{
  "a11y": {
    "activeBatches": "Lots actifs, {{count}} en attente",
    "activeBatchesButton": "Lots actifs",
    "addToFavorites": "Ajouter aux favoris",
    "addTag": "Ajouter une étiquette",
    "audioPlayer": "Lecteur audio",
    "backupCode": "Code de sauvegarde",
    "cancelAllDownloads": "Annuler tous les téléchargements",
    "clearAllNotifications": "Effacer toutes les notifications",
    "clearSelection": "Effacer la sélection",
    "clearUploadQueue": "Effacer la file d'attente de téléchargement",
    "copyLink": "Copier le lien",
    "closePanel": "Fermer le panneau",
    "composerFab": "Composer un nouvel e-mail",
    "detailsPanel": "Panneau de détails",
    "emailSending": "Envoi d'e-mail",
    "emptyFilesTable": "Aucun fichier à afficher",
    "editFileTags": "Modifier les étiquettes du fichier",
    "fileTagsCount": "Étiquettes, {{count}}",
    "enterFilePasswordForm": "Entrez le mot de passe du fichier",
    "expandUploadProgress": "Développer la progression du téléchargement",
    "fileTypesFilter": "Filtrer par type de fichier",
    "filters": "Filtres",
    "fullscreen": "Plein écran",
    "fileMoveForm": "Déplacer des fichiers",
    "filePublicLinkForm": "Paramètres du lien public",
    "filesTable": "Liste des fichiers",
    "globalSearch": "Rechercher des fichiers",
    "goBack": "Retourner",
    "groupForm": "Formulaire de groupe",
    "loading": "Chargement, veuillez patienter",
    "minimizeUploadProgress": "Réduire la progression du téléchargement",
    "mute": "Muet",
    "mainNavigation": "Navigation principale",
    "markAllRead": "Marquer toutes les notifications comme lues",
    "notificationsButton": "Notifications",
    "notificationsCount": "Notifications, {{count}} non lues",
    "notificationsList": "Liste des notifications",
    "openEmailsSection": "Ouvrir la section Emails",
    "openFileMenu": "Menu d'actions d'ouverture de fichier",
    "openFolder": "Ouvrir le dossier {{name}}",
    "openList": "Ouvrir {{name}}",
    "openMoreActions": "Ouvrir plus d'actions",
    "openFilesSection": "Section Ouvrir les fichiers",
    "otpCode": "Code de mot de passe à usage unique",
    "pendingGrants": "Demandes de subvention en attente, {{count}}",
    "pendingGrantsButton": "Demandes de subvention en attente",
    "playbackProgress": "Progression de la lecture, {{current}} sur {{duration}}",
    "playPause": "Lecture ou pause",
    "quickShare": "Téléchargement de partage rapide, {{percent}} pour cent",
    "removeFromFavorites": "Supprimer des favoris",
    "removeException": "Supprimer l'exception",
    "removeSharedFile": "Supprimer le fichier partagé",
    "searchExactMatch": "Rechercher une correspondance exacte",
    "searchWholeWord": "Rechercher un mot entier",
    "sectionSelector": "Sélecteur de sections",
    "selectCountry": "Sélectionnez {{country}}",
    "settingsSearch": "Paramètres de recherche",
    "skipToMain": "Passer au contenu principal",
    "tagActions": "Actions pour l'étiquette {{name}}",
    "tagNotSelected": "non sélectionné",
    "tagSelected": "sélectionné",
    "tagToggle": "{{name}}, {{state}}",
    "textEditor": "Éditeur de fichiers texte",
    "totpCode": "Code d'authentification",
    "unmute": "Activer le son",
    "activityMap": "Carte d'activité mondiale par pays",
    "cancelAllFailed": "Annuler tous les lots en échec",
    "copyBackupCodes": "Copier les codes de sauvegarde",
    "deleteSelected": "Supprimer la sélection",
    "downloadBackupCodes": "Télécharger les codes de sauvegarde",
    "downloadProgress": "Progression du téléchargement",
    "exitEditMode": "Quitter le mode édition",
    "expandDownloadProgress": "Développer la progression du téléchargement",
    "exportCsv": "Exporter au format CSV",
    "imageEditor": "Éditeur d'images",
    "markdownEditor": "Éditeur de démarques",
    "markdownHeading": "Style de titre",
    "markdownLinkActions": "Actions de lien",
    "markdownToolbar": "Barre d'outils de formatage",
    "minimizeDownloadProgress": "Minimiser la progression du téléchargement",
    "pdfViewer": "Visionneuse de documents PDF",
    "printDashboard": "Imprimer le tableau de bord",
    "refreshFolderStats": "Actualiser les statistiques du dossier",
    "refreshList": "Actualiser la liste",
    "removeFile": "Supprimer le fichier",
    "saveFile": "Enregistrer le fichier",
    "selectUser": "Sélectionnez {{name}}",
    "viewUploadErrors": "Afficher les erreurs de téléchargement",
    "uploadProgress": "Progression du téléchargement",
    "viewAsGrid": "Afficher sous forme de grille",
    "viewAsList": "Afficher sous forme de liste",
    "userForm": "Formulaire utilisateur",
    "userMenu": "Menu du compte utilisateur",
    "viewRiskIndicator": "{{name}}, voir les détails",
    "verifyingFile": "Vérification du fichier",
    "videoPlayer": "Lecteur vidéo",
    "volume": "Volume, {{percent}} pour cent",
    "messageInput": "Saisie des messages",
    "sendMessage": "Envoyer un message",
    "stopGenerating": "Arrêter de générer"
  },
  "antivirus": {
    "quarantine": {
      "title": "Quarantaine",
      "description": "Consultez les fichiers infectés, les échecs et les analyses ignorées ; libérez les faux positifs.",
      "empty": "Aucun fichier ne correspond à ce filtre",
      "rescan": "Relancer l'analyse",
      "release": "Libérer",
      "delete": "Supprimer",
      "rescanSuccess": "Nouvelle analyse mise en file d'attente",
      "releaseSuccess": "Fichier libéré de la quarantaine",
      "releaseModalTitle": "Libérer le fichier de la quarantaine",
      "releaseConfirmDescription": "Libérer « {{fileName}} » de la quarantaine ? Le fichier redeviendra disponible. Indiquez un motif pour le journal d'audit.",
      "releaseReasonLabel": "Motif",
      "releaseReasonPlaceholder": "Expliquez pourquoi le fichier doit être libéré",
      "releaseReasonRequired": "Un motif de libération est requis",
      "deleteConfirmTitle": "Supprimer le fichier en quarantaine ?",
      "deleteConfirmDescription": "Déplacer « {{fileName}} » vers la corbeille ? Utilise le chemin ordinaire de suppression de fichier.",
      "status": {
        "infected": "Infecté",
        "error": "Erreur",
        "skipped": "Ignoré",
        "toolarge": "Trop volumineux"
      },
      "columns": {
        "name": "Nom du fichier",
        "threat": "Menace",
        "engine": "Moteur",
        "ownerEmail": "E-mail du propriétaire",
        "scannedAt": "Analysé le",
        "actions": "Actions"
      },
      "errors": {
        "loadFailed": "Impossible de charger les fichiers en quarantaine",
        "rescanFailed": "Impossible de mettre en file la nouvelle analyse",
        "releaseFailed": "Impossible de libérer le fichier",
        "deleteFailed": "Impossible de supprimer le fichier",
        "invalidParams": "Filtre ou motif de libération invalide"
      }
    }
  },
  "account": {
    "title": "Compte",
    "description": "Gérez votre profil, vos préférences et votre sécurité.",
    "navAria": "Sections du compte",
    "profile": "Profil",
    "profileDescription": "Mettez à jour votre nom. L'e-mail ne peut pas être modifié ici.",
    "profileUnavailable": "Le profil n'est pas disponible.",
    "profileUpdated": "Profil mis à jour",
    "preferences": "Préférences",
    "preferencesDescription": "Options de langue, d’apparence et d’accessibilité.",
    "languageDescription": "Choisissez la langue de l'interface.",
    "appearanceDescription": "Choisissez clair, sombre ou suivez le système.",
    "accessibilityDescription": "Activez le contraste élevé et la réduction du mouvement.",
    "security": "Sécurité",
    "securityDescription": "Authentification à deux facteurs et mots de passe.",
    "twoFactorDescription": "Ajoutez ou gérez les codes d'application d'authentification.",
    "passkeysDescription": "Enregistrez et gérez les mots de passe pour ce compte.",
    "openTwoFactor": "Gérer 2FA",
    "openPasskeys": "Gérer les mots de passe",
    "sessions": "Séances",
    "sessionsDescription": "Gérez les sessions connectées et les sessions de déverrouillage de dossiers.",
    "activeSessionsDescription": "Examinez et révoquez les sessions de navigateur actives.",
    "folderSessionsDescription": "Gérez les sessions de déverrouillage par mot de passe pour les dossiers.",
    "openActiveSessions": "Gérer les sessions actives",
    "openFolderSessions": "Gérer les sessions de dossiers",
    "publicLinks": "Liens publics",
    "publicLinksDescription": "Affichez et révoquez les liens de partage publics que vous avez créés.",
    "publicLinksCtaDescription": "Ouvrez la liste de vos liens publics.",
    "openPublicLinks": "Gérer les liens publics"
  },
  "pageTitle": {
    "app": "Octroi de fichiers",
    "login": "Connexion",
    "logout": "Déconnexion",
    "settings": "Paramètres",
    "account": "Compte",
    "filesPersonal": "Fichiers",
    "filesReceived": "Reçu",
    "filesShared": "Partagé",
    "filesFavorites": "Favoris",
    "filesRecent": "Récents",
    "filesHidden": "Caché",
    "filesTrash": "Corbeille",
    "publicLink": "Lien public",
    "emails": "Emails",
    "emailsInbox": "Boîte de réception",
    "emailsSent": "Envoyé",
    "emailsDrafts": "Brouillons",
    "emailsFavorites": "Favoris par e-mail",
    "emailsArchive": "Archiver",
    "emailsTrash": "Corbeille d'e-mails",
    "users": "Utilisateurs",
    "groups": "Groupes",
    "dashboard": "Tableau de bord",
    "salesDashboard": "Tableau de bord des ventes",
    "activityLogs": "Journaux d'activité",
    "antivirusQuarantine": "Quarantaine",
    "viewer": "Visionneuse",
    "office": "Bureau",
    "quickShare": "Partage rapide",
    "store": "Magasin",
    "purchase": "Achat",
    "paymentSuccess": "Succès du paiement",
    "fileShareRequests": "Demandes de partage",
    "protectedFile": "Fichier protégé",
    "extensionAuthorize": "Autorisation de prolongation"
  },
  "activityLogOperationTypes": {
    "CreateFile": "Fichier créé",
    "CreateFolder": "Dossier créé",
    "CreateFileFailed": "La création du fichier a échoué",
    "CreateFolderFailed": "La création du dossier a échoué",
    "ReadFile": "Fichier consulté",
    "ReadFolder": "Dossier consulté",
    "DownloadFile": "Fichier téléchargé",
    "DownloadFileEncrypted": "Fichier crypté téléchargé",
    "DownloadFileZip": "Fichier téléchargé au format Zip",
    "SearchFiles": "Fichiers recherchés",
    "ReadFileFailed": "Échec de l'affichage du fichier",
    "ReadFolderFailed": "Échec de l'affichage des dossiers",
    "DownloadFileFailed": "Le téléchargement du fichier a échoué",
    "DownloadFileEncFailed": "Le téléchargement du fichier crypté a échoué",
    "DownloadFileZipFailed": "Le téléchargement du fichier Zip a échoué",
    "UpdateFile": "Fichier mis à jour",
    "RenameFile": "Fichier renommé",
    "MoveFile": "Fichier déplacé",
    "DuplicateFile": "Fichier dupliqué",
    "UploadFile": "Fichier téléchargé",
    "UpdateFileFailed": "Échec de la mise à jour du fichier",
    "RenameFileFailed": "Échec du changement de nom du fichier",
    "MoveFileFailed": "Échec du déplacement du fichier",
    "DuplicateFileFailed": "La duplication du fichier a échoué",
    "UploadFileFailed": "Échec du téléchargement du fichier",
    "DeleteFileToRecycleBin": "Fichier déplacé vers la corbeille",
    "DeleteFolderToRecycleBin": "Dossier déplacé vers la corbeille",
    "DeleteFileToRecycleBinFailed": "Échec du déplacement du fichier vers la corbeille",
    "DeleteFolderToRecycleBinFailed": "Échec du déplacement du dossier vers la corbeille",
    "DeleteFilePermanently": "Fichier définitivement supprimé",
    "DeleteFolderPermanently": "Dossier définitivement supprimé",
    "DeleteFilePermanentlyFailed": "La suppression définitive du fichier a échoué",
    "DeleteFolderPermanentlyFailed": "La suppression définitive du dossier a échoué",
    "ShareFile": "Fichier partagé",
    "ShareFolder": "Dossier partagé",
    "RevokeShare": "Partage révoqué",
    "ShareFileFailed": "Échec du partage de fichiers",
    "ShareFolderFailed": "Échec du partage de dossiers",
    "RevokeShareFailed": "Échec de la révocation du partage",
    "ViewAuditLog": "Journal d'audit consulté",
    "ExportAuditLog": "Journal d'audit exporté",
    "ViewAuditLogFailed": "Échec de l'affichage du journal d'audit",
    "ExportAuditLogFailed": "Échec de l'exportation du journal d'audit",
    "PurgeAuditLog": "Journal d'audit purgé (conservation)",
    "GrantAccess": "Accès accordé",
    "RevokeAccess": "Accès révoqué",
    "GrantAccessFailed": "Échec de l'octroi d'accès",
    "RevokeAccessFailed": "Échec de la révocation de l'accès",
    "CreateVersion": "Version créée",
    "RevertVersion": "Version inversée",
    "CreateVersionFailed": "La création de la version a échoué",
    "RevertVersionFailed": "Échec de la restauration de la version",
    "CommentFile": "Commentaire ajouté",
    "ReplyComment": "Commentaire répondu",
    "AssignTask": "Tâche assignée",
    "CommentFileFailed": "Le commentaire a échoué",
    "ReplyCommentFailed": "Échec de la réponse au commentaire",
    "AssignTaskFailed": "L'attribution de la tâche a échoué",
    "PreviewFile": "Fichier prévisualisé",
    "HiddenFile": "Fichier caché",
    "UnhiddenFile": "Fichier affiché",
    "AddToFavorites": "Ajouté aux favoris",
    "RemoveFromFavorites": "Supprimé des favoris",
    "PreviewFileFailed": "L'aperçu du fichier a échoué",
    "HiddenFileFailed": "Échec du masquage du fichier",
    "UnhiddenFileFailed": "Échec de l'affichage du fichier",
    "AddToFavoritesFailed": "Échec de l'ajout aux favoris",
    "RemoveFromFavoritesFailed": "Échec de la suppression des favoris",
    "CreateUser": "Utilisateur créé",
    "EditUser": "Utilisateur modifié",
    "RemoveUser": "Utilisateur supprimé",
    "CreateGroup": "Groupe créé",
    "EditGroup": "Groupe modifié",
    "RemoveGroup": "Groupe supprimé",
    "OnBehalfOfAccess": "Consulté au nom de l'utilisateur",
    "OnBehalfOfOperation": "Exploité pour le compte de l'utilisateur",
    "CreateUserFailed": "La création de l'utilisateur a échoué",
    "EditUserFailed": "Échec de la modification par l'utilisateur",
    "RemoveUserFailed": "Échec de la suppression de l'utilisateur",
    "CreateGroupFailed": "La création du groupe a échoué",
    "EditGroupFailed": "Échec de la modification du groupe",
    "RemoveGroupFailed": "Échec de la suppression du groupe",
    "OnBehalfOfAccessFailed": "L'accès au nom a échoué",
    "OnBehalfOfOperationFailed": "Échec de l'opération pour le compte",
    "LogIn": "Utilisateur connecté",
    "LogOut": "Utilisateur déconnecté",
    "OTPRequest": "OTP demandé",
    "LogInFailed": "La connexion a échoué",
    "LogOutFailed": "Échec de la déconnexion",
    "OTPRequestFailed": "La demande OTP a échoué",
    "AddTag": "Étiquette ajoutée",
    "RemoveTag": "Étiquette supprimée",
    "UpdateTag": "Étiquette mise à jour",
    "ListTags": "Étiquettes répertoriées",
    "AddTagFailed": "Échec de l'ajout de l'étiquette",
    "RemoveTagFailed": "Échec de la suppression de l'étiquette",
    "UpdateTagFailed": "Échec de la mise à jour des étiquettes",
    "ListTagsFailed": "Échec de la liste d'étiquettes",
    "RestoreFile": "Fichier restauré",
    "TagFile": "Étiquettes ajoutées au fichier",
    "RemoveTagFile": "Étiquettes supprimées du fichier",
    "EncryptFile": "Fichier crypté",
    "DecryptFile": "Fichier décrypté",
    "ChangeFileOwner": "Le propriétaire du fichier a changé",
    "SetFileExpiration": "Ensemble d'expiration de fichier",
    "GenerateShareLink": "Lien de partage généré",
    "ValidateUser": "Validé par l'utilisateur",
    "SignFile": "Fichier signé",
    "FileDescription": "Ensemble de description de fichier",
    "ShortCut": "Raccourci de fichier créé",
    "RestoreFileFailed": "La restauration du fichier a échoué",
    "TagFileFailed": "Échec du fichier de balisage",
    "RemoveTagFileFailed": "La suppression des étiquettes du fichier a échoué",
    "EncryptFileFailed": "Le cryptage du fichier a échoué",
    "DecryptFileFailed": "Le décryptage du fichier a échoué",
    "ChangeFileOwnerFailed": "Échec du changement de propriétaire du fichier",
    "SetFileExpirationFailed": "Échec de la définition de l'expiration",
    "GenerateShareLinkFailed": "Échec de la génération du lien de partage",
    "ValidateUserFailed": "La validation de l'utilisateur a échoué",
    "SignFileFailed": "La signature du fichier a échoué",
    "FileDescriptionFailed": "Échec de l'ensemble de description de fichier",
    "ShortCutFailed": "La création du raccourci vers le fichier a échoué",
    "ScreenCaptureAttempt": "Tentative de capture d'écran",
    "ClipboardCopyAttempt": "Tentative de copie du presse-papiers",
    "UnauthorizedAccessAttempt": "Tentative d'accès non autorisé",
    "ScreenCaptureAttemptFailed": "La tentative de capture d'écran a échoué",
    "ClipboardCopyAttemptFailed": "La tentative de copie du Presse-papiers a échoué",
    "UnauthorizedAccessAttemptFailed": "La tentative d'accès non autorisé a échoué",
    "MalwareDetection": "Logiciel malveillant détecté",
    "MalwareRemoval": "Logiciel malveillant supprimé",
    "SuspiciousActivityDetected": "Activité suspecte détectée",
    "IntrusionDetection": "Intrusion détectée",
    "IntrusionPrevention": "Intrusion évitée",
    "DataLeakageAttempt": "Tentative de fuite de données",
    "DataLeakageAttemptFailed": "La tentative de fuite de données a échoué",
    "PhishingAttemptDetected": "Tentative de phishing détectée",
    "RansomwareAttackDetected": "Attaque de ransomware détectée",
    "BruteForceAttackDetected": "Attaque par force brute détectée",
    "TwoFactorAuthEnabled": "Authentification à deux facteurs activée",
    "TwoFactorAuthDisabled": "Authentification à deux facteurs désactivée",
    "TwoFactorAuthAttemptFailed": "La tentative d'authentification à deux facteurs a échoué",
    "PasswordChange": "Mot de passe modifié",
    "PasswordChangeFailed": "Échec du changement de mot de passe",
    "SecuritySettingsUpdate": "Paramètres de sécurité mis à jour",
    "SecuritySettingsUpdateFailed": "La mise à jour des paramètres de sécurité a échoué",
    "FirewallRuleChange": "La règle du pare-feu a été modifiée",
    "FirewallRuleChangeFailed": "Échec de la modification de la règle du pare-feu",
    "EncryptionKeyManagement": "Clé de chiffrement gérée",
    "EncryptionKeyManagementFailed": "La gestion des clés de chiffrement a échoué",
    "AccessControlPolicyChange": "Politique de contrôle d'accès modifiée",
    "AccessControlPolicyChangeFailed": "Échec de la modification de la stratégie de contrôle d'accès",
    "SecurityPatchApplied": "Correctif de sécurité appliqué",
    "SecurityPatchAppliedFailed": "L'application du correctif de sécurité a échoué",
    "LastCheckToken": "Activité du dernier jeton de vérification",
    "UpdateSetting": "Mettre à jour le paramètre",
    "ViewGroupsList": "Liste des groupes consultée",
    "ViewUsersList": "Liste des utilisateurs consultée",
    "ViewTrash": "Corbeille consultée",
    "ViewArchivedFiles": "Fichiers cachés consultés",
    "ViewFavoriteFiles": "Fichiers favoris consultés",
    "ViewSharedFiles": "Fichiers partagés consultés",
    "ViewReceivedFiles": "Fichiers reçus consultés",
    "ViewSettings": "Paramètre consulté",
    "EmailSent": "E-mail envoyé",
    "EmailRead": "E-mail lu",
    "EmailSaveDraft": "Brouillon enregistré",
    "EmailUpdateDraft": "Brouillon mis à jour",
    "EmailTrash": "E-mail déplacé vers la corbeille",
    "EmailRestore": "E-mail restauré depuis la corbeille",
    "EmailDelete": "E-mail définitivement supprimé",
    "EmailArchive": "E-mail archivé",
    "EmailUnarchive": "E-mail non archivé",
    "EmailFavourite": "E-mail marqué comme favori",
    "EmailUnfavourite": "E-mail non marqué comme favori",
    "EmailAttachmentRemoved": "Pièce jointe supprimée de l'e-mail envoyé",
    "EmailRecipientRemoved": "Destinataire supprimé de l'e-mail envoyé",
    "EmailReplied": "Réponse par email envoyée",
    "EmailForwarded": "E-mail transféré",
    "CreateSetting": "Paramètre créé",
    "DeleteSetting": "Paramètre supprimé",
    "PaymentSessionCreated": "Session de paiement créée",
    "PaymentCompleted": "Paiement effectué",
    "SessionRevoked": "Session révoquée",
    "AllSessionsRevoked": "Toutes les sessions révoquées",
    "AdminSessionRevoked": "Session utilisateur révoquée par l'administrateur",
    "CreateCompany": "Société créée",
    "UpdateCompany": "Entreprise mise à jour",
    "BackOfficeCreateUser": "Utilisateur créé via le back office",
    "BackOfficeUpdateUser": "Utilisateur mis à jour via le back-office",
    "SystemMaintenance": "Entretien du système",
    "CreateCertificate": "Certificat créé",
    "CreateAccessRule": "Règle d'accès créée",
    "VersionRetention": "Conservation des versions appliquée",
    "CleanupDeletedVersions": "Versions supprimées nettoyées",
    "CreateIdentityProvider": "Fournisseur d'identité créé",
    "UpdateIdentityProvider": "Fournisseur d'identité mis à jour",
    "CreateAIAgent": "Agent IA créé",
    "UpdateAIAgent": "Agent IA mis à jour",
    "DeleteAIAgent": "Agent IA supprimé",
    "AIChatRequest": "Demande de chat IA",
    "AIChatWithDocument": "Chat IA avec document",
    "AIChatDeleteConversation": "Conversation de chat IA supprimée",
    "CancelBatch": "Lot annulé",
    "CancelFileJobs": "Travaux de fichiers annulés",
    "RetryFileJobs": "Tâches de fichiers réessayées",
    "InviteUsers": "Utilisateurs invités",
    "ViewExecutiveReport": "Rapport exécutif consulté",
    "CreatePublicLink": "Lien public créé",
    "RevokePublicLink": "Lien public révoqué",
    "PublicLinkAccess": "Lien public consulté",
    "PublicLinkDownload": "Téléchargement du lien public",
    "PublicLinkViewerAccess": "Accès au lecteur de liens publics",
    "PublicLinkAccessFailed": "L'accès au lien public a échoué",
    "IpRegionLoginBlocked": "Connexion bloquée par IP/région",
    "IpRegionFileOperationBlocked": "Opération de fichier bloquée par IP/région",
    "EntraIdSyncStarted": "La synchronisation de l'Entra ID a démarré",
    "EntraIdSyncCompleted": "Synchronisation Entra ID terminée",
    "EntraIdUserImported": "Utilisateur importé depuis Entra ID",
    "EntraIdGroupImported": "Groupe importé depuis Entra ID",
    "EntraIdSyncFailed": "La synchronisation de l'Entra ID a échoué",
    "SetFolderPassword": "Mot de passe du dossier défini",
    "RemoveFolderPassword": "Mot de passe du dossier supprimé",
    "FolderPasswordVerified": "Mot de passe du dossier vérifié",
    "FolderPasswordFailed": "La vérification du mot de passe du dossier a échoué",
    "FolderPasswordLockout": "Verrouillage du mot de passe du dossier",
    "FolderPasswordSessionRevoked": "Session de mot de passe du dossier révoquée",
    "FolderPasswordResetOtpRequested": "Réinitialisation du mot de passe du dossier OTP demandé",
    "FolderPasswordResetWithOtp": "Réinitialisation du mot de passe du dossier avec OTP",
    "FolderPasswordResetOtpFailed": "La réinitialisation du mot de passe du dossier OTP a échoué",
    "TotpExemptionGranted": "Dispense TOTP accordée",
    "TotpExemptionRevoked": "Exonération TOTP révoquée",
    "TotpExemptionExpired": "L'exemption TOTP a expiré",
    "TransferOwnership": "Propriété transférée",
    "TransferOwnershipFailed": "Le transfert de propriété a échoué",
    "UserLoginTokenCreated": "Jeton de connexion créé",
    "UserLoginTokenDeleted": "Jeton de connexion supprimé",
    "UserLoginTokenStatusChanged": "Le statut du jeton de connexion a été modifié",
    "UserLoginTokenUsed": "Connecté avec le jeton de connexion",
    "UserLoginTokenFailed": "L'authentification du jeton de connexion a échoué",
    "PasskeyRegistered": "Mot de passe enregistré",
    "PasskeyRemoved": "Clé d'accès supprimée",
    "PasskeyRemovedByAdmin": "Clé d'accès supprimée par l'administrateur",
    "PasskeyAuthenticationFailed": "L'authentification par mot de passe a échoué",
    "PasskeyPasswordlessLogin": "Connexion sans mot de passe par mot de passe",
    "PasskeyBlocked": "Mot de passe bloqué"
  },
  "activityLogTargetTypes": {
    "File": "Fichier",
    "Folder": "Dossier",
    "Files": "Fichiers",
    "FilesAndFolders": "Fichiers et dossiers",
    "FilesAndTags": "Fichiers et étiquettes",
    "FilesFoldersAndTags": "Fichiers, dossiers et étiquettes",
    "User": "Utilisateur",
    "Group": "Groupe",
    "Share": "Partager l'entrée",
    "ShareLink": "Partager le lien",
    "Version": "Version d'un fichier ou d'un document",
    "Comment": "Commenter un document ou un fichier",
    "Task": "Tâche assignée dans un environnement collaboratif",
    "Permission": "Autorisation",
    "AccessControl": "Entrées de contrôle d'accès",
    "Admin": "Opérations liées à l'administration",
    "Configuration": "Configuration du système",
    "Setting": "Cadre individuel",
    "Tag": "Étiquette ou étiquette",
    "Metadata": "Saisie de métadonnées",
    "Notification": "Entrée de notification",
    "Workflow": "Définition du workflow ou du processus",
    "Template": "Modèle de documents ou de fichiers",
    "AuditLog": "Journal d'audit",
    "Security": "Cibles liées à la sécurité",
    "Monitoring": "Cibles de surveillance et de journalisation",
    "Authentication": "Cibles liées à l'authentification",
    "TwoFactorAuth": "Cibles d'authentification à deux facteurs",
    "Session": "Session utilisateur ou jeton",
    "Encryption": "Cibles liées au chiffrement",
    "EncryptionKey": "Gestion des clés de chiffrement",
    "Payment": "Paiement ou transaction",
    "Company": "Entreprise ou locataire",
    "Certificate": "Certificat RSA pour l'accès en entreprise",
    "AccessRule": "Règle de contrôle d'accès",
    "IdentityProvider": "Fournisseur d'identité (par exemple Microsoft, Google)",
    "AIAgent": "Agent de classification IA",
    "AIChat": "Conversation de chat IA",
    "Batch": "Opération par lots",
    "Report": "Rapport exécutif ou autre",
    "Other": "Autres cibles génériques",
    "GroupsList": "Groupes",
    "UsersList": "Utilisateurs",
    "SpecialFolder": "Dossier spécial",
    "SettingsList": "Paramètres",
    "Email": "Courriel"
  },
  "realtime": {
    "connected": "Connecté",
    "connecting": "Connexion…",
    "disconnected": "Déconnecté",
    "reconnecting": "Reconnexion…"
  },
  "settings": {
    "settings": "Paramètres",
    "unavailable": "Les paramètres sont actuellement indisponibles",
    "retry": "Cliquez pour réessayer",
    "authentication": "Authentification",
    "saveCard": {
      "message": "Cliquez sur <strong>Save</strong> lorsque vous avez terminé les modifications."
    },
    "informations": "Informations",
    "preview": "Aperçu",
    "externalUserEnforcement": "Application par les utilisateurs externes",
    "externalUserEnforcementDescription": "Appliquez l’affichage en mode Anti-Capture pour tous les utilisateurs externes.",
    "tagBasedEncryption": "Chiffrement basé sur des étiquettes",
    "tagBasedEncryptionDescription": "Appliquez l'affichage en mode Anti-Capture pour les fichiers avec des étiquettes spécifiques.",
    "tagBasedEncryptionPlaceholder": "Étiquettes (séparées par des virgules), - par ex. « confidentiel, secret »",
    "companyBranding": {
      "title": "Image de marque de l'entreprise",
      "description": "Personnalisez l'apparence de la plateforme avec l'image de marque de votre entreprise. Cela inclut la définition du logo, des couleurs et d'autres éléments visuels qui seront affichés aux utilisateurs.",
      "companyName": "Nom de l'entreprise",
      "preferredLanguage": "Langue préférée",
      "companyLogos": "Logos d'entreprise",
      "companyLogosDescription": "La taille du fichier ne peut pas dépasser 1 Mo",
      "loginPageLogo": "Logo de la page de connexion",
      "loginPageLogoDescription": "Définissez le logo qui sera affiché sur la page de connexion pour les utilisateurs. Suggestions : Logo carré ou horizontal avec un fond transparent d'une largeur maximale de 200px.",
      "topBarLogo": "Logo de la barre supérieure",
      "topBarLogoDescription": "Définissez le logo qui sera affiché sur la barre supérieure de la plateforme. Suggestions : Logo carré ou horizontal avec fond transparent.",
      "emailNotificationLogo": "Logo de notification par courrier électronique",
      "emailNotificationLogoDescription": "Définissez le logo à utiliser dans les notifications par e-mail envoyées aux utilisateurs.",
      "quickShareBackground": "Arrière-plan de partage rapide",
      "quickShareBackgroundDescription": "Définissez l'image d'arrière-plan qui sera affichée sur la page de partage rapide. Taille suggérée : 1 200 x 1 920 pixels",
      "companyColors": "Couleurs de l'entreprise",
      "topBarColors": "Couleurs de la barre supérieure",
      "topBarColorsDescription": "Définissez la couleur de l'arrière-plan et du texte de la barre supérieure de la plateforme.",
      "mainButtonsColors": "Couleurs des boutons principaux",
      "mainButtonsColorsDescription": "Définissez la couleur d’arrière-plan et du texte du bouton principal.",
      "loginPageTitle": "Titre de la page de connexion",
      "loginPageSubtitle": "Sous-titre de la page de connexion",
      "loginTermsAndConditions": "Conditions générales de connexion",
      "loginPagePreview": "Aperçu de la page de connexion et de la barre supérieure",
      "mainButtonsPreview": "Aperçu des textes et des couleurs des boutons principaux",
      "emailNotificationsPreview": "Aperçu des notifications par e-mail",
      "quickSharePreview": "Aperçu de l'arrière-plan de partage rapide",
      "addLogo": "Ajouter un logo"
    },
    "emailCustomizations": {
      "title": "Personnalisations des e-mails",
      "description": "Personnalisez les modèles HTML utilisés pour les notifications par courrier électronique envoyées par la plateforme.",
      "language": "Langue",
      "noTemplates": "Aucun modèle d'e-mail disponible",
      "subject": "Sujet",
      "availablePlaceholders": "Espaces réservés disponibles (cliquez pour insérer)",
      "preview": "Aperçu",
      "customized": "Personnalisé",
      "default": "Par défaut",
      "resetToDefault": "Réinitialiser aux valeurs par défaut",
      "resetTitle": "Réinitialiser le modèle",
      "resetConfirm": "Réinitialiser",
      "resetConfirmDescription": "Cela supprimera vos personnalisations et reviendra au modèle par défaut. Cette action ne peut pas être annulée.",
      "resetSuccess": "Modèle réinitialisé par défaut",
      "resetError": "Échec de la réinitialisation du modèle",
      "saveSuccess": "Modèle enregistré avec succès",
      "saveError": "Échec de l'enregistrement du modèle",
      "sendTest": "Envoyer un e-mail de test",
      "testSuccess": "E-mail de test envoyé",
      "testError": "Échec de l'envoi de l'e-mail de test"
    },
    "downloadRestrictions": {
      "title": "Télécharger l'application du cryptage",
      "description": "Contrôlez les paramètres des restrictions de téléchargement pour tous les membres. Cela inclut l'application du cryptage des téléchargements, l'application de règles spécifiques pour les utilisateurs externes et le remplacement de ces paramètres en fonction des étiquettes de fichiers.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Appliquez le cryptage des téléchargements aux membres qui disposent déjà d’autorisations de téléchargement, soit parce qu’ils sont propriétaires, soit parce qu’ils disposent d’autorisations de modification. S’ils ne sont pas activés, les téléchargements fonctionneront normalement le cas échéant.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Précisez les membres qui font exception aux restrictions ci-dessus.",
      "externalUserEnforcementTitle": "Application par les utilisateurs externes",
      "externalUserEnforcementDescription": "Appliquer le cryptage des téléchargements pour tous les utilisateurs externes",
      "tagBasedEncryptionTitle": "Chiffrement basé sur des étiquettes",
      "tagBasedEncryptionDescription": "Forcer le téléchargement crypté avec des étiquettes spécifiques",
      "tagBasedEncryptionPlaceholder": "Étiquettes (séparées par des virgules), - par ex. « confidentiel, secret »",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles"
    },
    "downloadAllowedTags": {
      "title": "Télécharger les étiquettes autorisées",
      "description": "Permet aux membres de télécharger des documents partagés avec des autorisations en lecture seule.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur. Ce paramètre peut définir la portée des autorisations, les conditions dans lesquelles elles s'appliquent et les exceptions autorisées.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Précisez les membres qui font exception aux restrictions ci-dessus.",
      "externalUserEnforcementTitle": "Application par les utilisateurs externes",
      "externalUserEnforcementDescription": "Appliquer le cryptage des téléchargements pour tous les utilisateurs externes",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Activez le téléchargement des fichiers en lecture seule uniquement pour les fichiers comportant ces étiquettes.",
      "tagsPlaceholder": "Étiquettes (séparées par des virgules), - par ex. « confidentiel, secret »",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles"
    },
    "forcedAntiCaptureMode": {
      "title": "Mode anti-capture forcé",
      "description": "Appliquez l'affichage des fichiers partagés avec des étiquettes spécifiques uniquement en mode Anti-Capture.",
      "forcedAntiCaptureModeTitle": "Application de la loi anti-capture",
      "forcedAntiCaptureModeDescription": "Sélectionnez si vous souhaitez appliquer l'anti-capture à tout ou à aucun. L'activation de l'anti-capture activera également les téléchargements de fichiers sécurisés.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Précisez les membres qui font exception aux restrictions ci-dessus.",
      "tagBasedEncryptionTitle": "Chiffrement basé sur des étiquettes",
      "tagBasedEncryptionDescription": "Appliquer cette règle uniquement aux fichiers avec des étiquettes spécifiques"
    },
    "aiTagging": {
      "title": "Marquage IA",
      "description": "Activez le balisage IA pour les fichiers. Cela marquera automatiquement les fichiers en fonction de leur contenu.",
      "descriptionInternal": "Activez le balisage IA pour les fichiers. Cela marquera automatiquement les fichiers en fonction de leur contenu. <DangerText>Remarque : cela s'applique uniquement aux fichiers inférieurs à 250 Mo. Les modifications apportées à ces paramètres ne sont PAS appliquées de manière rétroactive, ce qui signifie que les fichiers avec des étiquettes existantes ne seront pas automatiquement classés.</DangerText>",
      "isRuleEnabledTitle": "Activer la règle de marquage AI",
      "isRuleEnabledDescription": "Permettez aux utilisateurs (administrateurs et contributeurs) de laisser l'IA marquer leurs fichiers en fonction de leur contenu.",
      "isAutomaticClassificationEnabledTitle": "Activer la classification automatique",
      "isAutomaticClassificationEnabledDescription": "Activez la classification automatique des fichiers en fonction de leur contenu.",
      "ruleTargetTitle": "Cible de la règle",
      "ruleTargetDescription": "Sélectionnez la cible de la règle.",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Appliquer cette règle uniquement aux fichiers avec des étiquettes spécifiques",
      "aiAgentTitle": "Agent IA",
      "aiAgentDescription": "Sélectionnez l'agent AI à utiliser pour le balisage des fichiers.",
      "aiAgentPlaceholder": "Sélectionnez un agent IA",
      "membersTitle": "Qui peut classer avec l'agent sélectionné",
      "membersDescription": "Choisissez à quels membres s'applique l'agent sélectionné.",
      "exceptionsTitle": "Gérer les exceptions",
      "exceptionsDescription": "Ajoutez des utilisateurs pour lesquels vous ne souhaitez pas de classification automatique",
      "exceptionsButtonText": "Gérer les utilisateurs",
      "filesTypeTitle": "Gestion des extensions de fichiers",
      "filesTypeDescription": "Spécifiez les extensions de fichiers à classer par l'agent.",
      "externalUserTitle": "Utilisateur externe",
      "externalUserDescription": "Autoriser la classification par des utilisateurs externes.",
      "filesTypePlaceholder": "Veuillez en sélectionner un ou plusieurs",
      "folderIdsTitle": "Dossiers à classer",
      "folderIdsDescription": "Sélectionnez les dossiers à classer par l'agent sélectionné."
    },
    "singleSignOn": {
      "title": "Authentification unique (SSO)",
      "enableTitle": "Activer l'authentification unique",
      "description": "Activez l'authentification unique (SSO) pour votre organisation. Cela permettra à vos utilisateurs de se connecter à Filegrant Enterprise en utilisant leurs informations d'identification existantes auprès d'un fournisseur d'identité pris en charge.",
      "providers": "Fournisseurs",
      "providersDescription": "Sélectionnez les fournisseurs que vous souhaitez activer pour l'authentification unique (SSO).",
      "google": "Google",
      "microsoft": "Microsoft",
      "cybergrant": "CyberGrant",
      "notificationSsoEnableMessage": "La fonctionnalité d'authentification unique (SSO) est en cours d'activation. Ce processus peut prendre quelques minutes. Veuillez rester sur cette page jusqu'à ce que le processus soit terminé.",
      "notificationSsoEnabledMessage": "La fonctionnalité d'authentification unique (SSO) a été activée avec succès.",
      "copyRedirectUriHint": "Copiez-le et ajoutez la configuration de votre IdP.",
      "redirectUri": "URI de redirection",
      "copyRedirectUriDesc": "Copiez-le et ajoutez la configuration de votre IdP.",
      "notificationSsoEnableTimeout": "Erreur lors de l'activation de SSO",
      "notificationSsoEnableTimeoutDesc": "Il n'a pas été possible d'activer la fonctionnalité Single Sign-On (SSO). Veuillez réessayer.",
      "domainAlreadySet": "Ce domaine est déjà défini",
      "mobileRedirectUri": "URI de redirection mobile",
      "mobileRedirectUriHint": "Ajoutez cet URI de redirection uniquement si vous souhaitez activer le SSO sur l'application mobile.",
      "clientCertificate": "Certificat client",
      "certificateInUse": "Certificat en cours d'utilisation",
      "certificateThumbprint": "Empreinte",
      "certificateExpiresAt": "Expire le",
      "certificateExpired": "Ce certificat a expiré le {{date}}. La connexion SSO et la sync Entra ID échoueront jusqu'à son remplacement.",
      "certificateExpiringSoon": "Ce certificat expire le {{date}} (dans {{days}} jours).",
      "certificateTooLarge": "Le fichier certificat est trop volumineux. Utilisez un PKCS#12 (.pfx/.p12) sous la limite de taille.",
      "certificateReadyToUpload": "Nouveau certificat sélectionné. Saisissez son mot de passe (laissez vide s'il n'y en a pas) et enregistrez.",
      "uploadCertificate": "Téléverser le certificat",
      "replaceCertificate": "Remplacer le certificat",
      "clearCertificate": "Supprimer le certificat",
      "certificatePassword": "Mot de passe du certificat",
      "certificatePasswordHint": "Saisissez le mot de passe PKCS#12 à chaque nouvel envoi ; le mot de passe stocké n'est jamais réutilisé. Laissez vide si le fichier n'a pas de mot de passe.",
      "certificatePasswordPlaceholder": "Mot de passe PKCS#12 (facultatif)",
      "noCredentialsWarning": "Aucun secret client ni certificat configuré. Ajoutez au moins une information d'identification avant d'activer ce fournisseur.",
      "clientIdChangeWarning": "Client ID modifié. Envoyez un nouveau secret client et/ou téléversez à nouveau le certificat, sinon les informations masquées seront effacées.",
      "clientIdChangeBlocksSave": "Impossible d'enregistrer : Client ID modifié tout en conservant des informations masquées",
      "clientIdChangeBlocksSaveHint": "Configuration Microsoft {{index}} : saisissez un nouveau secret client et/ou téléversez un certificat avant d'enregistrer.",
      "certificateProblemEntry": "{{provider}} — configuration {{index}} : {{message}}",
      "errors": {
        "certificateInvalid": "Le certificat client n'a pas pu être accepté",
        "certificateNotSupported": "Les certificats ne sont pas pris en charge pour ce fournisseur",
        "invalidConfiguration": "Configuration Single Sign-On invalide"
      }
    },
    "fileDeletionRestriction": {
      "title": "Restriction de suppression de fichiers",
      "description": "Activez un contrôle granulaire sur la suppression de fichiers par les utilisateurs. Ce paramètre vous permet de définir des autorisations de suppression en fonction du rôle de l'utilisateur par rapport au fichier : créateur, propriétaire ou destinataire. Cela garantit des règles de gestion de contenu claires et sécurisées, empêchant les suppressions non autorisées et garantissant le respect des politiques organisationnelles.",
      "allowDeletionFor": "Autoriser la suppression pour",
      "allowDeletionForDescription": "Choisissez si tous ou aucun des utilisateurs sont autorisés à supprimer des fichiers.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Précisez les membres qui font exception aux restrictions ci-dessus.",
      "fileAccessTypeTitle": "Types d'accès autorisés",
      "fileAccessTypeDescription": "Sélectionnez les types d'accès aux fichiers/dossiers autorisés à supprimer le fichier.",
      "owner": "Propriétaire",
      "creator": "Créateur",
      "receiver": "Récepteur"
    },
    "adminRegisteredMemberVisibility": {
      "title": "Visibilité des membres enregistrés par l'administrateur",
      "description": "Contrôlez la visibilité des membres ou des groupes enregistrés par les administrateurs auprès des utilisateurs. Les options incluent l'autorisation à tous les utilisateurs de voir les utilisateurs enregistrés comme administrateurs ou aucun. La visibilité passe principalement par le partage de fichiers. Lorsqu'un utilisateur partage un fichier avec une adresse e-mail correspondant à un membre enregistré comme administrateur, l'utilisateur verra le nom et le prénom du membre après le partage, même s'il n'est pas autorisé à afficher les utilisateurs enregistrés comme administrateur selon ce paramètre. Cette limitation ne s'applique pas aux utilisateurs ou aux groupes auxquels le statut Privé a été attribué.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Précisez les membres qui font exception aux restrictions ci-dessus.",
      "sectionTitle": "Limites de visibilité des utilisateurs",
      "visibilityTitle": "Visibilité des membres enregistrés par l'administrateur",
      "visibilityDescription": "Contrôlez la visibilité des membres ou des groupes enregistrés par les administrateurs auprès des utilisateurs. Les options incluent l'autorisation à tous les utilisateurs de voir les utilisateurs enregistrés comme administrateurs ou aucun. La visibilité passe principalement par le partage de fichiers. Lorsqu'un utilisateur partage un fichier avec une adresse e-mail correspondant à un membre enregistré comme administrateur, l'utilisateur verra le nom et le prénom du membre après le partage, même s'il n'est pas autorisé à afficher les utilisateurs enregistrés comme administrateur selon ce paramètre. Cette limitation ne s'applique pas aux utilisateurs ou aux groupes auxquels le statut Privé a été attribué."
    },
    "aiFileSummary": {
      "title": "Résumé du fichier AI",
      "description": "Activez le résumé des fichiers AI pour les fichiers. Cela générera automatiquement un résumé du fichier en fonction de son contenu.",
      "descriptionInternal": "Activez le résumé des fichiers AI pour les fichiers. Cela générera automatiquement un résumé du fichier en fonction de son contenu. <DangerText>Remarque : cela s'applique uniquement aux fichiers de taille inférieure à 250 Mo.</DangerText>",
      "activeForAllTitle": "Accès au résumé des fichiers AI",
      "activeForAllDescription": "Choisissez si les résumés de fichiers générés par l'IA sont disponibles pour tous les utilisateurs ou pour aucun.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Précisez les membres qui font exception aux restrictions ci-dessus.",
      "externalUserTitle": "Utilisateur externe",
      "externalUserDescription": "Autoriser la génération de résumés par des utilisateurs externes.",
      "filesTypeTitle": "Gestion des extensions de fichiers",
      "filesTypeDescription": "Spécifiez les extensions de fichiers à résumer par l'IA.",
      "filesTypePlaceholder": "Veuillez en sélectionner un ou plusieurs"
    },
    "aiFileChat": {
      "title": "Chat de fichiers IA",
      "description": "Activez le chat de fichiers AI pour les fichiers. Cela permettra aux utilisateurs de discuter avec le contenu du fichier.",
      "descriptionInternal": "Activez le chat de fichiers AI pour les fichiers. Cela permettra aux utilisateurs de discuter avec le contenu du fichier. <DangerText>Remarque : cela s'applique uniquement aux fichiers de taille inférieure à 250 Mo.</DangerText>",
      "activeForAllTitle": "Accès au chat de fichiers AI",
      "activeForAllDescription": "Choisissez si les discussions de fichiers générées par l'IA sont disponibles pour tous les utilisateurs ou pour aucun.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Précisez les membres qui font exception aux restrictions ci-dessus.",
      "externalUserTitle": "Utilisateur externe",
      "externalUserDescription": "Autoriser la discussion avec le contenu du fichier par des utilisateurs externes.",
      "filesTypeTitle": "Gestion des extensions de fichiers",
      "filesTypeDescription": "Spécifiez les extensions de fichiers à discuter avec l'IA.",
      "filesTypePlaceholder": "Veuillez en sélectionner un ou plusieurs"
    },
    "aiScraping": {
      "title": "Grattage de l'IA",
      "description": "Refuser le scraping des fichiers par l'IA. Cela empêchera tout outil d’IA de récupérer le contenu du fichier.",
      "descriptionInternal": "Refuser le scraping des fichiers par l'IA. Cela empêchera tout outil d’IA de récupérer le contenu du fichier. <DangerText>Remarque : le scraping AI est appliqué uniquement aux fichiers ouverts en mode lecture seule et d'une taille inférieure à 250 Mo. La protection contre le grattage n'est actuellement active que sur les fichiers PDF et Office.</DangerText>",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur. Ce paramètre peut définir la portée des autorisations, les conditions dans lesquelles elles s'appliquent et les exceptions autorisées.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Précisez les membres qui font exception aux restrictions ci-dessus.",
      "externalUserTitle": "Utilisateur externe",
      "externalUserDescription": "Autoriser la suppression du contenu du fichier par des utilisateurs externes.",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Appliquer ces règles uniquement aux fichiers avec des étiquettes spécifiques",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes"
    },
    "onBehalfMode": {
      "title": "Mode Au nom",
      "description": "Contrôlez le mode pour le compte de la plateforme. Cela vous permettra de préciser quels contributeurs peuvent effectuer des actions au nom d'autres contributeurs.",
      "internalTitle": "Actions d'administration au nom des utilisateurs",
      "internalDescription": "Les administrateurs autorisés peuvent consulter la liste des fichiers des contributeurs et effectuer les actions nécessaires telles que déplacer, supprimer ou partager des fichiers au nom des utilisateurs. Cependant, ils ne peuvent pas ouvrir ou afficher le contenu des fichiers, préservant ainsi la confidentialité des utilisateurs. Seul le super-administrateur a le pouvoir d'activer ou de désactiver cette fonctionnalité pour des administrateurs individuels. Cela garantit que seuls les administrateurs de confiance ont la possibilité de gérer les fichiers utilisateur.",
      "activeForAllTitle": "Portée des administrateurs",
      "activeForAllDescription": "Contrôlez la possibilité de définir si les administrateurs peuvent effectuer des actions au nom de tous les utilisateurs ou aucun. Ce paramètre vous permet de spécifier si les administrateurs ont l'autorisation de gérer des fichiers et d'effectuer des tâches au nom d'autres utilisateurs de la plateforme.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Les administrateurs sélectionnés ici feront exception aux autorisations « au nom » ci-dessus."
    },
    "fileSalesPermission": {
      "title": "Autorisation de vente de fichiers",
      "description": "Permettez aux utilisateurs de vendre leurs propres fichiers via la plateforme.",
      "internalTitle": "Activer la vente de fichiers pour les membres",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Permettez aux membres de vendre leurs propres fichiers via la plateforme. Les options incluent l’activation de cette fonctionnalité pour tous les membres ou aucun. Les fichiers mis en vente seront gérés par la plateforme, garantissant des transactions sécurisées et un traitement correct des paiements.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus.",
      "externalUserTitle": "Utilisateur externe",
      "externalUserDescription": "Autoriser la vente de fichiers par des utilisateurs externes."
    },
    "resharingPermission": {
      "title": "Autorisation de repartage de fichiers",
      "description": "Permettez aux utilisateurs de repartager des fichiers avec d’autres, tout en appliquant des règles basées sur des options prédéfinies et des étiquettes appliquées à chaque fichier. Cela garantit une distribution contrôlée du contenu et contribue à maintenir la conformité aux politiques de l’organisation.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis à des restrictions sur le partage de fichiers avec des options et des étiquettes spécifiques définies par l'administrateur. Les options incluent l'application de cette autorisation à tous les utilisateurs ou à aucun. Les fichiers existants déjà partagés resteront actifs et les modifications apportées aux étiquettes n'affecteront pas ces fichiers précédemment partagés.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Spécifiez les utilisateurs qui font exception à la règle ci-dessus.",
      "showUsers": "Afficher les utilisateurs qui ont déjà obtenu l'accès par d'autres.",
      "allowEdit": "Permet aux utilisateurs de modifier, remplacer ou supprimer les paramètres de partage existants.",
      "readOnly": "Activez le partage de fichiers par les utilisateurs disposant d'un accès en lecture seule (Viewer).",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Appliquer ces règles uniquement aux fichiers avec des étiquettes spécifiques",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes"
    },
    "fileVersioningRetentionPolicies": {
      "title": "Versionnement des fichiers",
      "description": "Configurez la manière dont les versions de fichiers sont conservées. Le nombre de rétention est requis, tandis que l'âge de rétention est facultatif et peut être défini sur 0.",
      "retentionByCountTitle": "Rétention par nombre",
      "retentionByCountDescription": "Définir la conservation par nombre – conserver uniquement les N dernières versions de chaque fichier ; les anciennes versions sont automatiquement purgées une fois cette limite atteinte",
      "retentionByAgeTitle": "Rétention par âge",
      "retentionByAgeDescription": "Définir la conservation par âge : supprimer les versions antérieures à N jours ; tout instantané dépassant cet âge sera automatiquement purgé pour éviter une surcharge de stockage"
    },
    "retentionPolicies": {
      "title": "Politiques de rétention",
      "description": "Configurez la durée pendant laquelle les fichiers sont conservés sur la plateforme. Gérez la suppression automatique de la corbeille et définissez des règles de conservation pour les fichiers actifs.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "trash": {
        "title": "Rétention des déchets",
        "description": "Les fichiers déplacés vers la corbeille sont supprimés définitivement après le nombre de jours configuré.",
        "activeForAllTitle": "Portée de rétention des déchets",
        "activeForAllDescription": "Choisissez si la rétention de la corbeille s'applique à tous les utilisateurs ou à aucun. Les valeurs de stratégie ci-dessous restent modifiables ; utilisez la liste d’exceptions pour exclure des utilisateurs ou des groupes spécifiques.",
        "retentionDaysTitle": "Jours à la poubelle",
        "retentionDaysDescription": "Jours pendant lesquels un fichier reste dans la corbeille avant sa suppression définitive. Doit être supérieur à 0.",
        "exceptionHandlingDescription": "Les utilisateurs et les groupes de cette liste ne sont pas soumis à la rétention des déchets ; leurs fichiers restent indéfiniment dans la corbeille."
      },
      "files": {
        "title": "Conservation des fichiers",
        "description": "Appliquez une règle de conservation aux fichiers actifs. La durée de conservation court à compter de la date que vous choisissez ci-dessous (création ou dernière modification).",
        "activeForAllTitle": "Portée de conservation des fichiers",
        "activeForAllDescription": "Choisissez si la conservation des fichiers s'applique à tous les utilisateurs ou à aucun. Les valeurs de stratégie ci-dessous restent modifiables ; utilisez la liste d’exceptions pour exclure des utilisateurs ou des groupes spécifiques.",
        "retentionDaysTitle": "Période de conservation (jours)",
        "retentionDaysDescription": "Nombre de jours après la date de référence sélectionnée (création ou modification) au-delà duquel l'action est déclenchée. Doit être supérieur à 0.",
        "retentionTriggerTitle": "Compter la rétention à partir de",
        "retentionTriggerDescription": "Choisissez si la période de conservation est calculée à partir de la création du fichier ou de sa dernière modification.",
        "retentionTrigger": {
          "created_at": "Date de création du fichier",
          "updated_at": "Date de dernière modification"
        },
        "actionOnExpiryTitle": "Action à l'expiration",
        "actionOnExpiryDescription": "Qu'arrive-t-il aux fichiers qui dépassent la période de conservation.",
        "actionOnExpiry": {
          "MoveToTrash": "Déplacer vers la corbeille",
          "DeletePermanently": "Supprimer définitivement",
          "RetainedTagWorkflow": "Appliquer l'étiquette *RETAINED, puis supprimer"
        },
        "retainedTag": {
          "title": "Comment fonctionne l'étiquette *RETAINED",
          "step1": "Lorsque vous enregistrez cette stratégie, le serveur crée une étiquette système nommée *RETAINED (visible dans la liste des étiquettes de l'entreprise, mais en lecture seule).",
          "step2": "Après la période de conservation ci-dessus, l'étiquette *RETAINED est automatiquement appliquée à chaque fichier créé il y a plus de plusieurs jours.",
          "step3": "Une fois balisé, le fichier reste accessible mais l'étiquette ne peut être supprimée par personne : l'interface utilisateur masque le contrôle de détachement et le serveur rejette toute tentative de suppression d'une étiquette système.",
          "step4": "Lorsque les jours fixés ci-dessous s'écoulent depuis l'application de l'étiquette, le fichier est définitivement supprimé (DB + stockage). Ajoutez des utilisateurs ou des groupes aux exceptions pour les exclure de l'ensemble du flux."
        },
        "retainedTagDaysTitle": "Jours avec étiquette *RETAINED",
        "retainedTagDaysDescription": "Une fois l'étiquette *RETAINED appliquée, les fichiers sont définitivement supprimés après ce nombre de jours. Doit être supérieur à 0.",
        "tagsTitle": "Appliquer uniquement aux fichiers avec ces étiquettes",
        "tagsDescription": "Laissez vide pour appliquer la stratégie à tous les fichiers. Seules les étiquettes publiques sont prises en charge.",
        "exceptionHandlingDescription": "Les utilisateurs et les groupes de cette liste ne sont pas soumis à la conservation des fichiers ; leurs fichiers ne sont jamais déplacés vers la corbeille, supprimés ou étiquetés comme *RETAINED."
      },
      "deletePermanentlyConfirm": {
        "title": "Confirmer la politique de suppression permanente",
        "description": "<DangerText>Cette action supprimera PERMANENTEMENT tous les fichiers de l'entreprise qui dépassent la période de conservation. Cette opération n'est pas réversible.</DangerText>"
      },
      "deletePermanentlySelectWarning": {
        "title": "Confirmer la suppression définitive",
        "description": "Lorsque cette action est sélectionnée, les fichiers qui dépassent la période de conservation seront supprimés définitivement. <DangerText>Cela ne peut pas être annulé et les fichiers supprimés ne peuvent pas être récupérés. </DangerText><br></br>Pour continuer, tapez <DangerText>{{confirmKeyword}}</DangerText> dans le champ ci-dessous."
      },
      "errors": {
        "trashRetentionDays": "Les jours passés dans la poubelle doivent être supérieurs à 0.",
        "retentionDays": "La période de conservation doit être supérieure à 0.",
        "retainedTagDays": "Les jours avec l'étiquette *RETAINED doivent être supérieurs à 0."
      }
    },
    "mandatoryExpirationSharedFile": {
      "title": "Fichier partagé à expiration obligatoire",
      "description": "Contrôlez l’expiration obligatoire des fichiers partagés. Cela vous permettra de préciser quels fichiers partagés doivent avoir une date d'expiration.",
      "descriptionInternal": "Cette section impose des limites de temps sur le partage de fichiers pour empêcher un accès indéfini. Les administrateurs peuvent exiger une date d'expiration pour chaque fichier partagé, définir une durée maximale autorisée et bloquer les partages sans date d'expiration. Ces règles garantissent que l'accès partagé est temporaire et conforme aux exigences de sécurité et de conformité. <DangerText> Les modifications apportées à ces paramètres ne sont PAS appliquées rétroactivement, ce qui signifie que les partages existants qui dépassent les nouvelles limites ne seront PAS mis à jour.</DangerText>",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur. Ce paramètre peut définir la portée des autorisations, les conditions dans lesquelles elles s'appliquent et les exceptions autorisées. Il garantit que l'activité des utilisateurs reste alignée sur les politiques de l'organisation tout en permettant une flexibilité le cas échéant.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Précisez les membres qui font exception aux restrictions ci-dessus.",
      "maxAllowedByAgeTitle": "Durée maximale autorisée",
      "maxAllowedByAgeDescription": "Définit une limite de durée maximale (par exemple, 90 jours) pour tout partage de fichiers.",
      "excludedDomainsTitle": "Domaines exclus",
      "excludedDomainsDescription": "Les partages vers ces domaines exacts ne nécessitent pas de date d'expiration. Saisissez uniquement des domaines (ex. company.com), sans jokers ni URL. Laissez vide pour aucune exemption.",
      "excludedDomainsPlaceholder": "Aucun domaine exclu, cliquez pour ajouter",
      "excludedGroupsTitle": "Groupes exclus",
      "excludedGroupsDescription": "Les partages vers des groupes peuvent être exemptés de l'expiration obligatoire. Choisissez aucun, tous les groupes ou des groupes spécifiques. L'appartenance d'un utilisateur à un groupe exempt ne dispense pas les partages utilisateur.",
      "excludedGroupsModeNone": "Aucun groupe exempt",
      "excludedGroupsModeAll": "Tous les groupes exempts",
      "excludedGroupsModeSome": "Seuls les groupes sélectionnés sont exempts",
      "excludedGroupsPlaceholder": "Sélectionnez les groupes exempts",
      "excludedGroupsExceptionsTitle": "Groupes qui restent soumis",
      "excludedGroupsExceptionsPlaceholder": "Sélectionnez les groupes qui nécessitent encore une expiration",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Applique la limite de temps de partage maximale uniquement aux fichiers avec certaines étiquettes.",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes"
    },
    "fileTagManagement": {
      "title": "Règles de suppression des étiquettes",
      "description": "Définissez les étiquettes qui ne peuvent pas être supprimées des fichiers. Les utilisateurs ciblés par une règle ne peuvent pas supprimer les étiquettes sélectionnées des fichiers ; des exceptions à la règle peuvent être accordées par utilisateur ou groupe.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis à des restrictions sur la suppression des étiquettes telles que définies par l'administrateur. Les étiquettes existantes sur les fichiers resteront inchangées et les mises à jour des autorisations n'affecteront pas les étiquettes précédemment appliquées.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Spécifiez les utilisateurs qui font exception à la règle ci-dessus.",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Étiquettes qui ne peuvent pas être supprimées des fichiers. Laissez vide pour protéger toutes les étiquettes.",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles"
    },
    "fileTagAdditionRestriction": {
      "title": "Règles d'ajout d'étiquettes",
      "description": "Définissez les étiquettes qui ne peuvent pas être ajoutées aux fichiers. Les utilisateurs ciblés par une règle ne peuvent pas ajouter les étiquettes sélectionnées aux fichiers ; des exceptions à la règle peuvent être accordées par utilisateur ou groupe.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Spécifiez les utilisateurs qui font exception à la règle ci-dessus.",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Étiquettes qui ne peuvent pas être ajoutées aux fichiers. Laissez vide pour restreindre toutes les étiquettes.",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles"
    },
    "externalFileSharingRestriction": {
      "title": "Restrictions de partage externe",
      "description": "Cette section permet aux administrateurs de décider si les contributeurs peuvent partager des fichiers en dehors de l'organisation et dans quelles conditions. Le partage peut être entièrement activé, désactivé ou limité à des domaines de confiance spécifiques. Les règles peuvent également restreindre le partage externe en fonction des étiquettes de fichiers ou permettre à certains expéditeurs et destinataires de contourner les politiques de prévention contre la perte de données (DLP). Ces contrôles permettent de sécuriser les informations confidentielles et de garantir que les collaborations externes n'ont lieu qu'avec des parties approuvées.",
      "descriptionInternal": "Cette section permet aux administrateurs de décider si les contributeurs peuvent partager des fichiers en dehors de l'organisation et dans quelles conditions. Le partage peut être entièrement activé, désactivé ou limité à des domaines de confiance spécifiques. Les règles peuvent également restreindre le partage externe en fonction des étiquettes de fichiers ou permettre à certains expéditeurs et destinataires de contourner les politiques de prévention contre la perte de données (DLP). Ces contrôles permettent de sécuriser les informations confidentielles et de garantir que les collaborations externes n'ont lieu qu'avec des parties approuvées.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur. Ce paramètre peut définir la portée des autorisations, les conditions dans lesquelles elles s'appliquent et les exceptions autorisées. Il garantit que l'activité des utilisateurs reste alignée sur les politiques de l'organisation tout en permettant une flexibilité le cas échéant.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Précisez les membres qui font exception à la règle ci-dessus.",
      "approvedDomainsTitle": "Domaines approuvés uniquement",
      "approvedDomainsDescription": "Limite le partage à une liste de domaines pré-approuvés.",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Autorise le partage avec des domaines externes uniquement pour les fichiers comportant des étiquettes spécifiques.",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes",
      "approvedDomainsPlaceholder": "Aucun domaine approuvé, cliquez pour ajouter"
    },
    "secureFileLocalAccess": {
      "title": "Accès local aux fichiers sécurisé",
      "description": "Contrôlez l’accès local sécurisé aux fichiers. Cela vous permettra de spécifier quels fichiers sont accessibles localement.",
      "descriptionInternal": "Ce paramètre définit la manière dont les documents peuvent être ouverts localement (sous Windows ou macOS) via l'agent de manière sécurisée et cryptée. Si un utilisateur dispose des autorisations requises, il peut ouvrir des fichiers protégés avec les applications autorisées, garantissant ainsi la conformité aux politiques de prévention contre la perte de données.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur. Ce paramètre peut définir la portée des autorisations, les conditions dans lesquelles elles s'appliquent et les exceptions autorisées. Il garantit que l'activité des utilisateurs reste alignée sur les politiques de l'organisation tout en permettant une flexibilité le cas échéant.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Précisez les membres qui font exception à la règle ci-dessus.",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Appliquer ces règles uniquement aux fichiers avec des étiquettes spécifiques",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes",
      "restrictionsTitle": "Restrictions",
      "restrictionsDescription": "Définissez quelles actions utilisateur sont limitées lors de l'accès aux documents protégés :",
      "restrictCopyPaste": "Restreindre les opérations de copier-coller",
      "restrictCopyPasteDescription": "Restreindre les opérations de copier-coller pour les fichiers avec des étiquettes spécifiques.",
      "restrictPrint": "Restreindre l'impression",
      "restrictPrintDescription": "Restreindre l'impression des fichiers avec des étiquettes spécifiques.",
      "restrictAppInternetAccess": "Restreindre l’accès Internet des applications",
      "restrictAppInternetAccessDescription": "Restreindre l'accès Internet des applications aux fichiers comportant des étiquettes spécifiques.",
      "restrictScreenCapture": "Restreindre la capture d'écran",
      "restrictScreenCaptureDescription": "Restreindre la capture d'écran pour les fichiers avec des étiquettes spécifiques.",
      "localAccessSettingsTitle": "Paramètres d'accès local",
      "localAccessSettingsDescription": "Configurez la manière dont les utilisateurs peuvent ouvrir et travailler avec des fichiers protégés sur leurs appareils :",
      "defaultLocalFileOpen": "Ouverture de fichier local par défaut",
      "defaultLocalFileOpenDescription": "Choisissez si vous souhaitez ouvrir les fichiers protégés avec l'application par défaut ou avec l'application spécifiée dans le champ « Applications autorisées ».",
      "allowedApplicationsTitle": "Applications autorisées",
      "allowedApplicationsDescription": "Choisissez les applications autorisées à ouvrir les fichiers protégés.",
      "offlineMode": "Permet l'accès aux fichiers lorsqu'aucune connexion Internet n'est disponible",
      "offlineModeDescription": "Le stockage local du certificat permet le décryptage hors ligne des fichiers. Le contenu du fichier peut être exposé si l'utilisateur local a accès au certificat stocké"
    },
    "tagBasedAccessControl": {
      "title": "Visibilité des fichiers balisés",
      "description": "Gérez l'accès aux documents avec des étiquettes (par exemple Public), accordant une visibilité à tous les utilisateurs ou invités externes, avec des droits de lecture/écriture en option et une protection par mot de passe.",
      "descriptionInternal": "Contrôlez l’accès aux documents à l’aide d'étiquettes d’utilisateur ou de groupe pour simplifier la recherche et la gestion des politiques. Des étiquettes (telles que Public) peuvent être appliquées pour permettre une visibilité plus large, soit à tous les utilisateurs enregistrés (Public interne), soit aux utilisateurs externes non authentifiés (Tout le monde), avec des autorisations facultatives de lecture ou de lecture/écriture et une protection par mot de passe.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur. Ce paramètre peut définir la portée des autorisations, les conditions dans lesquelles elles s'appliquent et les exceptions autorisées. Il garantit que l'activité des utilisateurs reste alignée sur les politiques de l'organisation tout en permettant une flexibilité le cas échéant.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Précisez les membres qui font exception à la règle ci-dessus.",
      "audienceTitle": "Public",
      "audienceDescription": "Définissez qui est autorisé à accéder aux documents balisés.",
      "registeredUsers": "Utilisateurs enregistrés",
      "unregisteredUsers": "Utilisateurs non enregistrés",
      "admin": "Administrateur",
      "contributors": "Contributeurs",
      "readers": "Lecteurs",
      "external": "Externe",
      "readAndWrite": "Lire et écrire",
      "readOnly": "Lecture seule",
      "passwordRequired": "Exiger un mot de passe pour l'accès",
      "setLinkExpiration": "Définir l'expiration du lien (date/heure)",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Autorise le partage avec des domaines externes uniquement pour les fichiers comportant des étiquettes spécifiques.",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes",
      "accessPolicyTagsRequired": "Les étiquettes de stratégie d'accès sont requises"
    },
    "contributorStorageLimit": {
      "title": "Limites de stockage",
      "allocationTitle": "Allocation de stockage des contributeurs",
      "allocationDescription": "Définissez l'espace de stockage disponible pour les contributeurs pour télécharger et partager des fichiers. Cette option vous permet de définir des limites de stockage spécifiques pour les contributeurs ou de choisir « Licence limitée » pour un stockage limité à l'espace total acheté par l'entreprise sous sa licence."
    },
    "deviceAccessLimitation": {
      "title": "Gestion des connexions simultanées",
      "browsersTitle": "Navigateurs",
      "browsersDescription": "Définissez le nombre de connexions simultanées que chaque membre peut établir à Filegrant Enterprise via différents navigateurs à l'aide de l'application Web.",
      "exceedingConnectionsTitle": "Dépassement des connexions du navigateur",
      "exceedingConnectionsDescription": "Spécifiez l'action à entreprendre lorsque le nombre de navigateurs connectés dépasse la limite autorisée.",
      "invalidateOldSessionsOption": "Invalidez automatiquement le jeton de session des connexions les plus anciennes.",
      "blockAccessOption": "Refuser l'accès jusqu'à ce que les anciennes sessions soient déconnectées manuellement ou expirent."
    },
    "editorFileManagement": {
      "title": "Contrôle de la gestion des fichiers des contributeurs",
      "subtitle": "Contrôlez les autorisations accordées aux contributeurs pour supprimer et renommer des fichiers et des dossiers au sein de leurs comptes. Les options incluent l'autorisation de tous les contributeurs ou d'aucun, avec des actions limitées aux fichiers qu'ils ont téléchargés ou reçus avec un accès éditeur.",
      "deletionPermissionsTitle": "Autorisations de suppression",
      "deletionPermissionsDescription": "Contrôlez si les contributeurs peuvent supprimer des fichiers. Les options incluent l'autorisation ou l'interdiction aux contributeurs de supprimer les fichiers qu'ils ont téléchargés ou reçus avec un accès éditeur.",
      "userScopeTitle": "Portée utilisateur",
      "userScopeDescription": "Contrôlez l'application des autorisations ci-dessus à tous les contributeurs ou à aucun.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Spécifiez les utilisateurs qui font exception aux autorisations ci-dessus. Ces utilisateurs auront un accès personnalisé pour supprimer et renommer des fichiers et des dossiers quels que soient les paramètres généraux."
    },
    "fileSizeLimit": {
      "title": "Limite de taille de fichier par membre",
      "limitTitle": "Limitation de la taille du fichier",
      "limitDescription": "Définissez la taille maximale du fichier que les membres peuvent télécharger. Ce paramètre vous permet de contrôler la plus grande taille de fichier pouvant être ajoutée à la plate-forme par n'importe quel membre, garantissant une utilisation efficace de l'espace de stockage et maintenant des performances optimales."
    },
    "quickShareMode": {
      "title": "Partage rapide",
      "description": "Gérer les paramètres de partage rapide. Contrôlez l'activation, l'ouverture automatique après la connexion et la durée maximale de partage.",
      "isVisibleTitle": "Visible",
      "isVisibleDescription": "Activer ou désactiver Quick Share pour les utilisateurs",
      "activeForAllTitle": "Accès au partage rapide",
      "activeForAllDescription": "Choisissez si Quick Share est disponible pour tous les utilisateurs ou pour aucun.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Précisez les membres qui font exception à la règle ci-dessus.",
      "showQuickShareByDefaultTitle": "Afficher le partage rapide par défaut",
      "showQuickShareByDefaultDescription": "Faire de Quick Share la page de destination par défaut après la connexion",
      "maxSharingDaysTitle": "Durée maximale de partage (jours)",
      "maxSharingDaysDescription": "Définissez le nombre de jours que dure le partage. Les actions expirent automatiquement après le nombre de jours sélectionné (maximum 365)",
      "enabledTitle": "Activer le partage rapide",
      "enabledDescription": "Lorsqu'il est activé, les utilisateurs peuvent partager des fichiers via Quick Share. Lorsqu'elle est désactivée, la fonctionnalité Quick Share n'est pas disponible.",
      "daysTitle": "Durée maximale de partage",
      "daysDescription": "Après ce nombre de jours, le lien du fichier partagé expirera et le partage sera supprimé.",
      "daysOption1": "Partage du dernier jour",
      "daysOption3": "Partage des 3 derniers jours",
      "daysOption7": "Partage des 7 derniers jours",
      "daysOption14": "Partage des 14 derniers jours",
      "daysOption30": "Partage des 30 derniers jours",
      "daysOption90": "Partage des 90 derniers jours"
    },
    "totpRequired": {
      "title": "Authentification à deux facteurs (TOTP)",
      "description": "Configurez TOTP 2FA à l’échelle de l’entreprise. Exigez TOTP pour tous les utilisateurs, définissez une période de grâce pour les nouveaux comptes et autorisez les administrateurs à réinitialiser le TOTP des utilisateurs.",
      "requiredTitle": "Exiger TOTP pour tous les utilisateurs",
      "requiredDescription": "Lorsqu'il est activé, tous les utilisateurs doivent configurer TOTP. Les nouveaux utilisateurs disposent d'un délai de grâce pour l'activer après la création du compte.",
      "gracePeriodDaysTitle": "Délai de grâce (jours)",
      "gracePeriodDaysDescription": "Les utilisateurs disposent de plusieurs jours à compter de la création du compte pour activer TOTP avant que la connexion ne soit bloquée.",
      "allowAdminResetTitle": "Autoriser les administrateurs à réinitialiser le TOTP de l'utilisateur",
      "allowAdminResetDescription": "Lorsqu'il est activé, les administrateurs peuvent désactiver TOTP pour les utilisateurs qui ont perdu l'accès à leur application d'authentification.",
      "maxExemptionDaysTitle": "Jours d'exonération maximum",
      "maxExemptionDaysDescription": "Nombre maximum de jours (1 à 365) pour une exemption TOTP temporaire lorsqu'un administrateur en accorde une. Par défaut 30.",
      "allowPermanentExemptionTitle": "Autoriser des exemptions permanentes",
      "allowPermanentExemptionDescription": "Lorsqu'ils sont activés, les administrateurs peuvent accorder des exemptions TOTP permanentes (sans expiration). En cas de désactivation, seules des exemptions temporaires sont autorisées.",
      "gracePeriodOption0": "Pas de délai de grâce (immédiat)",
      "gracePeriodOption1": "1 jour",
      "gracePeriodOption3": "3 jours",
      "gracePeriodOption7": "7 jours (recommandé)",
      "gracePeriodOption14": "14 jours",
      "gracePeriodOption30": "30 jours"
    },
    "passkeySettings": {
      "allowAdminRemoveDescription": "Lorsqu'ils sont activés, les administrateurs peuvent supprimer des clés d'accès individuelles ou effacer toutes les clés d'accès d'un utilisateur à partir des outils d'administration.",
      "allowAdminRemoveTitle": "Autoriser les administrateurs à supprimer les clés d'accès des utilisateurs",
      "allowAs2faDescription": "Lorsqu'il est activé, les utilisateurs qui terminent l'OTP par courrier électronique peuvent terminer leur connexion avec un mot de passe au lieu de TOTP, en fonction de l'inscription et d'autres politiques.",
      "allowAs2faTitle": "Autoriser les mots de passe comme deuxième facteur",
      "allowPasswordlessDescription": "Lorsqu'il est activé, les utilisateurs éligibles peuvent se connecter avec un mot de passe sans OTP de courrier électronique. Nécessite des clés d'accès comme deuxième facteur pour être autorisé.",
      "allowPasswordlessTitle": "Autoriser la connexion par mot de passe sans mot de passe",
      "attestationOptionDirect": "Direct",
      "attestationOptionIndirect": "Indirect",
      "attestationOptionNone": "Aucun (typique pour la plupart des organisations)",
      "attestationPreferenceDescription": "Dans quelle mesure le serveur demande-t-il une attestation lors de l'inscription. Des niveaux plus élevés peuvent améliorer l’assurance mais peuvent réduire la compatibilité des authentifiants.",
      "attestationPreferenceTitle": "Préférence d'attestation",
      "authenticatorAttachmentAny": "N'importe lequel (aucune restriction)",
      "authenticatorAttachmentCrossPlatform": "Multiplateforme (par exemple, clé de sécurité)",
      "authenticatorAttachmentDescription": "Vous pouvez éventuellement restreindre l'enregistrement aux authentificateurs de plateforme sur cet appareil, aux clés de sécurité multiplateformes, ou laisser sans restriction pour une compatibilité plus large.",
      "authenticatorAttachmentPlatform": "Plateforme (cet appareil)",
      "authenticatorAttachmentTitle": "Pièce jointe de l'authentificateur (facultatif)",
      "description": "Configurez les clés d'accès à l'échelle de l'organisation (WebAuthn) : activation, connexion à deuxième facteur ou sans mot de passe, limites par utilisateur, suppression d'administrateur et préférences de cérémonie d'inscription.",
      "enabledDescription": "Lorsqu'elles sont désactivées, l'enregistrement par mot de passe et la connexion basée sur un mot de passe ne sont pas disponibles pour les utilisateurs soumis à cette stratégie.",
      "enabledTitle": "Activer les mots de passe pour l'organisation",
      "maxCredentialsPerUserDescription": "Nombre maximum de mots de passe que chaque utilisateur peut enregistrer (1 à 50). Limite l’étalement et prend en charge les frais généraux.",
      "maxCredentialsPerUserTitle": "Nombre maximal de clés d'accès par utilisateur",
      "title": "Clés d'accès (WebAuthn)",
      "userVerificationDescription": "Dans quelle mesure l'authentifiant doit vérifier l'utilisateur lors de l'enregistrement du mot de passe. Requis est le plus strict ; découragé est le plus faible.",
      "userVerificationOptionDiscouraged": "Découragé",
      "userVerificationOptionPreferred": "Préféré",
      "userVerificationOptionRequired": "Obligatoire",
      "userVerificationTitle": "Vérification de l'utilisateur pour l'inscription"
    },
    "antivirusScan": {
      "title": "Analyse antivirus",
      "description": "Configurez quels types de fichiers téléversés sont analysés par le moteur antivirus. Le filtre d'extensions contrôle le coût, pas la politique de sécurité.",
      "enabledTitle": "Activer l'analyse antivirus",
      "enabledDescription": "Si activé, les téléversements correspondants sont analysés de façon asynchrone. Si désactivé, les nouveaux téléversements ne sont pas analysés, mais les verdicts existants restent sur les fichiers.",
      "extensionsTitle": "Extensions de fichiers analysées",
      "extensionsDescription": "Seuls les fichiers dont l'extension est listée sont envoyés au scanner. Restreignez la liste pour réduire le volume et le coût.",
      "extensionsPlaceholder": "Sélectionner les extensions à analyser",
      "costNoticeTitle": "Le filtre d'extensions contrôle le coût",
      "costNoticeDescription": "Analyser plus d'extensions augmente l'utilisation antivirus. Ce paramètre ne remplace pas les autres contrôles de sécurité.",
      "saveError": "Paramètres d'analyse antivirus invalides. Activez l'analyse uniquement avec au moins une extension sélectionnée.",
      "stickyInfectedNote": "Désactiver l'analyse ne supprime pas les verdicts infectés existants ni ne retire les fichiers de la quarantaine."
    },
    "activityLogRetention": {
      "title": "Conservation du journal d'activité",
      "description": "Définissez la durée pendant laquelle l'entreprise conserve son journal d'activité. Une fois la période de conservation écoulée depuis la création d'une entrée de journal, l'entrée est définitivement supprimée.",
      "activeTitle": "Politique de rétention",
      "activeDescription": "Lorsqu'il est désactivé, le journal d'activité est conservé indéfiniment et rien n'est jamais supprimé.",
      "windowTitle": "Période de conservation",
      "windowDescription": "Les entrées de journal antérieures à cette période sont définitivement supprimées. Plage autorisée : de {{min}} mois à {{max}} ans.",
      "warningTitle": "La suppression est définitive et rétroactive",
      "warningDescription": "L'activation de la stratégie supprime également les entrées de journal qui dépassent déjà la période de conservation. Les entrées supprimées ne peuvent pas être récupérées : exportez d'abord le journal d'activité si vous devez en conserver une copie."
    },
    "securityAnalysis": {
      "title": "Rapport exécutif et notification de sécurité",
      "description": "Configuration unique pour l'Executive Report (domaines internes, seuils d'indicateurs de risque), les seuils de détection des anomalies de sécurité et les notifications par email des anomalies détectées.",
      "enableTitle": "Activer les notifications par e-mail",
      "enableDescription": "Lorsqu'il est activé, un e-mail est envoyé aux destinataires sélectionnés pour les nouvelles anomalies de sécurité de la gravité choisie ou supérieure.",
      "recipientsTitle": "Destinataires",
      "recipientsDescription": "Utilisateurs et groupes de la plateforme qui recevront les notifications. Pour les groupes, tous les membres sont avertis.",
      "recipientsPlaceholder": "Rechercher des utilisateurs ou des groupes",
      "minSeverityTitle": "Gravité minimale",
      "minSeverityDescription": "Envoyez des notifications uniquement à partir de cette gravité. Avertissement inclut Avertissement et Critique ; Critique envoie uniquement Critique.",
      "severityWarning": "Attention et ci-dessus",
      "severityCritical": "Critique uniquement",
      "domainsTitle": "Domaines internes",
      "domainsDescription": "Liste séparée par des virgules des domaines de messagerie considérés comme internes lorsque le rapport exécutif fait la distinction entre partage interne et partage externe. S'il est vide, le domaine de messagerie du premier administrateur est utilisé.",
      "domainsPlaceholder": "company.com, filiale.com",
      "domainsError": "Un ou plusieurs domaines ne sont pas dans un format valide (par exemple, entreprise.com).",
      "thresholdsTitle": "Seuils des indicateurs de risque",
      "thresholdsDescription": "Seuils en pourcentage définissant ce qui est considéré comme un avertissement et ce qui est considéré comme critique pour chaque indicateur de risque du rapport exécutif.",
      "warningLabel": "Attention ≥",
      "criticalLabel": "Critique ≥",
      "thresholdError": "Le seuil d'alerte doit être inférieur au seuil critique.",
      "detectorThresholdsTitle": "Seuils de détection des anomalies",
      "detectorThresholdsDescription": "Le nombre d'événements définit ce qui est considéré comme un avertissement et ce qui est considéré comme critique pour chaque détecteur d'anomalies de sécurité. Les détecteurs sans seuils numériques (IP admin bloquée, signaux de sécurité explicites) ne sont pas personnalisables.",
      "detectorThresholdError": "Le seuil d'alerte doit être inférieur au seuil critique.",
      "detectors": {
        "bruteForceLogin": "Échec de connexion sur le même compte (fenêtre de 15 minutes)",
        "folderPassword": "Tentatives de mot de passe de dossier ayant échoué (par dossier et par utilisateur)",
        "publicLinkBruteForce": "Accès au lien public ayant échoué (par lien et IP)",
        "massDownload": "Fichiers téléchargés par un utilisateur (fenêtre de 60 minutes)",
        "passwordSpray": "Spray de mot de passe : tentatives de comptes distincts à partir d'une seule adresse IP",
        "unauthorizedCountry": "Accès bloqués depuis un pays non autorisé (par utilisateur et pays)"
      }
    },
    "ipRegionRestriction": {
      "title": "Restriction IP/région",
      "description": "Restreindre l'accès à la plateforme en fonction de l'adresse IP, du pays ou de la région",
      "warningMessage": "Attention : ce paramètre bloque tous les utilisateurs qui ne correspondent pas aux critères",
      "warningDescription": "Les utilisateurs en dehors des adresses IP, des pays ou des régions autorisés se verront refuser l'accès. Configurez des exceptions pour des utilisateurs ou des groupes spécifiques.",
      "confirmTitle": "Confirmer la configuration",
      "confirmWarning": "Cette configuration restreindra l'accès. Les utilisateurs en dehors des adresses IP, des pays ou des régions autorisés se verront refuser l'accès. Es-tu sûr?",
      "scopeTitle": "Champ d'application",
      "scopeDescription": "Quand cette restriction doit-elle s’appliquer ?",
      "scopeLogin": "Connexion uniquement",
      "scopeFileOps": "Opérations sur les fichiers uniquement",
      "scopeBoth": "Les deux (recommandé)",
      "allowedIpsTitle": "Adresses IP/plages CIDR autorisées",
      "allowedIpsDescription": "Liste d'adresses IP ou de plages CIDR séparées par des virgules (IPv4/IPv6)",
      "allowedCountriesTitle": "Pays autorisés",
      "allowedCountriesDescription": "Certains pays (codes ISO 3166-1 alpha-2)",
      "allowedRegionsTitle": "Régions autorisées",
      "allowedRegionsDescription": "Sélectionnez les régions (codes ISO 3166-2 ou « UE » pour l'Union européenne)",
      "allowPrivateNetworksTitle": "Autoriser les réseaux privés",
      "allowPrivateNetworksDescription": "Restriction de contournement pour les plages IP privées (10.x, 192.168.x, 172.16-31.x)",
      "adminAccessSectionTitle": "Accès administrateur",
      "restrictAdminAccessTitle": "Restreindre les paramètres d'administration par IP",
      "restrictAdminAccessDescription": "Autoriser l'accès aux paramètres d'administration uniquement à partir d'adresses IP ou de plages CIDR spécifiées",
      "adminAllowedIpsTitle": "Adresses IP d'administrateur autorisées",
      "adminAllowedIpsDescription": "Liste d'adresses IP ou CIDR séparées par des virgules autorisées à ouvrir les paramètres d'administration",
      "addAdminIp": "Ajouter une adresse IP",
      "addAllowedIp": "Ajouter une adresse IP ou CIDR",
      "logBlockedAttemptsTitle": "Consigner les tentatives bloquées",
      "logBlockedAttemptsDescription": "Enregistrez toutes les tentatives de refus d'accès dans le journal d'activité",
      "blockedMessageTitle": "Message bloqué personnalisé",
      "blockedMessageDescription": "Message affiché aux utilisateurs bloqués (max 200 caractères)",
      "blockedMessagePlaceholder": "Accès refusé depuis votre emplacement.",
      "exceptionsTitle": "Exceptions",
      "exceptionsDescription": "Utilisateurs ou groupes avec des critères d'accès supplémentaires",
      "validationAtLeastOne": "Au moins un critère (IP, pays ou région) doit être spécifié",
      "validationInvalidIp": "Format IP/CIDR invalide : {{entries}}",
      "validationInvalidCountry": "Codes pays invalides : {{codes}}",
      "validationInvalidRegion": "Codes de région invalides : {{codes}}",
      "adminAllowedIpsHelper": "IP/CIDR uniquement : pas de géolocalisation, pas de contournement de réseau privé et les exceptions ci-dessus ne s'appliquent pas ici."
    },
    "fileTypeRestriction": {
      "title": "Contrôle des restrictions de type de fichier",
      "description": "Vous permet de spécifier quels types de fichiers sont bloqués pour le téléchargement.",
      "blockedExtensionsTitle": "Extensions de fichiers bloquées",
      "blockedExtensionsDescription": "Spécifiez quelles extensions de fichiers sont bloquées. Cela vous permet de définir exactement quels types de fichiers sont soumis aux restrictions.",
      "userScopeTitle": "Portée utilisateur",
      "userScopeDescription": "Contrôlez si les utilisateurs seront empêchés de télécharger ou de partager des fichiers sur la plate-forme en fonction des types de fichiers spécifiés définis ci-dessus. Les options incluent le blocage de tous les utilisateurs ou d'aucun. Les fichiers existants téléchargés ou partagés resteront actifs même si l'autorisation est révoquée ultérieurement.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur. Ce paramètre peut définir la portée des autorisations, les conditions dans lesquelles elles s'appliquent et les exceptions autorisées.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Spécifiez les utilisateurs qui font exception aux restrictions ci-dessus.",
      "showUsers": "Afficher les utilisateurs qui ont déjà obtenu l'accès par d'autres.",
      "allowEdit": "Permet aux utilisateurs de modifier, remplacer ou supprimer les paramètres de partage existants.",
      "readOnly": "Activez le partage de fichiers par les utilisateurs disposant d'un accès en lecture seule (Viewer).",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Appliquez ces règles uniquement aux fichiers avec des étiquettes spécifiques.",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles",
      "fileTypesTitle": "Types de fichiers",
      "fileTypesDescription": "Définissez les types de fichiers soumis à cette règle.",
      "fileTypesPlaceholder": "Sélectionnez les types de fichiers ou les extensions"
    },
    "folderCreationPermission": {
      "title": "Limites des dossiers",
      "creationTitle": "Création du dossier des contributeurs",
      "creationDescription": "Contrôlez quels contributeurs peuvent créer des dossiers sur la plateforme. Les options incluent l'autorisation de tous les contributeurs ou d'aucun. Les dossiers existants restent accessibles même si l'autorisation est révoquée ultérieurement.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus."
    },
    "groupCreationControl": {
      "title": "Limites de groupe",
      "creationTitle": "Création d'un groupe de contributeurs",
      "creationDescription": "Contrôlez quels contributeurs peuvent créer des groupes sur la plateforme. Les options incluent l'autorisation de tous les contributeurs ou d'aucun. Les groupes créés ne sont visibles que par l'utilisateur qui les a créés. Les groupes existants restent accessibles même si l'autorisation est révoquée ultérieurement.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus."
    },
    "publicAccessLink": {
      "title": "Lien d'accès public",
      "description": "Contrôlez la possibilité pour les contributeurs de générer des liens pour accéder aux fichiers et dossiers sans authentification. Les options incluent l'autorisation à tous les membres ou à aucun de créer ces liens. Les liens existants resteront actifs même si l'autorisation est révoquée ultérieurement.",
      "activeForAllTitle": "Génération de liens de contributeurs",
      "activeForAllDescription": "Contrôlez la possibilité pour les contributeurs de générer des liens pour accéder aux fichiers et dossiers sans authentification. Les options incluent l'autorisation à tous les membres ou à aucun de créer ces liens. Les liens existants resteront actifs même si l'autorisation est révoquée ultérieurement.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Spécifiez les contributeurs qui font exception aux autorisations de génération de liens ci-dessus.",
      "forcePasswordTitle": "Forcer le mot de passe",
      "forcePasswordDescription": "Lorsqu'il est activé, l'utilisateur doit définir un mot de passe lors de la création d'un lien public.",
      "mandatoryMaxAccessCountTitle": "Nombre d'accès maximum obligatoire",
      "mandatoryMaxAccessCountDescription": "S'il est supérieur à 0, l'utilisateur doit spécifier un nombre maximum d'accès (0 à 10 000). 0 signifie non requis.",
      "maxExpirationDaysTitle": "Jours d'expiration maximum",
      "maxExpirationDaysDescription": "S'il est supérieur à 0, l'utilisateur doit définir une expiration dans ce nombre de jours (0 à 365). 0 signifie aucune contrainte. <br /> <DangerText> Si « Expiration obligatoire du fichier partagé » est activé, la date d'expiration définie dans ce paramètre aura priorité sur la date d'expiration maximale configurée ici. </DangerText>",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Les liens publics ne peuvent être créés que pour les fichiers comportant ces étiquettes."
    },
    "sessionControl": {
      "title": "Limite de sessions simultanées",
      "description": "Limitez le nombre de sessions actives par utilisateur. Lorsqu'un utilisateur dépasse la limite, la session la plus ancienne est automatiquement terminée.",
      "maxSessionsTitle": "Sessions maximales",
      "maxActiveSessions": "Nombre maximum de sessions actives",
      "maxSessionsDescription": "Définissez le nombre maximum de sessions simultanées autorisées par utilisateur. Lorsque la limite est atteinte, la session la plus ancienne sera automatiquement déconnectée.",
      "unlimited": "Illimité",
      "exceptionsTitle": "Exceptions",
      "exceptionsDescription": "Remplacez la limite de session pour des utilisateurs ou des groupes spécifiques.",
      "pendingExceptionsTitle": "Exceptions en attente",
      "savedExceptionsTitle": "Exceptions enregistrées",
      "selectUsersOrGroups": "Sélectionnez des utilisateurs ou des groupes..."
    },
    "uploadWithTag": {
      "title": "Gestion automatique des étiquettes",
      "description": "Filegrant Enterprise analysera les métadonnées des fichiers classifiés téléchargés à la recherche de mots-clés spécifiques. Si l'un des mots-clés spécifiés est détecté, la valeur correspondante sera appliquée au fichier en tant que étiquette. Si un tag n'existe pas déjà sur la plateforme, il est créé automatiquement. Ce processus garantit que chaque fichier est correctement classé et étiqueté en fonction de son contenu.",
      "keywordsTitle": "Mots-clés",
      "keywordsDescription": "Spécifiez les mots-clés dont les valeurs seront utilisées comme étiquettes pour le fichier après le téléchargement.",
      "userScopeTitle": "Portée utilisateur",
      "userScopeDescription": "Contrôlez si les membres sont soumis à la détection automatique des étiquettes pour les téléchargements de fichiers sur la plateforme. Les options incluent l’application de cela à tous les membres ou à aucun. Les fichiers existants qui ont déjà été téléchargés et balisés resteront actifs et les modifications apportées aux mots-clés n'affecteront pas ces fichiers précédemment balisés.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus."
    },
    "watermarkProtection": {
      "title": "Protection des filigranes",
      "description": "Contrôlez la protection des filigranes pour les fichiers partagés. Activez pour tous les membres ou aucun, gérez les exceptions et configurez les données qui apparaissent sur le filigrane (par exemple, date de partage, propriétaire, destinataire, date de création, IP).",
      "descriptionInternal": "Contrôlez la protection des filigranes pour les fichiers partagés. Activez pour tous les membres ou aucun, gérez les exceptions et configurez les données qui apparaissent sur le filigrane (par exemple, date de partage, propriétaire, destinataire, date de création, IP). <DangerText>Pour le moment, les filigranes sont appliqués uniquement aux fichiers PDF, Office et image, et uniquement lorsque les destinataires reçoivent le fichier en mode lecture seule.</DangerText>",
      "enabledTitle": "Activé",
      "enabledDescription": "Activez ou désactivez ce paramètre.",
      "userScopeTitle": "Portée utilisateur",
      "userScopeDescription": "Autorisez les membres à protéger leurs fichiers avec des filigranes. Les options incluent l’activation de cette fonctionnalité pour tous les membres ou aucun. Des filigranes peuvent être appliqués au moment du partage. Lorsque les destinataires ouvrent le document, le filigrane affichera leur adresse e-mail, leur adresse IP et la date d'accès au document, garantissant ainsi la protection et le suivi du contenu.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Appliquez la protection contre les filigranes à tous les membres ou à aucun. Lorsqu'il est défini sur aucun, vous pouvez toujours cibler des membres spécifiques via des exceptions et des étiquettes.",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus.",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Appliquez la protection par filigrane uniquement aux fichiers comportant ces étiquettes.",
      "previewTitle": "Aperçu",
      "textLabel": "Texte en filigrane",
      "repetitionLabel": "Répétition",
      "repetitionSingle": "Célibataire",
      "repetitionRepetitive": "Répétitif",
      "fieldsLabel": "Champs à afficher",
      "fieldsSharingDate": "Date de partage",
      "fieldsOwner": "Propriétaire",
      "fieldsRecipient": "Destinataire",
      "fieldsCreationDate": "Date de création",
      "fieldsIp": "Adresse IP",
      "positionXLabel": "Position horizontale",
      "positionYLabel": "Position verticale",
      "positionLeft": "Gauche",
      "positionCenter": "Centre",
      "positionRight": "À droite",
      "positionTop": "Haut",
      "positionMiddle": "Milieu",
      "positionBottom": "En bas",
      "positionsLabel": "Poste",
      "positionsTopLeft": "En haut à gauche",
      "positionsTopCenter": "En haut au centre",
      "positionsTopRight": "En haut à droite",
      "positionsBottomLeft": "En bas à gauche",
      "positionsBottomCenter": "En bas au centre",
      "positionsBottomRight": "En bas à droite",
      "positionsDiagonal": "Diagonale (répété)",
      "fontSizeLabel": "Taille de la police",
      "fontSizeDescription": "1 à 72",
      "fontColorLabel": "Couleur de police",
      "opacityLabel": "Opacité",
      "opacityDescription": "0 à 100 %",
      "textPlaceholderHelp": "Les boutons ci-dessous insèrent des espaces réservés dans le texte. Vous pouvez utiliser \\n pour les sauts de ligne et **gras** pour le texte en gras. L'info-bulle de chaque bouton explique ce qu'il fait.",
      "placeholderButtonOwner": "Propriétaire",
      "placeholderTooltipOwner": "Dans le filigrane, {owner} est remplacé par le nom du propriétaire du document.",
      "placeholderButtonAccessDate": "Afficher la date/heure",
      "placeholderTooltipAccessDate": "Dans le filigrane, {access_date} est remplacé par la date et l'heure auxquelles le document a été consulté.",
      "placeholderButtonSharingDate": "Date de partage",
      "placeholderTooltipSharingDate": "Dans le filigrane, {sharing_date} est remplacé par la date de génération du lien.",
      "placeholderButtonIp": "Adresse IP",
      "placeholderTooltipIp": "Dans le filigrane, {ip} est remplacé par l'adresse IP du spectateur.",
      "placeholderButtonRecipient": "Destinataire",
      "placeholderTooltipRecipient": "Dans le filigrane, {recipient} est remplacé par le nom du destinataire.",
      "placeholderButtonOwnerEmail": "E-mail du propriétaire",
      "placeholderTooltipOwnerEmail": "Dans le filigrane, {owneremail} est remplacé par l'adresse e-mail du propriétaire du document.",
      "placeholderButtonRecipientEmail": "E-mail du destinataire",
      "placeholderTooltipRecipientEmail": "Dans le filigrane, {recipientemail} est remplacé par l'adresse e-mail du destinataire."
    },
    "remotegrantForceEncryption": {
      "title": "Chiffrement forcé à distance (licence requise)",
      "description": "Cryptez les fichiers et attribuez automatiquement des autorisations d'accès aux membres nouvellement créés à l'aide de Remotegrant."
    },
    "sharingApprovalRequirement": {
      "title": "Partager les exigences d’approbation",
      "description": "Contrôle si le partage de fichiers et de dossiers nécessite une approbation préalable, garantissant que les fichiers sensibles sont examinés avant la distribution et que la conformité est maintenue.",
      "descriptionInternal": "Cette section permet aux administrateurs de contrôler si le partage de fichiers et de dossiers nécessite une approbation préalable. Les règles peuvent être appliquées universellement, à des types de propriété de fichiers spécifiques ou basées sur des étiquettes de classification. Les administrateurs peuvent garantir que les fichiers sensibles sont examinés avant d'être partagés, contribuant ainsi à maintenir la conformité, à prévenir les fuites de données et à appliquer les politiques organisationnelles. Les demandes d'approbation peuvent être acheminées vers un superviseur désigné ou une équipe d'examen prédéfinie.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur. Ce paramètre peut définir la portée des autorisations, les conditions dans lesquelles elles s'appliquent et les exceptions autorisées. Il garantit que l'activité des utilisateurs reste alignée sur les politiques de l'organisation tout en permettant une flexibilité le cas échéant.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus.",
      "reviewTeamTitle": "Équipe de révision",
      "reviewTeamDescription": "Spécifiez l’équipe qui examinera les demandes d’approbation.",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Appliquer ces règles uniquement aux fichiers avec des étiquettes spécifiques",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes",
      "exceptionHandlingTitle": "Gestion des exceptions",
      "exceptionHandlingDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus.",
      "generalApprovalTitle": "Exigence générale d’approbation",
      "generalApprovalDescription": "Le partage n'est autorisé qu'après l'approbation préalable d'un superviseur désigné ou d'une équipe définie dans la politique.",
      "resharingApprovalTitle": "Approbation pour les fichiers repartagés uniquement",
      "resharingApprovalDescription": "Applique l’exigence d’approbation uniquement aux fichiers précédemment reçus et en cours de partage.",
      "manageReviewTeam": "Gérer l'équipe d'examen"
    },
    "mandatoryFileClassification": {
      "title": "Classement obligatoire des dossiers",
      "description": "Exigez que les fichiers soient classifiés avant le partage, en garantissant que les fichiers sensibles sont correctement étiquetés et protégés.",
      "descriptionInternal": "Cette section garantit que les fichiers sont correctement classés avant de pouvoir être partagés. En exigeant une classification, il contribue à empêcher le partage accidentel ou non autorisé de contenu sensible et prend en charge une gouvernance cohérente des données.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur. Ce paramètre peut définir la portée des autorisations, les conditions dans lesquelles elles s'appliquent et les exceptions autorisées. Il garantit que l'activité des utilisateurs reste alignée sur les politiques de l'organisation tout en permettant une flexibilité le cas échéant.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus.",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Appliquer ces règles uniquement aux fichiers avec des étiquettes spécifiques",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes"
    },
    "forcedFileInvisibility": {
      "title": "Invisibilité forcée des fichiers",
      "description": "Cette fonctionnalité permet aux administrateurs de rendre des types de fichiers spécifiques invisibles aux destinataires tout en complétant l'action de partage. Par exemple, les documents Office utilisés comme fichiers principaux modifiables peuvent être partagés mais restent cachés pour le destinataire, réduisant ainsi le risque d'exposition de fichiers sources modifiables tout en permettant le partage de formats approuvés tels que les PDF.",
      "descriptionInternal": "Cette fonctionnalité permet aux administrateurs de rendre des types de fichiers spécifiques invisibles aux destinataires tout en complétant l'action de partage. Par exemple, les documents Office utilisés comme fichiers principaux modifiables peuvent être partagés mais restent cachés pour le destinataire, réduisant ainsi le risque d'exposition de fichiers sources modifiables tout en permettant le partage de formats approuvés tels que les PDF.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur. Ce paramètre peut définir la portée des autorisations, les conditions dans lesquelles elles s'appliquent et les exceptions autorisées. Il garantit que l'activité des utilisateurs reste alignée sur les politiques de l'organisation tout en permettant une flexibilité le cas échéant.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus.",
      "fileTypesTitle": "Invisible après le partage",
      "fileTypesDescription": "Rend certains types de fichiers (par exemple, les documents Office) invisibles pour les destinataires tout en complétant le processus de partage.",
      "fileTypesPlaceholder": "Saisissez les types de fichiers ou les extensions (par exemple, .docx, .xls, .pptx)",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Appliquer ces règles uniquement aux fichiers avec des étiquettes spécifiques",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes"
    },
    "shortcutLink": {
      "title": "Restriction des liens de raccourci",
      "description": "Restreindre la création de liens de raccourci pour les fichiers contenant des étiquettes désignées.",
      "descriptionInternal": "Restreindre la création de liens de raccourci pour les fichiers contenant des étiquettes désignées.",
      "activeForAllTitle": "Portée utilisateur",
      "activeForAllDescription": "Contrôlez si les utilisateurs sont soumis aux restrictions définies par l'administrateur.",
      "exceptionsTitle": "Gestion des exceptions",
      "exceptionsDescription": "Spécifiez les utilisateurs qui font exception à la fonctionnalité ci-dessus.",
      "tagsTitle": "Étiquettes",
      "tagsDescription": "Appliquer ces règles uniquement aux fichiers avec des étiquettes spécifiques",
      "tagsRequired": "Au moins une étiquette est requise lorsqu'il existe plusieurs règles",
      "exceptionsRequiredForTags": "Des exceptions sont requises pour la définition des étiquettes"
    },
    "adminSettingsPermissions": {
      "title": "Autorisations des paramètres d'administration",
      "description": "Restreint l'accès administrateur aux paramètres de la plateforme",
      "deniedSettingsUserTitle": "Portée de l'administrateur",
      "deniedSettingsUserDescription": "Sélectionnez l'administrateur qui se verra refuser l'accès aux paramètres.",
      "deniedSettingsTitle": "Paramètres refusés",
      "deniedSettingsDescription": "Spécifiez les paramètres auxquels les administrateurs ne sont pas autorisés à accéder.",
      "selectUserFirst": "Sélectionnez d'abord un utilisateur"
    }
  },
  "auth": {
    "loginPageTitle": "Bienvenue sur Filegrant Enterprise",
    "loginPageSubtitle": "Veuillez saisir votre adresse e-mail pour accéder en toute sécurité au document.",
    "resendOtpCode": "Renvoyer le code OTP",
    "loginTermsAndConditions": "J'accepte les [**Conditions d'utilisation**](https://www.cybergrant.net/terms-of-service) de Cyber Grant Inc.",
    "loginPageEmailLabel": "Adresse e-mail",
    "loginPageEmailPlaceholder": "Entrez votre adresse e-mail ici...",
    "loginPageOtpLabel": "Entrez ici le code à 6 chiffres que vous avez reçu à votre adresse e-mail. Si vous ne l'avez pas reçu, cliquez sur « Demander un nouveau code »",
    "loginButtonLabel": "Connexion",
    "loginPageResendOtp": "Demander un nouveau code",
    "orContinueWith": "Ou continuez avec",
    "loginPageTooManyAttempts": "Trop de tentatives, réessayez dans",
    "totpStepTitle": "Authentification à deux facteurs",
    "enterTotpCode": "Saisissez le code à 6 chiffres de votre application d'authentification",
    "configure2FA": "Je dois configurer 2FA",
    "useBackupCode": "Utiliser un code de secours",
    "useOtpCode": "Utiliser le code OTP",
    "enterBackupCode": "Entrez votre code de secours",
    "backupCodePlaceholder": "Entrez votre code de secours",
    "totpTimeRemaining": "Temps restant pour terminer l'authentification : {{time}}",
    "twoFactorChooseMethod": "Choisissez comment vérifier",
    "usePasskey": "Utiliser le mot de passe",
    "useTotp": "Utiliser l'application d'authentification",
    "passkeyWaiting": "En attente de votre mot de passe…",
    "orDivider": "ou",
    "signInWithPasskey": "Connectez-vous avec un mot de passe",
    "passkeyCancelled": "La connexion par mot de passe a été annulée.",
    "passkeyNotSupported": "Votre navigateur ne prend pas en charge les mots de passe.",
    "passwordlessNotEnabled": "La connexion par mot de passe n'est pas activée pour votre organisation.",
    "totpForcedSetupIntro": "Votre organisation nécessite une authentification à deux facteurs. Configurez-le maintenant pour terminer la connexion en tant que {{email}}.",
    "totpForcedSetupTitle": "Configurer l'authentification à deux facteurs",
    "totpForcedSetupDescription": "Scannez le code QR avec votre application d'authentification, puis saisissez le code à 6 chiffres pour terminer la connexion."
  },
  "secret": {
    "createTitle": "Créer un fichier secret",
    "createSecret": "Mot de passe ou secret",
    "newSecret": "Nouveau secret",
    "fileName": "Nom du fichier",
    "fileNameRequired": "Le nom du fichier est obligatoire",
    "protectWithPassword": "Protéger avec un mot de passe",
    "protectWithSecretKey": "Protéger avec une clé secrète",
    "secretKeyWarning": "Si vous perdez cette clé, les informations ne seront plus accessibles",
    "changeSecretKey": "Changer la clé secrète",
    "currentSecretKey": "Clé secrète actuelle",
    "wrongCurrentKey": "La clé secrète actuelle est incorrecte",
    "hint": "Indice",
    "hintPlaceholder": "Astuce facultative pour mémoriser la clé",
    "newSecretKey": "Nouvelle clé secrète",
    "confirmSecretKey": "Confirmer la clé secrète",
    "secretKeyMismatch": "Les clés secrètes ne correspondent pas",
    "enterPassword": "Entrez le mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "passwordRequired": "Le mot de passe est requis",
    "passwordMinLength": "Le mot de passe doit contenir au moins 4 caractères",
    "confirmPasswordRequired": "Confirmer le mot de passe",
    "passwordMismatch": "Les mots de passe ne correspondent pas",
    "wrongPassword": "Mauvais mot de passe",
    "addField": "Ajouter un champ",
    "addFieldForGroup": "Ajouter un champ au groupe",
    "removeField": "Supprimer le champ",
    "editLabel": "Modifier l'étiquette",
    "fieldType": "Tapez",
    "fieldLabel": "Nouveau champ",
    "fieldValue": "Valeur",
    "fields": {
      "heading": "Champs",
      "username": "Nom d’utilisateur",
      "password": "Mot de passe",
      "website": "Site web",
      "cardholder": "Titulaire",
      "number": "Numéro de carte",
      "brand": "Marque",
      "exp_month": "Mois d’expiration",
      "exp_year": "Année d’expiration",
      "cvv": "CVV",
      "title": "Civilité",
      "first_name": "Prénom",
      "last_name": "Nom",
      "fiscal_code": "Numéro fiscal",
      "passport": "Passeport",
      "driving_license": "Permis de conduire",
      "email": "E-mail",
      "phone": "Téléphone",
      "address1": "Adresse ligne 1",
      "address2": "Adresse ligne 2",
      "address3": "Adresse ligne 3",
      "city": "Ville",
      "state": "Région / Province",
      "zip": "Code postal",
      "country": "Pays",
      "private_key": "Clé privée",
      "public_key": "Clé publique",
      "fingerprint": "Empreinte",
      "notes": "Notes"
    },
    "searchFields": "Champs de recherche",
    "noFieldsYet": "Aucun champ pour l'instant",
    "untitled": "Sans titre",
    "types": {
      "text": "Texte",
      "password": "Mot de passe",
      "url": "URL",
      "username": "Nom d'utilisateur",
      "email": "E-mail",
      "phone": "Téléphone",
      "textarea": "Zone de texte",
      "number": "Nombre",
      "month": "Mois",
      "year": "Année"
    },
    "validation": {
      "email": "Cela ne semble pas être une adresse e-mail valide",
      "url": "Cela ne semble pas être une URL valide",
      "phone": "Cela ne semble pas être un numéro de téléphone valide",
      "number": "Cela ne semble pas être un nombre valide"
    },
    "password": {
      "show": "Afficher",
      "hide": "Masquer",
      "generate": "Générer un mot de passe",
      "copy": "Copier",
      "copied": "Copié!",
      "length": "Longueur",
      "includeSymbols": "Inclure des caractères spéciaux",
      "strength": {
        "veryWeak": "Très faible",
        "weak": "Faible",
        "fair": "Foire",
        "strong": "Fort",
        "veryStrong": "Très fort"
      }
    },
    "edit": "Modifier",
    "save": "Enregistrer",
    "saved": "Enregistré avec succès",
    "cancel": "Annuler",
    "protectedFile": "Fichier protégé",
    "enterPasswordToView": "Entrez le mot de passe pour afficher le contenu",
    "unlock": "Déverrouiller",
    "noData": "Aucune donnée disponible",
    "loadError": "Erreur de chargement du fichier",
    "saveError": "Erreur lors de l'enregistrement du fichier",
    "addWebsite": "Ajouter un site",
    "addGroup": "Ajouter un groupe",
    "newGroup": "Nouveau groupe",
    "renameGroup": "Renommer le groupe",
    "deleteGroup": "Supprimer le groupe",
    "moveUp": "Monter",
    "moveDown": "Descendre",
    "dragToReorderField": "Glisser pour réordonner {{label}}",
    "dragToReorderGroup": "Glisser pour réordonner le groupe {{label}}",
    "presets": {
      "credentials": "Identifiants de connexion",
      "card": "Carte de paiement",
      "identity": "Identité",
      "ssh_key": "Clé SSH",
      "custom": "Secret personnalisé"
    },
    "groups": {
      "credentials_main": "Identifiants de connexion",
      "credentials_autofill": "Options de remplissage automatique",
      "card_main": "Carte",
      "identity_personal": "Personnel",
      "identity_ids": "Documents",
      "identity_contact": "Contact",
      "identity_address": "Adresse",
      "ssh_main": "Clé SSH",
      "custom_fields": "Champs personnalisés",
      "additional_options": "Options supplémentaires"
    },
    "card": {
      "brands": {
        "visa": "Visa",
        "mastercard": "Mastercard",
        "amex": "American Express",
        "other": "Autre"
      }
    },
    "identity": {
      "titles": {
        "mr": "M.",
        "ms": "Mme",
        "mx": "Mx",
        "dr": "Dr",
        "prof": "Pr",
        "other": "Autre"
      }
    },
    "ssh": {
      "upload": "Importer un fichier de clé",
      "uploadError": "Impossible de lire le fichier de clé"
    }
  },
  "publicShare": {
    "createLink": "Lien public",
    "revokeLink": "Révoquer le lien public",
    "revokeLinkConfirmDescription": "Révoquer le lien public pour {{fileName}} ?",
    "badgeSection": "Lien public",
    "badgeActive": "Lien public actif",
    "revoked": "Lien public révoqué avec succès",
    "createModal": {
      "title": "Créer un lien public",
      "fileLabel": "Fichier",
      "allowDownload": "Autoriser le téléchargement",
      "expirationLabel": "Expiration (facultatif)",
      "expirationPlaceholder": "Jamais",
      "maxAccessCountLabel": "Nombre maximum d'accès (facultatif)",
      "maxAccessCountPlaceholder": "Illimité",
      "protectWithPassword": "Protéger avec un mot de passe",
      "passwordLabel": "Mot de passe",
      "passwordPlaceholder": "Entrez le mot de passe",
      "passwordRequired": "Le mot de passe est requis lorsque la protection est activée",
      "createLink": "Créer un lien"
    },
    "successModal": {
      "title": "Lien créé !",
      "message": "Le lien public a été créé.",
      "copyLink": "Copier le lien",
      "warning": "Toute personne disposant de ce lien peut accéder au fichier.",
      "expiresAt": "Expire",
      "remainingAccesses": "Accès restants",
      "password": "Mot de passe"
    },
    "errors": {
      "linkAlreadyExists": "Un lien public existe déjà pour ce fichier. Révoquez-le d'abord pour en créer un nouveau.",
      "linkNotFound": "Aucun lien actif trouvé pour ce fichier.",
      "featureDisabled": "Les liens publics sont désactivés pour votre organisation.",
      "notOwner": "Vous devez être le propriétaire pour créer ou révoquer des liens publics."
    },
    "passwordTitle": "Contenu protégé",
    "passwordMessage": "Ce fichier est protégé par un mot de passe. Entrez le mot de passe pour y accéder.",
    "passwordRequired": "Un mot de passe est requis.",
    "errorInvalidPassword": "Le mot de passe que vous avez entré est incorrect. Veuillez réessayer.",
    "passwordSubmit": "Accès",
    "errorExpiredTitle": "Lien expiré",
    "errorExpiredMessage": "Ce lien de partage n'est plus valide. La date d'expiration est passée. Contactez la personne qui vous a envoyé le lien pour en demander un nouveau.",
    "errorMaxAccessTitle": "Limite d'accès atteinte",
    "errorMaxAccessMessage": "Ce lien a atteint le nombre maximum d'accès autorisés. Contactez la personne qui vous a envoyé le lien pour en demander un nouveau.",
    "errorNotFoundTitle": "Lien invalide",
    "errorNotFoundMessage": "Le lien que vous essayez d'ouvrir n'existe pas ou a été révoqué par le propriétaire. Veuillez vérifier que vous avez copié correctement l'URL.",
    "folderContents": "Contenu du dossier",
    "items": "articles",
    "fileSize": "Taille",
    "fileType": "Tapez",
    "sharedAt": "Partagé sur",
    "list": {
      "title": "Mes liens publics",
      "description": "Gérez vos liens de partage publics. Révoquer un lien pour le désactiver.",
      "fileName": "Nom",
      "type": "Tapez",
      "status": "Statut",
      "statusActive": "Actif",
      "statusExpired": "Expiré",
      "statusExhausted": "Limite atteinte",
      "expiresAt": "Expire",
      "accessCount": "Accès",
      "hasPassword": "Mot de passe",
      "empty": "Pas encore de liens publics."
    }
  },
  "common": {
    "buttons": "Boutons",
    "change": "Changement",
    "setting": "Paramètre",
    "background": "Contexte",
    "foreground": "Premier plan",
    "edit": "Modifier",
    "remove": "Supprimer",
    "settings": "Paramètres",
    "integrations": "Intégrations",
    "customizations": "Personnalisations",
    "enable": "Activer",
    "logout": "Déconnexion",
    "features": "Caractéristiques",
    "day_one": "{{count}} jour",
    "day_other": "{{count}} jours",
    "files": "Fichiers",
    "received": "Reçu",
    "rename": "Renommer",
    "cancel": "Annuler",
    "cancelUpload": "Annuler le téléchargement",
    "canceled": "Annulé",
    "close": "Fermer",
    "open": "Ouvert",
    "createFolder": "Créer un dossier",
    "openFolder": "Ouvrir le dossier",
    "uploadFolder": "Télécharger le dossier",
    "uploadFile": "Télécharger le fichier",
    "downloadEncrypted": "Téléchargement crypté",
    "createdBy": "Créé par",
    "login": "Connexion",
    "otpCode": "Code OTP",
    "passkeys": "Mots-clés",
    "email": "Courriel",
    "username": "Nom d'utilisateur",
    "emails": "Emails",
    "emailLabel": "Étiquette d'e-mail",
    "emailPlaceholder": "Espace réservé pour l'e-mail",
    "labels": "Étiquettes",
    "inputs": "Entrées",
    "loginLabel": "Étiquette de connexion",
    "resendOtpLabel": "Renvoyer l'étiquette OTP",
    "otpCodeLabel": "Étiquette de code OTP",
    "allUsers": "Tous les utilisateurs",
    "allGroups": "Tous les groupes",
    "globalSearchPlaceholder": "Rechercher des fichiers et des dossiers",
    "folderPickerSearchInFolder": "Rechercher dans ce dossier",
    "globalSearchDescription": "Commencez à taper pour rechercher des fichiers et des dossiers",
    "filterExactMatch": "Correspondance exacte (mot entier)",
    "filterWholeWord": "J'aime la recherche (caractère générique)",
    "loading": "Chargement...",
    "loadingDescription": "Veuillez patienter pendant que nous chargeons vos données",
    "thinking": "En pensant...",
    "thinkingDescription": "AI traite votre demande",
    "noResults": "Aucun résultat trouvé",
    "noFilesFound": "Aucun fichier trouvé",
    "hidden": "Caché",
    "hide": "Masquer",
    "lock": "Verrouiller",
    "file": "Fichier",
    "fileSize": "Taille du fichier",
    "tags": "Étiquettes",
    "tag": "Étiquette",
    "title": "Titre",
    "users": "Utilisateurs",
    "user": "Utilisateur",
    "groups": "Groupes",
    "overview": "Aperçu",
    "mode": "Mode",
    "opacity": "Opacité",
    "includeUserEmail": "Inclure l'e-mail de l'utilisateur",
    "appliesToExternalUsers": "S'applique aux utilisateurs externes",
    "blurOnFocusLoss": "Flou sur perte de concentration",
    "maxExpirationDays": "Expiration maximale (jours)",
    "noRecipients": "Aucun destinataire",
    "createdAt": "Créé à",
    "group": "Groupe",
    "reviewTeam": "Équipe de révision",
    "folder": "Dossier",
    "publicLink": "Lien public",
    "publicLinkTitle": "Lien public de déposant",
    "logs": "Journaux",
    "addUsersOrGroups": "Ajouter des utilisateurs ou des groupes",
    "addUsers": "Ajouter des utilisateurs",
    "userTagInputEmptyPlaceholder": "Commencez à taper pour rechercher des utilisateurs ou des groupes",
    "member": "Membre",
    "member_zero": "Aucun membre",
    "member_other": "Membres",
    "uploaded": "Téléchargé",
    "failed": "Échec",
    "retries": "Nouvelles tentatives",
    "preparingFilesForUpload": "Préparation des fichiers pour le téléchargement",
    "uploadingFilesCounter": "Téléchargement des fichiers {{amount}} sur {{total}}",
    "uploadedFilesCounter": "Téléchargé {{amount}} sur {{total}}",
    "copyLink": "Copier le lien",
    "unhide": "Afficher",
    "licenseLimitation": "Limitation de la licence",
    "deletionDate": "Date de suppression",
    "creationDate": "Date de création",
    "newUser": "Nouvel utilisateur",
    "newGroup": "Nouveau groupe",
    "noActionsAvailable": "Aucune action disponible",
    "author": "Auteur",
    "openProtectedFile": "Ouvrir le fichier protégé",
    "showFilesSharedWith": "Afficher les fichiers partagés avec",
    "showFilesSharedBy": "Afficher les fichiers partagés par",
    "upload": "Télécharger",
    "youCanRequestANewOtpIn": "Vous pouvez demander un nouvel OTP dans",
    "otpExpired": "OTP expiré",
    "otpValidFiveMinutesOnce": "Ce code est valable 5 minutes et ne fonctionne qu'une seule fois.",
    "generateNewOtp": "Générer un nouvel OTP",
    "clickHereToGenerateNewOtp": "Cliquez ici pour générer un nouvel OTP",
    "preparingFileForDownload": "Préparation du fichier pour le téléchargement",
    "preparingForDownload": "Préparation du téléchargement",
    "uploadErrors": "Erreurs de téléchargement",
    "uploadErrorsDescription": "Certains fichiers n'ont pas pu être téléchargés",
    "size": "Taille",
    "status": "Statut",
    "percentage": "Pourcentage",
    "viewer": "Visionneuse",
    "editor": "Éditeur",
    "shareWith": "Partager avec",
    "retry": "Réessayer",
    "regenerate": "Régénérer",
    "permissions": "Autorisations",
    "expiration": "Expiration",
    "message": "Message",
    "uploadingFiles": "Téléchargement de fichiers",
    "addFiles": "Ajouter des fichiers",
    "addFolders": "Ajouter des dossiers",
    "max": "Max.",
    "preview": "Aperçu",
    "write": "Écrire",
    "quickShare": "Partage rapide",
    "maxFilesAmountAndSizeEach": "Max {{amount}} fichiers, {{size}}Mo chacun",
    "startUploadAndShare": "Commencez le téléchargement et partagez",
    "processing": "Traitement",
    "startNewUploadAndShare": "Démarrer un nouveau téléchargement et partager",
    "continue": "Continuer",
    "goToFileManager": "Allez dans le gestionnaire de fichiers",
    "goToQuickShare": "Accédez au partage rapide",
    "viewAll": "Voir tout",
    "emptyUsersList": "Ici vous pouvez trouver les utilisateurs que vous avez ajoutés",
    "emptyGroupsList": "Ici vous pouvez trouver les groupes que vous avez ajoutés",
    "confirmationMessage": "Message de confirmation",
    "lastModified": "Dernière modification",
    "opened": "Ouvert",
    "lastAccess": "Dernier accès",
    "accessExpiration": "Expiration de l'accès",
    "description": "Description",
    "descriptionNotEditable": "La description n'est pas modifiable",
    "sharedItems": "Éléments partagés",
    "sharedItemsCount": "Article partagé {{count}}",
    "sharedItemsCount_other": "Éléments partagés {{count}}",
    "itemsSharedWith": "Éléments partagés avec <strong>{{resource}}</strong>",
    "manageItems": "Gérer les éléments",
    "items": "Articles",
    "visibleToAdminsOnly": "Visible uniquement par les administrateurs",
    "pleaseEnterName": "Veuillez saisir un nom",
    "pleaseEnterFirstName": "Veuillez saisir un prénom",
    "pleaseEnterLastName": "Veuillez saisir un nom de famille",
    "pleaseEnterEmail": "Veuillez saisir un e-mail",
    "invalidEmail": "L'adresse e-mail n'est pas valide",
    "nameCannotBeEmail": "Le nom ne peut pas être une adresse e-mail",
    "publicLinkSearchHint": "La recherche filtre ce dossier après le chargement de toutes les pages",
    "companyTag": "Étiquette d'entreprise",
    "replace": "Remplacer",
    "fileName": "Nom du fichier",
    "enterFileName": "Entrez le nom du fichier",
    "new": "Nouveau",
    "organize": "Organiser",
    "downloadFile": "Télécharger le fichier",
    "expiry": "Expiration",
    "downloadPdf": "Télécharger le PDF",
    "downloadEncryptedFile": "Télécharger le fichier crypté",
    "save": "Enregistrer",
    "createShortcut": "Créer un raccourci",
    "create": "Créer",
    "createShortcutFor": "Créer un raccourci pour {{resource}}",
    "selectFolderToCreateFileShortcut": "Sélectionnez une position pour afficher le chemin du dossier où le fichier sera créé",
    "editUser": "Modifier l'utilisateur",
    "unblockUser": "Débloquer l'utilisateur",
    "blockUser": "Bloquer l'utilisateur",
    "deleteUser": "Supprimer un utilisateur",
    "excludeFromSso": "Exclure de l'authentification unique",
    "includeInSso": "Réactiver l'authentification unique",
    "confirm": "Confirmer",
    "search": "Rechercher",
    "noUsersFound": "Aucun utilisateur trouvé",
    "noSettingsFound": "Aucun paramètre trouvé",
    "block": "Bloquer",
    "unblock": "Débloquer",
    "role": "Rôle",
    "addedOn": "Ajouté",
    "memberOfNGroups": "Membre des groupes N°",
    "noExpirationDate": "Pas de date d'expiration",
    "groupsMember": "Membre des groupes",
    "onBehalfOf": "Au nom de",
    "exitFromBehalfOfMode": "Quitter le mode compte",
    "expiryDate": "Date d'expiration",
    "select": "Sélectionnez",
    "nothingHasBeenSharedYet": "Rien n'a encore été partagé",
    "manageGroups": "Gérer les groupes",
    "noGroupsYet": "Aucun groupe pour l'instant",
    "addExpirationDate": "Ajouter une date d'expiration",
    "editExpirationDate": "Modifier la date d'expiration",
    "edited": "Modifié",
    "removed": "Supprimé",
    "removeExpirationDate": "Supprimer la date d'expiration",
    "usersWithSharedFiles": "Utilisateurs avec des fichiers partagés",
    "usersWithoutSharedFiles": "Utilisateurs sans fichiers partagés",
    "changeRole": "Changer de rôle",
    "yes": "Oui",
    "no": "Non",
    "selected": "Sélectionné",
    "editGroup": "Modifier le groupe",
    "viewGroup": "Afficher le groupe",
    "numberOfMembers": "N° de membres",
    "numberOfMembersInline": "{{count}} membre",
    "numberOfMembersInline_one": "{{count}} membre",
    "numberOfMembersInline_other": "{{count}} membres",
    "groupMembers": "Membres du groupe",
    "editGroups": "Modifier les groupes",
    "noUsers": "Aucun utilisateur",
    "deleteGroup": "Supprimer le groupe",
    "documents": "Documents",
    "images": "Images",
    "audio": "Audio",
    "video": "Vidéo",
    "other": "Autre",
    "fileExtensionType": {
      "Text": "Texte",
      "SourceCode": "Code source",
      "Markup": "Balisage",
      "Data": "Données",
      "Image": "Images",
      "Video": "Vidéo",
      "Audio": "Audio",
      "Document": "Documenter",
      "Spreadsheet": "Feuille de calcul",
      "Presentation": "Présentation",
      "Archive": "Archiver",
      "Database": "Base de données",
      "Font": "Police",
      "System": "Système",
      "Executable": "Exécutable",
      "Configuration": "Configuration",
      "Log": "Journal",
      "Backup": "Sauvegarde",
      "Certificate": "Certificat",
      "Model3D": "Modèle 3D",
      "CAD": "CAD",
      "GIS": "GIS",
      "Scientific": "Scientifique",
      "EBook": "Livre électronique",
      "Vector": "Vecteur",
      "Raw": "Brut"
    },
    "fileTypes": "Types de fichiers",
    "download": "Télécharger",
    "share": "Partager",
    "createCopy": "Créer une copie",
    "markAsRead": "Marquer comme lu",
    "markAsUnread": "Marquer comme non lu",
    "move": "Déplacer",
    "convertToPdf": "Convertir en PDF",
    "convert": "Convertir",
    "wordDocument": "Document Word",
    "excelDocument": "Document Excel",
    "pptDocument": "Document PowerPoint",
    "hideFromList": "Masquer de la liste",
    "showInList": "Afficher dans la liste",
    "editAccessAndProtections": "Modifier l'accès et les protections",
    "tagColor": "Couleur de l'étiquette",
    "tagName": "Nom de l'étiquette",
    "addToFavorites": "Ajouter aux favoris",
    "removeFromFavorites": "Supprimer des favoris",
    "deletePermanently": "Supprimer définitivement",
    "delete": "Supprimer",
    "selectedItems": "Articles sélectionnés",
    "deselectAll": "Tout désélectionner",
    "signOut": "Se déconnecter",
    "tagTitle": "Titre de l'étiquette",
    "noTagsYet": "Pas encore d'étiquettes",
    "untitledDocument": "Document sans titre",
    "copyOf": "Copie de",
    "restoreFromTrash": "Restaurer à partir de la corbeille",
    "shared": "Partagé",
    "expiresOn": "Expire le {{date}}",
    "shareExpiredOn": "Partage expiré le {{date}}",
    "favourite": "Favoris",
    "favouriteAddedTo": "ajouté à",
    "favouriteRemovedFrom": "retiré de",
    "publicLinkLabel": "Lien public",
    "classificationInProgress": "Classement en cours",
    "forSale": "À vendre",
    "favorites": "Favoris",
    "recent": "Récents",
    "transferOwnership": "Transférer la propriété",
    "trash": "Corbeille",
    "expirationDate": "Date d'expiration",
    "details": "Détails",
    "unlock": "Déverrouiller",
    "activities": "Activités",
    "copyToClipboard": "Copier dans le presse-papier",
    "fileType": "Type de fichier",
    "noTagsApplied": "Aucune étiquette n'a été appliquée à ce fichier",
    "notSharedYet": "Pas encore partagé",
    "manageAccess": "Gérer l'accès",
    "selectItemToViewDetails": "Sélectionnez un élément pour afficher ses détails",
    "unlockFolderToViewDetails": "Déverrouillez le dossier pour afficher les détails",
    "unlockFolderToViewSize": "Déverrouillez le dossier pour afficher la taille",
    "folderContent": "Contenu du dossier",
    "calculateFolderSize": "Calculer la taille",
    "recalculate": "Recalculer",
    "recalculateCooldown": "Veuillez patienter un moment avant de recalculer",
    "subfolders": "Sous-dossiers",
    "totalSize": "Taille totale",
    "filters": "Filtres",
    "owner": "Propriétaire",
    "linkCopied": "Lien copié dans le presse-papier !",
    "account": "Compte",
    "customization": "Personnalisation",
    "adminRegisteredUserVisibility": "Visibilité des utilisateurs enregistrés par l'administrateur",
    "adminRegisteredUserVisibilityDescription": "Rendre les utilisateurs enregistrés par l'administrateur visibles à moins qu'ils ne soient désactivés ; visibilité via le partage de fichiers uniquement.",
    "autoFileDeletion": "Suppression automatique des fichiers",
    "autoFileDeletionDescription": "Supprimez automatiquement les fichiers après une date de création et une période de conservation spécifiées.",
    "cannotOpenFileOnBehalf": "Vous ne pouvez pas ouvrir de fichiers au nom du mode.",
    "certifiedTimestamping": "Horodatage certifié",
    "certifiedTimestampingDescription": "Autorisez les contributeurs à appliquer une date certifiée aux fichiers à l’aide d’un certificat numérique.",
    "compressionCompleted": "Compression terminée",
    "compressionFailed": "Échec de la compression",
    "compressionOfFilesInProgress": "Compression des fichiers en cours",
    "verifyingFileIntegrity": "Vérification de l'intégrité des fichiers...",
    "fileIntegrityVerified": "Intégrité des fichiers vérifiée",
    "downloadCompletedWithExclusions": "Téléchargement terminé, mais certains fichiers ont été exclus",
    "moveCompletedWithExclusions": "Déplacement terminé, mais certains fichiers n'ont pas pu être déplacés",
    "filesExcludedForMove": "Les fichiers suivants n'ont pas pu être déplacés :",
    "excludedFilesTitle": "Fichiers exclus",
    "viewExcludedFiles": "Afficher les fichiers exclus",
    "filesExcludedForRestrictions": "Certains fichiers ont été exclus en raison de restrictions :",
    "contributorStorageLimit": "Limite de stockage des contributeurs",
    "contributorStorageLimitDescription": "Définissez des limites d’espace de stockage pour que les contributeurs puissent télécharger de nouveaux fichiers.",
    "contents": "Contenu",
    "deviceAccessLimitation": "Limitation de l'accès aux appareils",
    "deviceAccessLimitationDescription": "Limitez l’accès à un certain nombre d’appareils et déconnectez les plus anciens.",
    "downloadPreparation": "Préparation du téléchargement",
    "downloadReady": "Téléchargement prêt",
    "editorFileManagement": "Gestion des fichiers de l'éditeur",
    "editorFileManagementDescription": "Autoriser les contributeurs à supprimer et renommer des fichiers selon les autorisations.",
    "fileSizeLimit": "Limite de taille de fichier",
    "fileSizeLimitDescription": "Limitez la taille maximale de chaque fichier pouvant être téléchargé.",
    "folderCreationPermission": "Autorisation de création de dossier",
    "folderCreationPermissionDescription": "Définissez si les contributeurs sont autorisés à créer de nouveaux dossiers.",
    "groupCreationControl": "Contrôle de création de groupe",
    "groupCreationControlDescription": "Contrôlez quels contributeurs sont autorisés à créer des groupes.",
    "members": "Membres",
    "msOfficeEditing": "Édition Word, Excel, Powerpoint",
    "msOfficeEditingDescription": "Autorisez les membres à modifier des documents directement avec l'éditeur en ligne Microsoft Office.",
    "newButton": "Nouveau",
    "security": "Sécurité",
    "sessionControl": "Contrôle de session",
    "sessionControlDescription": "Limitez le nombre de sessions simultanées par utilisateur.",
    "sessions": "Séances",
    "superAdmins": "Super administrateurs",
    "uploadWithTag": "Télécharger avec étiquette",
    "uploadWithTagDescription": "Capturez et définissez automatiquement les étiquettes détectées sur les fichiers sources.",
    "withExpiration": "Avec expiration",
    "withoutExpiration": "Sans péremption",
    "addTag": "Ajouter une étiquette",
    "openFileLocation": "Emplacement du fichier ouvert",
    "loadingTags": "Chargement des étiquettes...",
    "unlimited": "Illimité",
    "dropHereYourFirstFile": "Déposez ici votre premier fichier",
    "noFilesReceived": "Aucun fichier reçu",
    "hereYouCanFindFavoritesFiles": "Ici vous pouvez trouver vos fichiers préférés",
    "noRecentlyOpenedFiles": "Aucun fichier ouvert récemment",
    "hereYouCanFindSharedFiles": "Ici vous pouvez trouver des fichiers partagés",
    "hereYouCanFindDeletedFiles": "Ici vous pouvez trouver les fichiers supprimés",
    "noFiles": "Aucun fichier",
    "loadingFiles": "Chargement des fichiers...",
    "filesFetchFailed": "Impossible de charger les fichiers. Vérifiez votre connexion et réessayez.",
    "shareDisabledNoRecipients": "Ajoutez au moins un utilisateur ou un groupe pour partager",
    "shareDisabledNoChanges": "Aucune modification à enregistrer",
    "editorDisabledByPolicy": "L'autorisation Éditeur n'est pas autorisée pour ces fichiers",
    "editorDisabledCannotElevate": "Vous ne pouvez pas élever ce partage en Éditeur",
    "hereYouCanFindHiddenFiles": "Ici vous pouvez trouver des fichiers cachés",
    "noFilesInThisFolder": "Aucun fichier dans ce dossier",
    "noGroupsFound": "Aucun groupe trouvé",
    "sell": "Vendre",
    "loadingPermissions": "Chargement des autorisations...",
    "me": "Moi",
    "applyTags": "Appliquer des étiquettes",
    "emptyTrash": "Vider la poubelle",
    "classify": "Classement de l'IA",
    "active": "Actif",
    "activeDescription": "Activer ou désactiver ce paramètre",
    "add": "Ajouter",
    "rule": "Règle",
    "selectTags": "Sélectionnez les étiquettes",
    "manageExceptions": "Gérer les exceptions",
    "selectFolders": "Sélectionner des dossiers",
    "selectUsers": "Sélectionnez les utilisateurs",
    "selectGroups": "Sélectionnez des groupes",
    "selectDate": "Sélectionnez une date",
    "none": "Aucun",
    "addRule": "Ajouter une règle",
    "addConfiguration": "Ajouter une configuration",
    "aiAgents": "Agents IA",
    "daysLeft": "jours restants",
    "disabled": "Désactivé",
    "enabled": "Activé",
    "months": "Mois",
    "years": "Années",
    "totpStatus": {
      "enabled": "2FA actif",
      "enabledExempt": "2FA actif (exempt)",
      "exempt": "Exonéré du 2FA",
      "exemptExpires": "Exonéré jusqu'à {{date}}"
    },
    "clientId": "Identifiant client",
    "clientSecret": "Secret client",
    "tenantId": "ID du locataire",
    "domains": "Domaines",
    "addDomain": "Ajouter un domaine",
    "addItem": "Ajouter un article",
    "artificialIntelligence": "Intelligence artificielle",
    "artificialIntelligenceSummary": "Résumé de l'IA",
    "artificialIntelligenceDocumentChat": "Discutez avec le document",
    "generatingSummary": "Générer un résumé",
    "startNewConversation": "Démarrer une nouvelle conversation",
    "groupMembership": "Appartenance à un groupe",
    "expired": "Expiré",
    "sharedBy": "Partagé par",
    "shareRequests": "Demandes de partage",
    "fileShareRequests": "Demandes de partage de fichiers",
    "noShareRequests": "Aucune demande de partage",
    "activityLog": "Journal d'activité",
    "targetType": "Type de cible",
    "operationType": "Type d'opération",
    "fromDate": "À partir du jour",
    "toDate": "À ce jour",
    "classificationStatus": "Classement IA",
    "invite": "Inviter",
    "send": "Envoyer",
    "target": "Cible",
    "operation": "Fonctionnement",
    "timestamp": "Horodatage",
    "export": "Exporter",
    "exportActivityLogsDescription": "Exporter les journaux d'activité visibles vers un fichier CSV",
    "clickForDetailAiClassification": "Cliquez pour plus de détails sur la classification AI",
    "aiClassificationStatus": "Statut de classification de l'IA",
    "noActivityLogsFound": "Aucun journal d'activité trouvé",
    "activityLogQuickFilters": {
      "clearDatesAndOperation": "Effacer les filtres de date et de type",
      "downloads24h": "Téléchargements de fichiers au cours des dernières 24 heures",
      "failedLogins7d": "Échec de connexion au cours des 7 derniers jours",
      "last24hAllActivity": "Toute activité au cours des dernières 24 heures",
      "last24hLogins": "Connexions au cours des dernières 24 heures",
      "last7DaysAllActivity": "Toutes les activités des 7 derniers jours",
      "sharing7d": "Partage de fichiers au cours des 7 derniers jours",
      "title": "Préréglages de filtres rapides"
    },
    "waitingForUpload": "En attente de téléchargement",
    "waitingForNetwork": "En attente du réseau",
    "uploadsPausedWaitingForNetwork": "Téléchargements suspendus – en attente de connexion réseau",
    "offline": "Hors ligne",
    "noPermissions": "Aucune autorisation",
    "additionalData": "Données supplémentaires",
    "noActivities": "Aucune activité",
    "multipleOwners": "Plusieurs propriétaires",
    "mixed": "Mixte",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "multipleExpiryDates": "Plusieurs dates d'expiration",
    "copied": "Copié!",
    "copy": "Copier",
    "editFile": "Modifier le fichier",
    "untitled": "Sans titre",
    "editModeEnabled": "Mode édition activé",
    "exitEditMode": "Quitter le mode édition",
    "editModeDisabled": "Mode édition désactivé",
    "reload": "Recharger",
    "forward10Seconds": "Avancer de 10 secondes",
    "backward10Seconds": "Recul de 10 secondes",
    "goToStart": "Allez pour commencer",
    "goToEnd": "Aller à la fin",
    "playbackSpeed": "Vitesse de lecture",
    "error": "Erreur",
    "shareAgain": "Partager à nouveau",
    "expiringSoon": "Expire bientôt",
    "filterByTargetOrOperation": "Filtrer par cible ou opération",
    "searchByFileName": "Rechercher par nom de fichier",
    "versions": "Versions",
    "version": "Version",
    "restore": "Restaurer",
    "showMoreVersions": "Afficher plus de versions",
    "showLessVersions": "Afficher moins de versions",
    "currentVersion": "Version actuelle",
    "bold": "Audacieux",
    "italic": "Italique",
    "link": "Lien",
    "unorderedList": "Liste non ordonnée",
    "orderedList": "Liste ordonnée",
    "header1": "En-tête 1",
    "header2": "En-tête 2",
    "header3": "En-tête 3",
    "paragraph": "Paragraphe",
    "secondsAgo": "il y a quelques secondes",
    "all": "Tout",
    "dataLossPrevention": "Prévention de la perte de données",
    "uploadSuccess": "Téléchargement réussi",
    "uploading": "Téléchargement",
    "readOnly": "Lecture seule",
    "aiScrapingProtectionOn": "Protection contre le grattage de l'IA activée",
    "openFileLocally": "Ouvrir le fichier localement",
    "reloadPage": "Recharger la page",
    "reloadingPageIn": "Rechargement de la page en <strong>{{count}}</strong>",
    "keepOffline": "Synchroniser sur l'appareil",
    "openFileOnline": "Ouvrir le dossier en ligne",
    "saveAndContinue": "Enregistrer et continuer",
    "cancelAndContinue": "Annuler et continuer",
    "language": "Langue",
    "colorScheme": {
      "title": "Apparence",
      "light": "Lumière",
      "dark": "Sombre",
      "system": "Suivre le système"
    },
    "accessibility": {
      "title": "Accessibilité",
      "highContrast": "Contraste élevé",
      "reduceMotion": "Réduire les mouvements",
      "none": "Désactivé",
      "activeCount": "{{count}} activé"
    },
    "impersonateUser": "Usurper l'identité d'un utilisateur",
    "protect": "Protéger",
    "setPassword": "Définir le mot de passe",
    "password": "Mot de passe",
    "stopImpersonation": "Arrêtez l'usurpation d'identité",
    "loggedInAs": "Connecté en tant que",
    "enterReason": "Entrez le motif de l'usurpation d'identité...",
    "timeRemaining": "Temps restant",
    "notifications": "Notifications",
    "clear": "Effacer",
    "markAllRead": "Marquer tout comme lu",
    "clearAll": "Tout effacer",
    "noNotifications": "Aucune notification",
    "batches": "Lots",
    "noActiveBatches": "Aucun lot actif",
    "refresh": "Actualiser",
    "refreshCooldown": "Veuillez attendre {{seconds}}s avant d'actualiser à nouveau",
    "minutes": "minutes",
    "justNow": "Juste maintenant",
    "minutesAgo": "il y a {{count}} minute",
    "minutesAgo_other": "il y a {{count}} minutes",
    "hoursAgo": "il y a {{count}} heure",
    "hoursAgo_other": "Il y a {{count}} heures",
    "daysAgo": "il y a {{count}} jour",
    "daysAgo_other": "il y a {{count}} jours",
    "monthsAgo": "il y a {{count}} mois",
    "monthsAgo_other": "il y a {{count}} mois",
    "yearsAgo": "il y a {{count}} an",
    "yearsAgo_other": "il y a {{count}} ans",
    "fileNotFound": "Fichier introuvable",
    "selectAll": "Tout sélectionner",
    "clearSelection": "Effacer la sélection",
    "import": "Importer",
    "noFilesMatchingFilters": "Aucun fichier ne correspond aux filtres, essayez de supprimer certains filtres ou de modifier les critères de recherche",
    "noUsersMatchingFilters": "Aucun utilisateur ne correspond aux filtres, essayez de supprimer certains filtres ou de modifier les critères de recherche",
    "noGroupsMatchingFilters": "Aucun groupe ne correspond aux filtres, essayez de supprimer certains filtres ou de modifier les critères de recherche",
    "AIGrant": "AIGrant",
    "emailGrant": "E-mailGrant",
    "searchTags": "Rechercher des étiquettes",
    "manageUsersAndGroups": "Gérer les utilisateurs et les groupes",
    "public": "Publique",
    "private": "Privé",
    "approved": "Approuvé",
    "rejected": "Rejeté",
    "pending": "En attente",
    "pendingApprovalTooltip": "En attente d'approbation, demandé {{date}}",
    "approvedByTeamTooltip": "Partage approuvé par l'équipe {{date}}",
    "rejectedByTeamTooltip": "Partage rejeté par l'équipe {{date}}",
    "reject": "Rejeter",
    "rejectFileShareRequest": "Rejeter la demande de partage de fichiers",
    "rejectionReason": "Motif du rejet",
    "rejectionReasonPlaceholder": "Entrez le motif du refus",
    "moreOwners": "Plus de propriétaires",
    "permissionLevel": "Niveau d'autorisation",
    "name": "Nom",
    "approve": "Approuver",
    "from": "De",
    "to": "à",
    "requester": "Demandeur",
    "shareTo": "Partager avec",
    "limitation": "Limitation",
    "selectRequestToViewDetails": "Sélectionnez une demande pour afficher les détails",
    "shareRequestApprovalTitle": "Partager l'approbation de la demande pour {{fileName}}",
    "noFilesAvailable": "Aucun fichier disponible",
    "accessDenied": "Accès refusé",
    "fileShareRequestsList": "Liste des demandes de partage de fichiers",
    "fileShareRequestsDescription": "Approuvez ou rejetez les demandes de partage de fichiers. Cliquez sur une demande sur le côté gauche pour voir ses détails.",
    "waiting": "En attente",
    "tagIsUsedForFileVisibility": "Les fichiers avec cette étiquette sont partagés avec d'autres utilisateurs comme défini dans le paramètre Visibilité des fichiers balisés",
    "systemTagLocked": "Étiquette système gérée par le serveur : ne peut pas être supprimée.",
    "tagRemovalRestricted": "Votre administrateur n'autorise pas la suppression de cette étiquette des fichiers.",
    "tagAdditionRestricted": "Votre administrateur n'autorise pas l'ajout de cette étiquette aux fichiers.",
    "completingLogin": "Finalisation de la connexion...",
    "redirectingToLogin": "Redirection vers la connexion...",
    "redirecting": "Redirection...",
    "twoFactorAuthentication": "2FA",
    "debug": "Débogage",
    "sessionExpiresIn": "Ce dossier sera à nouveau verrouillé dans {{time}}",
    "protectedFolder": "Dossier protégé",
    "sessionsTitle": "Débloquez des sessions pour {{fileName}}",
    "folderSessions": "Sessions de dossiers",
    "publicLinks": "Liens publics",
    "revoke": "Révoquer",
    "revokeLink": "Révoquer le lien public",
    "revokeLinkConfirmDescription": "Révoquer le lien public pour {{fileName}} ?",
    "protectedContentTitle": "Contenu protégé",
    "protectedContentMessage": "Ce contenu est protégé par un mot de passe. Entrez le mot de passe pour y accéder.",
    "accessCodeRequired": "Un mot de passe est requis.",
    "accessCodeLabel": "Mot de passe",
    "accessCodePlaceholder": "Entrez le mot de passe",
    "access": "Accès",
    "folderContents": "Contenu du dossier",
    "sharedAt": "Partagé sur",
    "alerts": {
      "moreCount": "{{count}} plus d'alertes",
      "manageTwoFactor": "Gérer 2FA",
      "dismissMenu": "Répéter ou ignorer",
      "snoozePreset": {
        "h24": "1 jour",
        "h72": "3 jours",
        "h168": "1 semaine"
      },
      "snoozeHoursGeneric": "{{count}} heures"
    },
    "usersFetchFailed": "Impossible de charger les utilisateurs. Vérifiez votre connexion et réessayez.",
    "groupsFetchFailed": "Impossible de charger les groupes. Vérifiez votre connexion et réessayez.",
    "emailsFetchFailed": "Impossible de charger les e-mails. Vérifiez votre connexion et réessayez.",
    "pleaseSelectRole": "Veuillez sélectionner un rôle",
    "selectColor": "Sélectionner une couleur",
    "color": "Couleur",
    "loadingActivities": "Chargement des activités...",
    "quickShareMessagePlaceholder": "Écrivez un message aux utilisateurs sélectionnés...",
    "signFile": "Signer le fichier"
  },
  "roles": {
    "1000": "Super administrateur",
    "1001": "Administrateur",
    "2001": "Contributeur",
    "3002": "Lecteur",
    "4001": "Externe"
  },
  "accessMap": {
    "tagAccessTabLabel": "Accès et protections",
    "entityAccessTabLabel": "Étiquettes et protections",
    "visibility": "Visibilité",
    "appliedProtections": "Protections appliquées",
    "appliedTo": "Appliqué à",
    "appliedToNobody": "Personne ne bénéficie actuellement de cette protection via cette étiquette.",
    "configuration": "Configuration",
    "exceptions": "Exceptions",
    "exceptionsCount": "{{count}} exception",
    "exceptionsCount_one": "{{count}} exception",
    "exceptionsCount_other": "{{count}} exception",
    "hasExceptionsTooltip": "Certains destinataires sont exclus de cette protection.",
    "openInSettings": "Ouvrir dans les paramètres",
    "otherTagsInSetting": "Autres étiquettes qui activent cette protection",
    "noProtectionsForTag": "Aucune protection n'est encore appliquée à cette étiquette.",
    "noProtectionsForThisTag": "Aucune protection héritée de cette étiquette.",
    "configureProtection": "Configurer une protection",
    "publicTagShort": "Publique",
    "privateTagShort": "Privé",
    "allUsersInCompany": "Tous les utilisateurs de l'entreprise",
    "tagNotShared": "Cette étiquette n’est encore partagée avec personne.",
    "protectionsCount": "{{count}} protection",
    "protectionsCount_one": "{{count}} protection",
    "protectionsCount_other": "{{count}} protection",
    "inheritedFromGroups": "Visible via les groupes : {{groups}}",
    "tagsVisibleToGroup": "Tags visibles par ce groupe ({{count}})",
    "tagsVisibleToUser": "Étiquettes visibles par cet utilisateur ({{count}})",
    "rulesAppliedToGroup": "Règles de protection appliquées à ce groupe ({{count}})",
    "rulesAppliedToUser": "Règles de protection appliquées à cet utilisateur ({{count}})",
    "userSeesNoTags": "Cet utilisateur ne voit aucune étiquette.",
    "groupSeesNoTags": "Ce groupe ne voit aucune étiquette.",
    "tagNoRulesLead": "Les fichiers avec cette étiquette n'activent aucune règle spécifique pour ce groupe.",
    "tagRulesLead": "Les fichiers avec cette étiquette activent la règle suivante :",
    "tagRulesLead_one": "Les fichiers avec cette étiquette activent la règle suivante :",
    "tagRulesLead_other": "Les fichiers avec cette étiquette activent les règles {{count}} suivantes :",
    "summary": {
      "action": "Action",
      "behaviour": "Comportement",
      "readOnlyRoles": "Rôles en lecture seule",
      "showRecipients": "Afficher les destinataires d'origine",
      "allowEdit": "Autoriser la modification",
      "readOnlyMode": "Mode lecture seule",
      "watermarkText": "Texte en filigrane",
      "placement": "Poste",
      "appliesToExternal": "Application par les utilisateurs externes",
      "approvedDomains": "Domaines approuvés",
      "maxExpirationDays": "Durée maximale autorisée",
      "excludedDomains": "Domaines exclus",
      "excludedGroups": "Groupes exclus",
      "requireApprovalOnShare": "Exigence générale d’approbation",
      "requireApprovalOnReshare": "Approbation pour les fichiers repartagés uniquement",
      "reviewTeamSize": "Équipe de révision",
      "hiddenFileTypes": "Invisible après le partage",
      "allowedApplications": "Applications autorisées",
      "rolesAllowed": "Public"
    }
  },
  "alerts": {
    "codes": {
      "TOTP_NOT_ENABLED": {
        "message": "Une authentification à deux facteurs est requise. Activez-le pour sécuriser votre compte."
      },
      "LICENSE_EXPIRING": {
        "message": "Votre licence expire le {{expirationDate}} ({{daysRemaining}} jours restants)."
      },
      "LOW_BACKUP_CODES": {
        "message": "Il vous reste quelques codes de sauvegarde ({{remaining}}). Régénérez-les dans des paramètres à deux facteurs."
      },
      "_generic": {
        "message": "Vous avez un avis actif ({{code}}). Contactez votre administrateur si vous avez besoin d'aide."
      }
    }
  },
  "errors": {
    "required": "Ce champ est obligatoire",
    "minLength": "Doit contenir au moins {{min}} caractères",
    "authenticatorCodeInvalid": "Le code d'authentification n'est pas valide.",
    "authenticatorNotRemoved": "Une erreur s'est produite lors de la suppression de l'authentificateur.",
    "authenticationUserBlocked": "L'utilisateur est bloqué. Veuillez contacter l'administrateur.",
    "authenticationUserExpired": "L'utilisateur a expiré. Veuillez contacter l'administrateur.",
    "codeIncorrect": "Le code que vous avez entré est incorrect. Veuillez réessayer.",
    "genericDeleteError": "Une erreur s'est produite lors de la suppression de {{resource}}. Veuillez réessayer ou contacter l'assistance si le problème persiste.",
    "genericError": "Une erreur s'est produite. Veuillez réessayer ou contacter l'assistance si le problème persiste.",
    "genericFetchError": "Une erreur s'est produite lors de la récupération de {{resource}}. Veuillez réessayer ou contacter l'assistance si le problème persiste.",
    "userProfileUnavailable": "Nous n'avons pas pu charger votre profil. Vous restez connecté avec des autorisations limitées jusqu'à ce que ce problème soit résolu.",
    "userProfileStale": "Nous n'avons pas pu actualiser votre profil. Vous êtes toujours connecté avec vos dernières autorisations connues.",
    "userProfileRetry": "Réessayer",
    "alerts": {
      "dismissFailed": "Impossible de mettre à jour cette alerte. Veuillez réessayer.",
      "invalidSnooze": "Choisissez une durée de répétition valide.",
      "fetchFailed": "Impossible de charger les alertes. Ils réessayeront automatiquement."
    },
    "sessionsFetchError": "Erreur lors de la récupération des sessions.",
    "sessionsRevokeError": "Erreur lors de la révocation de la session.",
    "sessionsRevokeForbiddenError": "Vous n'êtes pas autorisé à révoquer les sessions de cet utilisateur.",
    "sessionsRevokeOthersError": "Erreur lors de la révocation d'autres sessions.",
    "sessionsRevokeAllError": "Erreur lors de la révocation de toutes les sessions.",
    "genericUpdateError": "Une erreur s'est produite lors de la mise à jour de {{resource}}. Veuillez réessayer ou contacter l'assistance si le problème persiste.",
    "genericCreateError": "Une erreur s'est produite lors de la création de {{resource}}. Veuillez réessayer ou contacter l'assistance si le problème persiste.",
    "invalidCredentials": "Email ou mot de passe incorrect. Veuillez vérifier vos informations d'identification et réessayer.",
    "invalidUsername": "Le nom d'utilisateur que vous avez entré n'est pas valide.",
    "tokenInvalid": "Le jeton fourni n'est pas valide ou a expiré.",
    "tokenExpired": "Jeton d'accès expiré",
    "unsavedChangesMessage": "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter et perdre ces modifications ?",
    "unsavedChangesTitle": "Modifications non enregistrées détectées.",
    "licenseExpired": "La licence a expiré. Veuillez renouveler votre licence.",
    "licenseMaxUsersReached": "Le nombre maximum d'utilisateurs pour cette licence a été atteint. Vous ne pouvez pas ajouter de nouveaux utilisateurs ni attribuer des rôles non externes aux utilisateurs existants.",
    "mandatoryClassificationCannotRemove": "Vous ne pouvez pas supprimer toutes les étiquettes de classification. Au moins une étiquette doit rester car la classification obligatoire des fichiers est activée dans les paramètres de votre organisation.",
    "tagRemovalDenied": "Vous n'êtes pas autorisé à supprimer une ou plusieurs des étiquettes sélectionnées de ce fichier.",
    "tagAdditionDenied": "Vous n'êtes pas autorisé à ajouter une ou plusieurs des étiquettes sélectionnées à ce fichier.",
    "emailNotFound": "L'adresse e-mail {{email}} n'est pas enregistrée. Veuillez vérifier votre adresse e-mail et réessayer.",
    "otpExpired": "L'OTP a expiré. Veuillez demander un nouvel OTP.",
    "totpWrong": "Code 2FA invalide. Veuillez réessayer.",
    "temporaryTotpExpired": "Le temps nécessaire pour terminer la connexion a expiré.",
    "errorAdminTotpResetNotAllowed": "Impossible de désactiver 2FA : votre organisation n'autorise pas les administrateurs à réinitialiser le TOTP de l'utilisateur. Un super administrateur peut autoriser cela dans les paramètres d'authentification à deux facteurs (TOTP).",
    "transferOwnershipFailed": "La propriété n'a pas pu être transférée. Veuillez réessayer ou contacter l'assistance.",
    "otpRequestLimitExceeded": "Vous avez dépassé la limite de demande d'OTP. Veuillez réessayer plus tard.",
    "requestFilePermissions": "Essayez de contacter le propriétaire du fichier pour renouveler vos autorisations",
    "noUploadPermission": "Vous n'êtes pas autorisé à télécharger des fichiers à cet emplacement.",
    "publicLinkClassificationRequired": "Le fichier doit être classifié avant de créer un lien public.",
    "publicLinkPasswordRequired": "Un mot de passe est requis pour les liens publics.",
    "publicLinkMaxAccessCountRequired": "Un nombre maximum d’accès est requis.",
    "publicLinkExpirationRequired": "Une date d'expiration est requise.",
    "publicLinkExpirationExceeded": "L'expiration dépasse le nombre maximum de jours autorisé.",
    "publicLinkExpirationInPast": "La date d'expiration doit être une date ultérieure.",
    "publicLinkFolderPasswordProtected": "Impossible de créer un lien public pour les dossiers protégés par mot de passe ou pour les fichiers qu'ils contiennent. Pour partager via un lien public, supprimez la protection par mot de passe du dossier.",
    "publicLinkDownloadRestricted": "Impossible de créer un lien public car Download Encryption Enforcement est actif pour ce fichier ou ses étiquettes. Pour partager via un lien public, supprimez la restriction du paramètre Download Encryption Enforcement.",
    "publicLinkAnticaptureActive": " Impossible de créer un lien public car le mode Anti-capture est actif pour ce fichier ou ses étiquettes. Pour partager via un lien public, supprimez Anti-capture du fichier ou des paramètres d'étiquette applicables.",
    "publicLinkExternalSharingRestricted": "Impossible de créer un lien public car des restrictions de partage externe sont actives pour ce fichier ou ses étiquettes. Pour partager via un lien public, supprimez les limites applicables dans le paramètre Restrictions de partage externe.",
    "publicLinkResharingDenied": "Impossible de créer un lien public car le repartage n'est pas autorisé pour ce fichier ou ses étiquettes. Pour partager via un lien public, vérifiez et mettez à jour le paramètre Autorisations de repartage de fichiers.",
    "publicLinkDownloadTagsRestricted": "Impossible de créer un lien public car des restrictions de téléchargement sont actives pour ce fichier ou ses étiquettes. Pour partager via un lien public, vérifiez le paramètre Télécharger les étiquettes autorisées.",
    "publicLinkApprovalRequired": "Impossible de créer un lien public car une approbation de partage est requise pour ce fichier ou ses étiquettes. Pour partager via un lien public, consultez le paramètre Exigences d'approbation de partage.",
    "publicLinkMandatoryExpiration": "Impossible de créer un lien public car la politique d'expiration obligatoire est active pour ce fichier ou ses étiquettes. Pour partager via un lien public, assurez-vous que la date d'expiration est dans la limite définie dans le paramètre Expiration obligatoire du fichier partagé.",
    "tagsAmountLimitReached": "Vous ne pouvez pas créer plus de {{limit}} étiquettes.",
    "hitASnag": "Oh-oh ! Il y a là un problème. Veuillez réessayer...",
    "noPermission": "Vous n'êtes pas autorisé à effectuer cette action.",
    "errorDownloadFile": "Un problème est survenu lors du téléchargement du fichier. Veuillez réessayer.",
    "errorDuplicateFile": "Un problème est survenu lors de la duplication du fichier. Veuillez réessayer.",
    "errorMoveFile": "Un problème est survenu lors du déplacement du fichier. Veuillez réessayer.",
    "denyFileMove": "Le déplacement n'est pas autorisé pour ce fichier.",
    "errorDeleteFiles": "Un problème est survenu lors de la suppression des fichiers. Veuillez réessayer.",
    "errorHideFiles": "Un problème est survenu lors du masquage des fichiers. Veuillez réessayer.",
    "errorUploadFile": "Un problème est survenu lors du téléchargement du fichier. Veuillez réessayer.",
    "cannotAddArchivedFilesToFavorites": "Les fichiers archivés ne peuvent pas être ajoutés aux favoris.",
    "cannotDeleteMultiplePasswordProtected": "Impossible de supprimer les éléments sélectionnés car plusieurs dossiers protégés par mot de passe sont verrouillés. Veuillez déverrouiller chaque dossier individuellement et réessayer.",
    "cannotUnlockMultiplePasswordProtected": "Impossible de déverrouiller plusieurs dossiers protégés par mot de passe à la fois. Veuillez déverrouiller chaque dossier individuellement.",
    "groupNameCannotBeEmail": "Le nom du groupe ne peut pas être une adresse e-mail.",
    "invalidFolder": "Ce dossier n'est pas valide.",
    "invalidFolderUpload": "Le dossier que vous essayez de télécharger n'existe pas ou n'est pas pris en charge.",
    "zeroByteFileNotUploaded": "Les fichiers de zéro octet ne sont pas téléchargés. Veuillez sélectionner les fichiers avec du contenu.",
    "loginFailed": "La connexion a échoué",
    "unauthorized": "L'authentification a échoué. Veuillez réessayer.",
    "forbidden": "Accès refusé",
    "serverError": "Erreur de serveur. Veuillez réessayer plus tard.",
    "tooManyRequests": "Trop de demandes. Veuillez réessayer plus tard.",
    "oauthAccessDenied": "Accès refusé par l'utilisateur",
    "oauthInvalidCallback": "Rappel OAuth invalide",
    "oauthStateMismatch": "La vérification de sécurité a échoué",
    "oauthContextMissing": "Contexte OAuth manquant",
    "oauthProviderNotEnabled": "Fournisseur OAuth non activé",
    "oauthNotEnabled": "Direct OAuth n'est pas activé pour ce locataire",
    "oauthDomainNotAllowed": "Domaine de messagerie non autorisé",
    "oauthEmailMismatch": "Vous vous êtes connecté avec un compte différent de l'e-mail que vous avez saisi. Veuillez vous connecter avec le bon compte.",
    "oauthCodeExchangeFailed": "Échec de l'échange du code d'autorisation",
    "oauthTokenValidationFailed": "La validation du jeton a échoué",
    "oauthInvalidTenant": "Locataire invalide",
    "oauthSessionExpired": "Session expirée. Veuillez réessayer.",
    "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter pour continuer.",
    "filePasswordLockout": "Ce dossier est verrouillé en raison d'un trop grand nombre de tentatives infructueuses. Réessayez dans {{minutes}} minutes.",
    "getViewerData": "Un problème est survenu lors de l'obtention des données du spectateur. Veuillez réessayer.",
    "protectedLinkAlreadyUsed": "Lien déjà utilisé, générez un nouveau code",
    "protectedLinkAlreadyUsedOrExpired": "Lien déjà utilisé ou expiré, générez un nouveau code",
    "fileAccessSessionExpired": "Session expirée, générez un nouveau code",
    "protectedFileDownloadOnlyForWindows": "Le téléchargement de fichiers protégés est disponible uniquement pour la plate-forme Windows.",
    "antiCaptureActivated": "Cet élément est protégé par des paramètres anti-capture.",
    "downloadRestrictionActivated": "Cet élément est protégé par les paramètres de restrictions de téléchargement.",
    "antivirusFileInfected": "Ce fichier ne peut pas être ouvert ni partagé car l'antivirus a détecté une menace.",
    "antivirusFileInfectedNamed": "L'antivirus a détecté {{threatName}} dans {{fileName}}.",
    "antivirusRescanNotAllowed": "Vous n'êtes pas autorisé à demander une nouvelle analyse antivirus pour ce fichier.",
    "antivirusNotAvailable": "L'analyse antivirus n'est pas disponible pour le moment. Réessayez plus tard.",
    "downloadRestrictionMultipleDownloadWithWatermark": "Le téléchargement de plusieurs fichiers n'est pas autorisé lorsqu'un ou plusieurs fichiers comportent un filigrane.",
    "fileSizeTooBigForDownload": "Le fichier ne peut pas être téléchargé en mode crypté car il dépasse 250 Mo.",
    "fileNotAvailable": {
      "title": "Le fichier n'est plus disponible",
      "description": "Le fichier auquel vous essayez d'accéder n'est plus disponible. Il a peut-être été supprimé ou déplacé."
    },
    "publicLinkNotFoundTitle": "Ce lien n'est pas disponible",
    "publicLinkNotFoundMessage": "Ce lien n'existe pas, a été supprimé ou n'est plus accessible.",
    "publicLinkItemNotAvailable": "Cet élément n'est pas disponible",
    "publicLinkExpiredTitle": "Lien expiré",
    "publicLinkExpiredMessage": "Ce lien a expiré et n'est plus valide.",
    "publicLinkMaxAccessTitle": "Limite d'accès atteinte",
    "publicLinkMaxAccessMessage": "Le nombre maximum d'accès pour ce lien a été atteint.",
    "invalidAccessCode": "Le mot de passe que vous avez entré est incorrect. Veuillez réessayer.",
    "fileSizeUploadLimit": "La taille du fichier dépasse la limite de téléchargement de {{value}} Mo",
    "fileSizeExceedsAdminLimit": "Impossible de télécharger le fichier : la taille dépasse la limite maximale définie par l'administrateur.",
    "fileSizeExceedsLicenseLimit": "Impossible de télécharger le fichier : la taille dépasse la limite maximale établie dans la licence.",
    "uploadingFileError": "Un problème est survenu lors du téléchargement du fichier.",
    "uploadInterrupted": "Téléchargement annulé par l'utilisateur.",
    "fileTypeRestrictionError": "Ce type de fichier ne peut pas être téléchargé en raison des paramètres appliqués.",
    "quickShareError": "Un problème est survenu lors du partage des fichiers. Veuillez réessayer.",
    "quickShareFilesNotUploaded": "Le fichier {{ count }} n'a pas été téléchargé avec succès. Cliquez sur Continuer pour partager quand même les fichiers téléchargés avec succès.",
    "quickShareFilesNotUploaded_other": "Les fichiers {{ count }} n'ont pas été téléchargés avec succès. Cliquez sur Continuer pour partager quand même les fichiers téléchargés avec succès.",
    "enterOnBehalfOfUserFailed": "Échec de la saisie au nom de l'utilisateur. Veuillez réessayer.",
    "exitOnBehalfOfUserFailed": "Échec de la sortie au nom de l'utilisateur. Veuillez réessayer.",
    "reasonRequired": "Veuillez saisir le motif de votre participation au nom de l'utilisateur",
    "reasonMinLength": "Le motif doit comporter au moins 3 caractères",
    "impersonatedUserNotNotified": "L'utilisateur n'a pas pu être notifié par e-mail (aucune adresse e-mail sur le compte)",
    "quickShareFilesNotShared": "Les fichiers n'ont pas été partagés avec succès. Cliquez sur Continuer pour partager quand même les fichiers téléchargés avec succès.",
    "filesNotShared": "Les fichiers n'ont pas été partagés.",
    "fileSizeExceedsLimit": "La taille du fichier dépasse la limite de {{value}}.",
    "otpWrong": "Le code OTP est erroné. Veuillez réessayer.",
    "groupNameAlreadyUsed": "Le nom du groupe est déjà utilisé.",
    "updateFileAccessError": "Un problème est survenu lors de la mise à jour de l'accès au fichier. Veuillez réessayer.",
    "deleteFileAccessError": "Un problème est survenu lors de la suppression de l'accès au fichier. Veuillez réessayer.",
    "errorCreateFileShortcut": "Un problème est survenu lors de la création du raccourci vers le fichier. Veuillez réessayer.",
    "openShortcutFileError": "Oups, il semble que le fichier lié ne soit plus disponible. Il a peut-être été supprimé ou l'accès a été révoqué.",
    "confirmationMessageMatch": "Le message de confirmation ne correspond pas.",
    "emailExist": "L'e-mail existe déjà.",
    "shareFiles": "Il y avait un problème pour partager les fichiers. Veuillez réessayer.",
    "genericSellError": "Une erreur s'est produite lors de la mise en vente du fichier.",
    "someItemsCannotBeSelected": "Certains éléments ne peuvent pas être sélectionnés",
    "invalidMicrosoftEntraIdToken": "Le jeton Microsoft Entra ID n’est pas valide ou a expiré.",
    "atLeastOneOption": "Vous devez sélectionner au moins une option",
    "groupNameAlreadyExists": "Le nom du groupe est déjà utilisé.",
    "cannotAddSuperAdminToGroup": "Vous ne pouvez pas ajouter un Super Admin à un groupe.",
    "editSharingDenied": "Vous n'êtes pas autorisé à modifier les droits d'accès aux documents déjà partagés. Si un utilisateur n'apparaît pas dans la liste, cela signifie qu'il dispose déjà d'un partage actif.",
    "errorRemoveShareFiles": "Un problème est survenu lors de la suppression des fichiers partagés. Veuillez réessayer.",
    "noFileClassificationAvailable": "Aucune classification de fichiers disponible pour le moment",
    "errorPermanentlyDeleteFiles": "Un problème est survenu lors de la suppression définitive des fichiers. Veuillez réessayer.",
    "aiDocumentChatError": "Une erreur s'est produite lors de la discussion avec le document. Veuillez réessayer.",
    "filesAlreadyClassified": "Les fichiers sont déjà classés",
    "filesBeingClassified": "Les dossiers sont actuellement en cours de classement",
    "filesBeingClassifiedDescription": "Veuillez attendre que le processus de classification en cours soit terminé avant d'en démarrer un nouveau.",
    "filesTooBig": "Les fichiers dépassent la taille limite de classification",
    "filesTooBigDescription": "La taille de fichier maximale autorisée pour la classification AI est de 250 Mo. Veuillez sélectionner des fichiers plus petits.",
    "tooManyFiles": "Trop de fichiers sélectionnés",
    "tooManyFilesDescription": "{{files}} fichiers sélectionnés ; le maximum est {{limit}}. Réduisez la sélection et réessayez.",
    "rejectionReasonRequired": "Le motif du refus est requis",
    "rejectionReasonMinLength": "Le motif du refus doit comporter au moins 3 caractères",
    "fileAlreadyInUseError": "Le fichier est déjà utilisé par un autre utilisateur.",
    "contentHashMismatchError": "Fichier corrompu lors du téléchargement (incompatibilité de hachage)",
    "fileIntegrityCheckFailed": "La vérification de l'intégrité du fichier a échoué",
    "fileIntegrityCheckFailedDescription": "Le fichier téléchargé est peut-être corrompu. Veuillez réessayer de télécharger.",
    "fileIntegrityCheckError": "Erreur de vérification de l'intégrité du fichier",
    "fileIntegrityCheckErrorDescription": "Impossible de vérifier l'intégrité du fichier, mais le téléchargement va continuer.",
    "storageUrlFetchFailed": "Locataire introuvable ou temporairement indisponible",
    "storageUrlFetchFailedDescription": "Veuillez vérifier l'adresse et réessayer : <strong>{{tenantAddress}}</strong>.",
    "folderPasswordRequired": "Ce dossier nécessite une vérification du mot de passe",
    "folderPassword": {
      "passwordRequired": "Un mot de passe est requis.",
      "tooShort": "Le mot de passe doit comporter au moins 4 caractères.",
      "ownerOnly": "Seul le propriétaire du dossier peut effectuer cette action.",
      "alreadyExists": "Ce dossier est déjà protégé par mot de passe.",
      "ancestorProtected": "Impossible d'effectuer cette action car un dossier parent est protégé par mot de passe.",
      "descendantProtected": "Impossible d'effectuer cette action car un sous-dossier est protégé par mot de passe.",
      "notSet": "Ce dossier n'a pas de protection par mot de passe configurée.",
      "notProtected": "Ce dossier n'est pas protégé par mot de passe.",
      "currentRequired": "Le mot de passe actuel est requis.",
      "expired": "La protection par mot de passe du dossier a expiré. Veuillez contacter le propriétaire du dossier.",
      "incorrect": "Le mot de passe du dossier actuel est incorrect. Veuillez réessayer.",
      "sessionNotFound": "Session introuvable ou déjà révoquée.",
      "sessionForbidden": "Vous n'êtes pas autorisé à gérer cette session.",
      "otpNotRequested": "OTP n’a pas été demandé. Veuillez demander un nouveau code."
    },
    "notAFolder": "L'élément sélectionné n'est pas un dossier",
    "ipRegionBlocked": {
      "message": "Accès refusé depuis votre emplacement.",
      "loginTitle": "Accès refusé",
      "loginMessage": "Accès refusé depuis votre emplacement.",
      "loginGeneric": "Accès refusé depuis votre emplacement.",
      "fileOperationTitle": "Opération non autorisée",
      "fileOperationMessage": "Accès refusé depuis votre emplacement."
    },
    "ipRegionAdminLockout": {
      "title": "Impossible d'activer la restriction IP de l'administrateur",
      "message": "Votre adresse IP actuelle doit être incluse dans les adresses IP d'administrateur autorisées, sinon vous vous verriez exclu des paramètres d'administration."
    },
    "dateMustBeFuture": "La date doit être dans le futur",
    "externalSharingNotAllowed": "Les destinataires suivants ne sont pas autorisés à recevoir des partages externes : {{recipients}}",
    "sharingNotAllowedMandatoryTag": "Les pièces jointes doivent avoir une étiquette de classification avant d'être envoyées",
    "fileSharingDenied": "Le partage de fichiers n'est pas autorisé pour cette opération.",
    "cannotAccessFiles": "Vous ne pouvez pas accéder à un ou plusieurs des fichiers demandés.",
    "partialSharingDenied": "Certains fichiers ne peuvent pas être partagés avec les destinataires sélectionnés.",
    "partialSharingDeniedDisabledRecipients": "Certains utilisateurs ou groupes sélectionnés disposent déjà du partage de ces fichiers, mais celui-ci est actuellement désactivé. Réactivez-le à l'aide du bouton {{shareAgainLabel}} à côté de chaque destinataire.",
    "passKeyDataRequired": "Les données du mot de passe sont manquantes ou invalides. Veuillez réessayer.",
    "passKeyForbidden": "Vous n'êtes pas autorisé à effectuer cette action.",
    "passKeyLimitReached": "Vous avez atteint le nombre maximum de mots de passe. Supprimez-en un avant d’en ajouter un autre.",
    "passKeyLockedOut": "Trop de tentatives d'authentification infructueuses. Veuillez réessayer plus tard ou utiliser une autre méthode de connexion.",
    "passKeyNotAllowed": "Cette action de mot de passe n'est pas autorisée.",
    "passKeyNotEnabled": "Les clés d'accès ne sont pas activées pour votre compte ou votre organisation.",
    "passKeyNotFound": "Clé d'accès introuvable. Il a peut-être été supprimé ou n'est plus valide.",
    "passKeySessionExpired": "La session du mot de passe a expiré. S'il vous plaît, recommencez.",
    "passKeyVerificationFailed": "Identifiant introuvable ou non activé pour la connexion sans mot de passe.",
    "batchNotFound": "Lot introuvable ou accès refusé.",
    "batchNotCancellable": "Ce lot ne peut pas être annulé (hors classification).",
    "batchAlreadyFinished": "Cette opération est déjà terminée.",
    "batchRetryNotSupported": "La nouvelle tentative n'est prise en charge que pour les lots de classification.",
    "noFileJobsFound": "Aucun des fichiers sélectionnés ne peut être annulé ou réessayé dans son état actuel.",
    "queueUnavailable": "La file de traitement est temporairement indisponible. Réessayez plus tard.",
    "pdfConversionUnsupportedFormat": "Ce format de fichier n'est pas pris en charge pour la conversion PDF.",
    "pdfConversionFileTooLarge": "Fichier trop volumineux pour la conversion. Taille maximale {{maxSizeMb}} MB.",
    "pdfConversionFailed": "Échec de la conversion PDF. Veuillez réessayer.",
    "pdfConversionAntivirusBlocked": "Conversion PDF bloquée : le fichier contient une menace.",
    "fileNotFound": "Fichier introuvable."
  },
  "notifications": {
    "genericUpdateSuccess": "{{resource}} mis à jour avec succès.",
    "genericCreateSuccess": "{{resource}} créé avec succès.",
    "linkCopiedToClipboard": "Lien copié dans le presse-papier !",
    "codeCopiedToClipboard": "Code copié dans le presse-papier !",
    "fileProtectedWithAntiCapture": "Ce fichier est protégé par anticapture. Pour afficher le contenu du fichier, entrez ce code lorsque vous y êtes invité dans Filegrant Viewer, et vous avez terminé !",
    "otpCopiedToClipboard": "OTP copié dans le presse-papier !",
    "fileProtectedDownloadInProgress": "Téléchargement en cours, à la fin du téléchargement lancez l'application téléchargée, entrez ci-dessus indiqué pour visualiser le fichier.",
    "quickShareSuccess": "Fichiers partagés avec succès.",
    "fileLocatedInThisLocation": "Ce fichier se trouve déjà à cet emplacement.",
    "fileAccessRevoked": "Droits d'accès révoqués avec succès.",
    "fileAccessUpdated": "Droits d'accès mis à jour avec succès.",
    "fileVersionRestored": "Version du fichier restaurée avec succès.",
    "folderCreated": "Dossier {{resource}} créé avec succès.",
    "fileCreated": "Fichier {{resource}} créé avec succès.",
    "fileRenamed": "Fichier {{resource}} renommé en {{newName}} avec succès.",
    "fileDuplicated": "Fichier {{resource}} dupliqué avec succès.",
    "fileDuplicated_other": "Fichiers dupliqués avec succès.",
    "fileFavouriteChanged": "Fichier {{resource}} {{isFavourite}} favoris avec succès.",
    "fileFavouriteChanged_other": "Fichiers {{isFavourite}} favoris avec succès.",
    "fileShortcutCreated": "Le raccourci du fichier {{resource}} a été créé avec succès.",
    "fileMoved": "Le fichier {{resource}} a été déplacé avec succès.",
    "fileMoved_other": "Fichiers déplacés avec succès.",
    "emptyTrash": "Corbeille vidée avec succès.",
    "operationMayTakeTime": "Cette opération peut prendre un certain temps.",
    "fileRestored": "Fichier {{resource}} restauré avec succès.",
    "fileRestored_other": "Fichiers restaurés avec succès.",
    "fileHidden": "Fichier {{resource}} masqué avec succès.",
    "fileHidden_other": "Fichiers masqués avec succès.",
    "fileUnhidden": "Fichier {{resource}} affiché avec succès.",
    "fileUnhidden_other": "Fichiers affichés avec succès.",
    "filesMarkedAsRead_one": "Marqué comme lu.",
    "filesMarkedAsRead_other": "{{count}} fichiers marqués comme lus.",
    "filesMarkedAsUnread_one": "Marqué comme non lu.",
    "filesMarkedAsUnread_other": "{{count}} fichiers marqués comme non lus.",
    "folderLocked": "{{count}} dossier verrouillé.",
    "folderLocked_other": "{{count}} dossiers verrouillés.",
    "fileClassifying": "Le fichier est en cours de classification",
    "filesClassifying": "{{count}} le fichier est en cours de classification",
    "filesClassifying_other": "{{count}} les fichiers sont en cours de classification",
    "filesClassifyingBatch": "{{count}} les fichiers sont classés comme un lot",
    "filesClassifyingBatchWithSkipped": "{{count}} fichiers en file d'attente pour classification. {{skipped}} ignoré.",
    "folderClassifyingBatch": "Le contenu du dossier est classé comme un lot",
    "foldersClassifyingBatch": "{{count}} les dossiers sont classés comme un lot",
    "fileTagsUpdated": "Les étiquettes du fichier {{resource}} ont été mises à jour avec succès.",
    "fileDeleted": "Fichier {{resource}} supprimé avec succès.",
    "fileDeleted_other": "Fichiers supprimés avec succès.",
    "checkingFilesExistsCounter": "Vérification des fichiers : {{done}} / {{total}}",
    "checkingFoldersExistsCounter": "Vérification des dossiers : {{done}} / {{total}}",
    "checkingFilesInFolderCounter": "{{folder}} · Vérification des fichiers : {{done}} / {{total}}",
    "checkingSubfoldersInFolderCounter": "{{folder}} · Vérification des dossiers : {{done}} / {{total}}",
    "tags": {
      "title": "Fichier balisé",
      "description": "Le fichier a été tagué",
      "error": "La classification de l'IA a échoué.",
      "batchSuccessTitle": "Lot de classement terminé",
      "batchSuccessDescription": "Classifié {{processed}} sur {{total}} fichiers.",
      "batchFailedTitle": "Échec du lot de classification",
      "batchFailedDescription": "Lot terminé avec des erreurs ({{processed}}/{{total}})."
    },
    "summary": {
      "title": "Résumé du fichier",
      "description": "Résumé généré pour le fichier {{fileId}}",
      "ready": "Le résumé du fichier est prêt.",
      "open": "Ouvrir le résumé"
    },
    "fileUnavailable": "Fichier non disponible",
    "suggestGridMode": {
      "title": "Ce dossier contient uniquement des images",
      "description": "Passez à la vue grille pour un meilleur aperçu.",
      "action": "Passer à la grille"
    },
    "documentClassification": {
      "title": "Document classifié",
      "description": "Classification des documents terminée pour le fichier {{fileId}}"
    },
    "default": {
      "title": "Notification",
      "description": "Nouvelle notification reçue"
    },
    "sharing": {
      "title": "Fichier partagé",
      "sharing_operation_download": "{{actorName}} téléchargé {{fileName}}",
      "sharing_operation_open": "{{actorName}} ouvert {{fileName}}",
      "sharing_operation_edit": "{{actorName}} édité {{fileName}}",
      "sharing_operation_delete": "{{actorName}} supprimé {{fileName}}",
      "sharing_operation_rename": "{{actorName}} renommé {{fileName}}",
      "sharing_operation_add": "{{actorName}} ajouté {{fileName}}",
      "sharing_operation_move": "{{actorName}} déplacé {{fileName}}",
      "sharing_operation_copy": "{{actorName}} copié {{fileName}}",
      "sharing_operation_unknown": "{{actorName}} a effectué une opération sur {{fileName}}"
    },
    "folderPasswordSet": "Protection par mot de passe activée",
    "folderPasswordUpdated": "Protection par mot de passe mise à jour",
    "folderPasswordRemoved": "Protection par mot de passe supprimée",
    "unlockingFolder": "Déverrouillage du dossier…",
    "folderUnlocked": "Dossier déverrouillé avec succès",
    "pdfConversionStarted": "Conversion de {{resource}} en PDF démarrée.",
    "pdfConversionSuccess": "Conversion PDF terminée avec succès.",
    "pdfConversionFailed": "Échec de la conversion PDF.",
    "pdfConversionStillRunning": "La conversion PDF est toujours en cours. Vous serez averti lorsqu'elle sera terminée."
  },
  "files": {
    "downloadPreparation": "Préparation du téléchargement",
    "downloadReady": "Téléchargement prêt",
    "compressionOfFilesInProgress": "Compression des fichiers en cours",
    "compressionCompleted": "Compression terminée",
    "compressionFailed": "Échec de la compression"
  },
  "fileAccessNotification": {
    "enableActivityNotifications": "Activer les notifications d'activité",
    "includeSubfolders": "Inclure les sous-dossiers",
    "notifyOwner": "Informer le propriétaire",
    "notifyRecipients": "Notifier les destinataires",
    "whoCanTrigger": "Qui peut déclencher des notifications ?",
    "trigger": {
      "ownerOnly": "Propriétaire uniquement",
      "anyone": "N'importe qui"
    },
    "operation": {
      "download": "Télécharger",
      "open": "Ouvert",
      "edit": "Modifier",
      "delete": "Supprimer",
      "rename": "Renommer",
      "add": "Ajouter",
      "move": "Déplacer",
      "copy": "Copier"
    },
    "configureNotifications": "Configurer les notifications",
    "customizeFor": "Personnaliser pour",
    "discardChangesTitle": "Supprimer les modifications ?",
    "discardChangesDescription": "Vous avez des modifications non enregistrées. Les jeter et fermer ?",
    "discardConfirm": "Jeter",
    "notificationsDisabled": "Notifications désactivées",
    "notificationsEnabled": "Notifications activées",
    "modalTitle": "Notifications d'activité"
  },
  "modal": {
    "saveTagsConfirm": {
      "title": "Enregistrer les modifications d'étiquettes ?",
      "description": "Vous avez des modifications non enregistrées dans les étiquettes. Enregistrer avant de fermer ?"
    },
    "userGroupSelectorForm": {
      "title": "Gérer l'équipe d'examen",
      "description": "Sélectionnez les utilisateurs et les groupes pour l'équipe de révision",
      "currentMembers": "Membres actuels",
      "unsavedReviewTeam": "Équipe de révision non enregistrée"
    },
    "tagUserGroupMultiSelectForm": {
      "title": "Gérer les utilisateurs et les groupes",
      "description": "Sélectionnez les utilisateurs et les groupes qui peuvent accéder à cette étiquette",
      "usersAndGroups": "Utilisateurs et groupes",
      "unsavedUsersAndGroups": "Utilisateurs et groupes non enregistrés"
    },
    "changeUserRole": {
      "title": "Changer le rôle d'utilisateur",
      "description": "Êtes-vous sûr de vouloir changer le rôle {{name}} de {{initialRole}} à {{newRole}} ?"
    },
    "deleteUsersForm": {
      "title": "Supprimer un utilisateur",
      "title_other": "Supprimer des utilisateurs",
      "roleAdminOrContributor": "L'utilisateur que vous êtes sur le point de supprimer est un contributeur ou un administrateur et peut avoir téléchargé des fichiers sur le système. La suppression de cet utilisateur supprimera également tous ses fichiers téléchargés et tous les partages associés, et il ne pourra plus accéder à la plateforme. Êtes-vous sûr de vouloir continuer ? <i>(Tapez \"{{keyword}}\" pour confirmer.)</i>",
      "roleReader": "L'utilisateur que vous êtes sur le point de supprimer est un lecteur et peut avoir des fichiers qui ont été partagés avec lui par d'autres utilisateurs. La suppression de cet utilisateur l'empêchera d'accéder au système et aux fichiers partagés avec lui. Êtes-vous sûr de vouloir continuer ? <i>(Tapez \"{{keyword}}\" pour confirmer.)</i>",
      "roleExternal": "L'utilisateur que vous vous apprêtez à supprimer est également référencé par d'autres utilisateurs de la plateforme, qui ont partagé des fichiers ou des dossiers directement avec eux. La suppression de cet utilisateur révoquera son accès à tout contenu partagé, et les autres utilisateurs qui ont partagé avec eux ne verront plus cet utilisateur dans leurs propres listes d'utilisateurs. Êtes-vous sûr de vouloir continuer ? <i>(Tapez \"{{keyword}}\" pour confirmer.)</i>",
      "multiple": "Vous êtes sur le point de supprimer plusieurs utilisateurs. Certains de ces utilisateurs peuvent avoir téléchargé des fichiers sur le système. Les supprimer supprimera tous leurs fichiers téléchargés et tous les partages associés, et ils ne pourront plus accéder à la plateforme. Êtes-vous sûr de vouloir continuer ? <i>(Tapez \"{{keyword}}\" pour confirmer.)</i>",
      "transferDestinationLabel": "Transférer des fichiers personnels à un autre utilisateur (facultatif)",
      "transferDestinationPlaceholder": "Rechercher un utilisateur…",
      "transferOptionalHint": "Si vous choisissez un destinataire, les fichiers personnels du ou des comptes que vous supprimez y seront transférés avant la suppression. Laissez vide pour supprimer des fichiers conformément à la politique décrite ci-dessus.",
      "userReferencedInSettings": {
        "title": "Impossible de supprimer l'utilisateur",
        "title_other": "Impossible de supprimer des utilisateurs",
        "description": "L'utilisateur sélectionné ne peut pas être supprimé. Cet utilisateur est référencé dans les paramètres suivants : <settingsList/>. Supprimez cet utilisateur de ces paramètres avant de réessayer.",
        "description_other": "Les utilisateurs sélectionnés ne peuvent pas être supprimés. Ils sont référencés dans les paramètres suivants : <settingsList/>. Supprimez-les de ces paramètres avant de réessayer.",
        "unknownSettings": "Un ou plusieurs paramètres"
      }
    },
    "changeUsersStatus": {
      "title": "Changer le statut d'utilisateur",
      "description": "Êtes-vous sûr de vouloir {{status}} <strong>{{resource}}</strong> ?",
      "description_other": "Êtes-vous sûr de vouloir {{status}} <strong>ces utilisateurs</strong> ?"
    },
    "excludeFromSso": {
      "titleExclude": "Exclure l'utilisateur du SSO",
      "titleInclude": "Réactiver le SSO pour l'utilisateur",
      "descriptionExclude": "Êtes-vous sûr de vouloir exclure <strong>{{resource}}</strong> du SSO ? Ils ne pourront plus se connecter via le fournisseur d'identité configuré et devront se connecter via OTP.",
      "descriptionInclude": "Êtes-vous sûr de vouloir réactiver l'authentification unique pour <strong>{{resource}}</strong> ? Ils pourront à nouveau se connecter via le fournisseur d'identité configuré."
    },
    "enterOnBehalfOf": {
      "title": "Entrez en mode Au nom de",
      "description": "Vous démarrez une session où vous verrez des données et effectuerez des opérations au nom de <strong>{{resource}}</strong>.<br /><br />Confirmez-vous ?"
    },
    "impersonateUser": {
      "title": "Usurper l'identité d'un utilisateur",
      "description": "Êtes-vous sûr de vouloir vous connecter en tant que {{userName}} ? Vous pourrez voir et effectuer des opérations en tant qu'utilisateur.",
      "emailNotice": "L'utilisateur recevra un e-mail l'informant de cette usurpation, avec votre nom, la date et l'heure, ainsi que le motif saisi ci-dessous.",
      "reasonLabel": "Motif — affiché à l'utilisateur dans l'e-mail de notification",
      "reasonTruncateHint": "Les motifs de plus de 500 caractères sont tronqués avec « … » dans l'e-mail (le texte complet est tout de même enregistré).",
      "reasonEmptyHint": "Si laissé vide, l'e-mail affiche « Not specified »."
    },
    "userForm": {
      "editTitle": "Modifier l'utilisateur",
      "newTitle": "Nouvel utilisateur",
      "editDescription": "Modifier les détails de l'utilisateur",
      "newDescription": "Ajouter un nouvel utilisateur"
    },
    "userGroups": {
      "title": "Appartenance à un groupe",
      "description": "Liste des groupes dont <strong>{{resource}}</strong> est membre"
    },
    "userFiles": {
      "title": "Éléments partagés",
      "description": "Éléments partagés avec <strong>{{resource}}</strong>"
    },
    "groupFiles": {
      "title": "Éléments partagés",
      "description": "Éléments partagés avec <strong>{{resource}}</strong>"
    },
    "fileSizeTooBigForOpen": {
      "title": "Taille du fichier trop grande",
      "description": "La taille du fichier dépasse la limite de {{value}}. Si vous souhaitez ouvrir le fichier, vous pouvez le télécharger et l'ouvrir localement."
    },
    "deleteGroups": {
      "title": "Supprimer le groupe",
      "title_other": "Supprimer des groupes",
      "description": "Êtes-vous sûr de vouloir supprimer <strong>{{resource}}</strong> ? Êtes-vous sûr de vouloir continuer ? <i>(Tapez \"{{keyword}}\" pour confirmer.)</i>",
      "description_other": "Etes-vous sûr de vouloir supprimer <strong>ces groupes</strong> ? Êtes-vous sûr de vouloir continuer ? <i>(Tapez \"{{keyword}}\" pour confirmer.)</i>"
    },
    "groupForm": {
      "editTitle": "Modifier le groupe",
      "newTitle": "Nouveau groupe",
      "viewTitle": "Afficher le groupe",
      "editDescription": "Modifier les détails du groupe",
      "viewDescription": "Afficher les détails du groupe",
      "newDescription": "Ajouter un nouveau groupe",
      "allUsers": "Tous les utilisateurs",
      "selectedUsersOrGroups": "Utilisateurs ou groupes sélectionnés"
    },
    "entraIdGroupsImportForm": {
      "importFromEntraId": "Importer depuis Entra ID",
      "title": "Importer des groupes depuis Microsoft Entra ID",
      "searchGroups": "Rechercher des groupes...",
      "selectNew": "Sélectionnez nouveau uniquement",
      "existing": "Existant",
      "new": "Nouveau",
      "importMembers": "Importer également les membres du groupe",
      "importSelected": "Importer ({{count}})",
      "importSuccess": "Importation terminée : {{created}} créé, {{updated}} mis à jour",
      "importError": "Erreur lors de l'importation",
      "errorLoadingGroups": "Erreur lors du chargement des groupes à partir d'Entra ID",
      "noGroupsFound": "Aucun groupe trouvé",
      "resultSummary": "Créé : {{created}}, Mis à jour : {{updated}}, Ignoré : {{skipped}}, Échec : {{failed}}",
      "usersImported": "{{count}} membre(s) également importé(s)",
      "permissionDeniedFallback": "Autorisation refusée",
      "permissionErrorTitle": "Autorisations Azure AD insuffisantes",
      "permissionErrorDescription": "L'application Azure AD ne dispose pas des autorisations suffisantes pour accéder à l'API Microsoft Graph.",
      "permissionErrorSteps": "Pour résoudre ce problème :",
      "permissionErrorStep1": "Accédez au portail Azure > Inscriptions d’applications > Votre application",
      "permissionErrorStep2": "Accédez aux autorisations de l'API",
      "permissionErrorStep3": "Ajoutez les autorisations d'application requises (non déléguées)",
      "permissionErrorStep4": "Cliquez sur \"Accorder le consentement de l'administrateur\" pour autoriser les autorisations",
      "requiredPermissions": "Autorisations requises",
      "defaultRole": "Rôle par défaut"
    },
    "csvUsersImportForm": {
      "importFromCsv": "Import from CSV",
      "title": "Import users from CSV",
      "description": "Create new users only. Rows whose email already exists are skipped (not treated as failures). Roles: SuperAdmin, Admin, Contributor, Reader (or numeric codes).",
      "browserStayOpenWarning": "Do not close or refresh this browser tab until the import finishes. Progress exists only in this session.",
      "confirmSkipErrors": "Il y a {{count}} éléments avec des erreurs ; ils ne seront pas importés.",
      "downloadTemplate": "Download CSV template",
      "sendInvites": "Send invitation emails to newly created users",
      "dropzone": "Drop a CSV file here or click to browse",
      "fileSelected": "Selected: {{name}}",
      "invalidFileType": "Please select a .csv file",
      "readError": "Could not read the CSV file",
      "noValidRows": "No valid rows found in this file",
      "colLine": "Line",
      "confirmImport": "Import {{count}} users",
      "emptyFile": "The CSV file is empty",
      "invalidHeader": "Invalid header. Expected: {{expected}}",
      "tooManyColumns": "Too many columns on this row",
      "missingFirstName": "First name is required",
      "missingLastName": "Last name is required",
      "missingEmail": "Email is required",
      "invalidEmail": "Invalid email address",
      "missingRole": "Role is required",
      "invalidRole": "Invalid role: {{value}}",
      "superAdminRoleNotAllowed": "Only a SuperAdmin can assign the SuperAdmin role",
      "invalidExpirationDate": "Invalid expiration date: {{value}}",
      "invalidBoolean": "Invalid boolean for {{field}}: {{value}}",
      "duplicateInFile": "Duplicate email in file (first seen on line {{firstLine}})",
      "genericCreateError": "Could not create user",
      "drawerAria": "User import progress",
      "drawerRunning": "Importing users…",
      "drawerCompleted": "User import complete",
      "drawerCancelled": "User import cancelled",
      "importingUsersCounter": "Importing users {{amount}} of {{total}}",
      "importedUsersCounter": "Imported {{amount}} of {{total}}",
      "waitingForImport": "Waiting",
      "importingRow": "Importing…",
      "alreadyExists": "Already exist",
      "summary": "Created: {{created}} · Already exist: {{skipped}} · Failed: {{failed}}",
      "progressCount": "{{done}} / {{total}}",
      "failedList": "Failed",
      "alreadyExistList": "Already exist ({{count}})",
      "cancelImport": "Cancel import",
      "cancelConfirmTitle": "Cancel import?",
      "cancelConfirmContent": "In-flight creates will finish; remaining rows will not start.",
      "continueImport": "Keep importing",
      "minimizeDrawer": "Minimize",
      "expandDrawer": "Expand",
      "previewHeading": "{{total}} utilisateurs · {{errors}} erreurs",
      "searchPlaceholder": "Rechercher des utilisateurs…",
      "colStatus": "Statut",
      "filterWithErrors": "Avec erreurs",
      "filterValid": "Valides",
      "statusError": "Erreur",
      "statusOk": "OK"
    },
    "entraIdUsersImportForm": {
      "importFromEntraId": "Importer depuis Entra ID",
      "title": "Importer des utilisateurs depuis Microsoft Entra ID",
      "searchUsers": "Rechercher des utilisateurs...",
      "selectNew": "Sélectionnez nouveau uniquement",
      "existing": "Existant",
      "new": "Nouveau",
      "importSelected": "Importer ({{count}})",
      "importSuccess": "Importation terminée : {{created}} créé, {{updated}} mis à jour",
      "importError": "Erreur lors de l'importation",
      "errorLoadingUsers": "Erreur lors du chargement des utilisateurs à partir d'Entra ID",
      "noUsersFound": "Aucun utilisateur trouvé",
      "resultSummary": "Créé : {{created}}, Mis à jour : {{updated}}, Ignoré : {{skipped}}, Échec : {{failed}}",
      "permissionDeniedFallback": "Autorisation refusée",
      "permissionErrorTitle": "Autorisations Azure AD insuffisantes",
      "permissionErrorDescription": "L'application Azure AD ne dispose pas des autorisations suffisantes pour accéder à l'API Microsoft Graph.",
      "permissionErrorSteps": "Pour résoudre ce problème :",
      "permissionErrorStep1": "Accédez au portail Azure > Inscriptions d’applications > Votre application",
      "permissionErrorStep2": "Accédez aux autorisations de l'API",
      "permissionErrorStep3": "Ajoutez les autorisations d'application requises (non déléguées)",
      "permissionErrorStep4": "Cliquez sur \"Accorder le consentement de l'administrateur\" pour autoriser les autorisations",
      "requiredPermissions": "Autorisations requises",
      "defaultRole": "Rôle par défaut"
    },
    "batchDetailForm": {
      "title": "Détail du lot",
      "noFailedFiles": "Aucun fichier en échec",
      "noFiles": "Aucun fichier dans cet état",
      "fileCancelled": "Annulation demandée pour ce fichier.",
      "fileCancelError": "Erreur lors de la demande d'annulation du fichier.",
      "fileRetried": "Fichier remis en file pour nouvel essai",
      "fileRetryError": "Erreur lors de la nouvelle tentative",
      "truncatedHint": "L'aperçu des fichiers en échec a été tronqué. Utilisez l'onglet Échoués pour la liste complète.",
      "attempt": "Tentative {{count}}",
      "tabs": {
        "pending": "En attente",
        "processing": "En cours",
        "success": "Terminés",
        "failed": "Échoués",
        "canceled": "Annulés"
      },
      "status": {
        "pending": "En attente",
        "processing": "En cours",
        "success": "Terminé",
        "failed": "Échoué",
        "canceled": "Annulé"
      }
    },
    "batchesList": {
      "panelTitle": "Lots",
      "noActiveBatches": "Aucun lot actif",
      "cancelAllFailed": "Annuler tous les lots en échec (pas en cours)",
      "cancelAllFailedConfirmTitle": "Annuler tous les lots en échec ?",
      "cancelAllFailedConfirmContent": "Seuls les lots au statut Échec seront effacés. Les lots en cours ou en file d’attente continuent et ne sont pas concernés. Cette opération ne peut pas être annulée.",
      "cancelBatch": "Annuler le lot",
      "cancelBatchConfirmTitle": "Annuler ce lot ?",
      "cancelBatchConfirmContent": "Cela annulera la demande. Le traitement pourra s'arrêter au prochain point de contrôle. Cette action ne peut pas être annulée.",
      "failedFiles": "Le fichier {{count}} a échoué",
      "failedFiles_other": "{{count}} fichiers ont échoué",
      "progress": "{{processed}} / {{total}}",
      "status": {
        "all": "Tout",
        "queued": "En file d'attente",
        "processing": "Traitement",
        "completed": "Terminé",
        "failed": "Échec",
        "partiallycompleted": "Partiellement terminé",
        "cancelled": "Annulé"
      },
      "operation": {
        "all": "Toutes les opérations",
        "classification": "Classement de l'IA",
        "folderexpansion": "Extension de dossier",
        "delete": "Supprimer",
        "zip": "La création du ZIP a échoué"
      },
      "pendingFiles": "{{count}} en attente",
      "pendingFiles_other": "{{count}} en attente",
      "processingFiles": "{{count}} en cours",
      "processingFiles_other": "{{count}} en cours",
      "processedFiles": "{{count}} terminé",
      "processedFiles_other": "{{count}} terminés",
      "canceledFiles": "{{count}} annulé",
      "canceledFiles_other": "{{count}} annulés",
      "viewDetail": "Voir les détails"
    },
    "tagForm": {
      "editTitle": "Modifier l'étiquette",
      "newTitle": "Nouvelle étiquette",
      "editDescription": "Modifier les détails de l'étiquette",
      "newDescription": "Ajouter une nouvelle étiquette",
      "visibility": "Visibilité",
      "selectUserRoles": "Sélectionnez les rôles d'utilisateur",
      "visibilityDescription": "Rendez cette étiquette visible pour les rôles suivants et spécifiez si l'étiquette sera visible par tout le monde ou uniquement par des groupes ou des utilisateurs spécifiques.",
      "usedInSettings": "Utilisé dans :",
      "usedInSettingsNone": "Cette étiquette n’est utilisée dans aucun contexte."
    },
    "deleteTag": {
      "title": "Supprimer l'étiquette",
      "description": "Êtes-vous sûr de vouloir supprimer <strong>{{resource}}</strong> ? Êtes-vous sûr de vouloir continuer ?",
      "descriptionWithPublicTag": "Êtes-vous sûr de vouloir supprimer <strong>{{resource}}</strong> ? La suppression de cette étiquette supprimera tous les partages qui lui sont associés dans le paramètre de visibilité des fichiers balisés.",
      "errorInUse": "Impossible de supprimer l'étiquette",
      "errorInUseDescription": "Cette étiquette est actuellement utilisée dans les domaines suivants :",
      "errorInUseAction": "Supprimez l'étiquette de ces emplacements avant de la supprimer.",
      "usedInSettings": "Paramètres",
      "usedInClassificationAgent": "Agent de classement"
    },
    "fileTitleForm": {
      "newFolderTitle": "Nouveau dossier",
      "editFolderTitle": "Renommer le dossier",
      "editFileTitle": "Renommer le fichier"
    },
    "fileFromTemplateForm": {
      "newWordDocumentTitle": "Nouveau document Word",
      "newExcelDocumentTitle": "Nouveau document Excel",
      "newPowerpointDocumentTitle": "Nouveau document PowerPoint",
      "newGenericDocumentTitle": "Nouveau document"
    },
    "enterFolderPasswordForm": {
      "passwordPlaceholder": "Mot de passe",
      "required": "Le mot de passe est requis",
      "cancel": "Annuler",
      "confirm": "Déverrouiller",
      "error": "Mot de passe incorrect",
      "lockout": "Trop de tentatives infructueuses. Réessayez dans {{minutes}} minutes.",
      "genericError": "Une erreur s'est produite",
      "resetPassword": "Réinitialiser le mot de passe",
      "forgotPassword": "Mot de passe oublié ?",
      "title": "Dossier protégé",
      "description": "Le dossier \"{{folderName}}\" nécessite un mot de passe."
    },
    "filePasswordForm": {
      "title": "Protection par mot de passe du dossier",
      "createTitle": "Définir la protection par mot de passe",
      "editTitle": "Modifier la protection par mot de passe",
      "password": "Mot de passe",
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "newPasswordHelp": "Laisser vide pour conserver le mot de passe actuel",
      "ownerBypass": "Contournement du propriétaire",
      "ownerBypassDescription": "Le propriétaire peut accéder au dossier sans mot de passe",
      "adminBypass": "Contournement de l'administrateur",
      "adminBypassDescription": "L'administrateur peut accéder au dossier sans mot de passe",
      "maxFailedAttempts": "Nombre maximum de tentatives infructueuses",
      "lockoutDuration": "Durée du verrouillage (minutes)",
      "sessionDuration": "Durée de la session (minutes)",
      "expirationDate": "Date d'expiration",
      "expirationDatePlaceholder": "Sélectionnez la date (facultatif)",
      "remove": "Supprimer le mot de passe",
      "removeConfirm": "Êtes-vous sûr de vouloir supprimer le mot de passe ?",
      "validation": {
        "required": "Ce champ est obligatoire",
        "minLength": "Doit contenir au moins {{min}} caractères",
        "expirationDateExpired": "La date d'expiration ne peut pas être située dans le passé"
      }
    },
    "fileSessionsForm": {
      "title": "Sessions de dossiers",
      "revokeAllSessionsDescription": "Toutes les sessions de déverrouillage pour \"{{fileName}}\" seront révoquées. Les utilisateurs devront saisir à nouveau le mot de passe pour accéder à ce dossier.",
      "revokeAllFolderSessionsDescription": "Toutes les sessions de déverrouillage de dossiers seront révoquées. Les utilisateurs devront saisir à nouveau le mot de passe pour accéder à n'importe quel dossier protégé.",
      "noSessions": "Aucune session active",
      "unknownDevice": "Appareil inconnu",
      "createdAt": "Créé",
      "expiresAt": "Expire",
      "revokeSession": "Révoquer",
      "sessionRevoked": "Session révoquée avec succès",
      "sessionRevoked_other": "{{count}} sessions révoquées avec succès",
      "allSessionsRevoked": "Toutes les sessions ont été révoquées",
      "fetchError": "Erreur lors de la récupération des sessions",
      "revokeError": "Erreur lors de la révocation de la session",
      "revokeAllError": "Erreur lors de la révocation de toutes les sessions",
      "revokeSessionConfirmTitle": "Révoquer cette session ?",
      "revokeSessionConfirmDescription": "Cette session de déverrouillage de dossier sera immédiatement révoquée. L'utilisateur devra saisir à nouveau le mot de passe pour accéder à ce dossier.",
      "revokeAllConfirmTitle": "Révoquer toutes les sessions de dossiers ?",
      "revokeAllConfirmDescription": "Toutes les sessions de déverrouillage de dossiers seront révoquées. Les utilisateurs devront saisir à nouveau le mot de passe pour accéder aux dossiers protégés.",
      "logoutAll": "Révoquer tout"
    },
    "userSessionsForm": {
      "activeSessions": "Séances actives",
      "manageSessions": "Gérer les séances",
      "manageUserSessions": "Séances de {{userName}}",
      "noSessions": "Aucune session active",
      "unknownBrowser": "Navigateur inconnu",
      "unknownDevice": "Appareil inconnu",
      "lastActivity": "Dernière activité",
      "expiresAt": "Expire",
      "currentSession": "Session en cours",
      "revokeSession": "Révoquer",
      "sessionRevoked": "Session révoquée avec succès",
      "sessionRevoked_other": "{{count}} sessions révoquées avec succès",
      "otherSessionsRevoked": "{{count}} session révoquée avec succès",
      "otherSessionsRevoked_other": "{{count}} sessions révoquées avec succès",
      "allSessionsRevoked": "Toutes les sessions ont été révoquées",
      "revokeSessionConfirmTitle": "Révoquer cette session ?",
      "revokeSessionConfirmDescription": "L'appareil sera immédiatement déconnecté.",
      "revokeGroupedSessionConfirmDescription": "Cela révoquera les sessions {{count}} de cet appareil.",
      "revokeOthersConfirmTitle": "Se déconnecter de tous les autres appareils ?",
      "revokeOthersConfirmDescription": "Tous les appareils, à l'exception de celui actuel, seront déconnectés.",
      "revokeAllConfirmTitle": "Déconnecter tous les appareils ?",
      "revokeAllConfirmDescription": "Tous les appareils seront déconnectés, y compris celui actuel. Vous devrez vous reconnecter.",
      "adminRevokeAllConfirmTitle": "Se déconnecter de toutes les sessions utilisateur ?",
      "adminRevokeAllConfirmDescription": "Toutes les sessions de {{userName}} seront révoquées. L'utilisateur devra se reconnecter.",
      "logoutOthers": "Déconnectez-vous des autres appareils",
      "logoutAll": "Tout déconnecter",
      "revokeAllUserSessions": "Révoquer tout"
    },
    "resetFilePasswordForm": {
      "forgotPassword": "Mot de passe oublié ?",
      "otpSentToEmail": "OTP envoyé à votre adresse e-mail.",
      "resetPassword": "Réinitialiser le mot de passe",
      "otpCodeLabel": "Code OTP",
      "newPasswordLabel": "Nouveau mot de passe",
      "wrongOtpCode": "Mauvais code OTP.",
      "tooManyAttemptsRequestNewOtp": "Trop de tentatives. Demandez un nouvel OTP.",
      "codeExpiredRequestNewOtp": "Code expiré. Demandez un nouvel OTP.",
      "otpRequired": "OTP est requis",
      "otpMustBe6": "OTP doit être composé de 6 chiffres",
      "newPasswordRequired": "Un nouveau mot de passe est requis",
      "newPasswordMin": "Le mot de passe doit contenir au moins 4 caractères",
      "passwordResetSuccess": "Le mot de passe a été réinitialisé avec succès.",
      "tooManyOtpRequests": "Trop de demandes OTP. Veuillez réessayer plus tard."
    },
    "fileMoveForm": {
      "title": "Déplacer {{resource}}",
      "title_other": "Déplacer {{count}} fichiers",
      "currentPosition": "Poste actuel",
      "folderIsEmpty": "Le dossier est vide",
      "selectFolderToMoveInto": "Sélectionnez une position pour afficher le chemin du dossier où vous souhaitez déplacer le fichier"
    },
    "fileShortcutForm": {
      "title": "Créez un raccourci pour {{resource}}",
      "currentPosition": "Poste actuel",
      "folderIsEmpty": "Le dossier est vide",
      "selectFolderToCreateShortcutInto": "Sélectionnez une position pour afficher le chemin du dossier où vous souhaitez créer le raccourci",
      "goBack": "Retourner"
    },
    "fileChooseDestinationForm": {
      "currentPosition": "Poste actuel",
      "folderIsEmpty": "Le dossier est vide",
      "selectFolderHint": "Sélectionnez le dossier dans lequel enregistrer le fichier",
      "goBack": "Retourner"
    },
    "fileShareForm": {
      "title": "Partager {{resource}}",
      "title_other": "Partager {{count}} fichiers",
      "message": "Partagez ce fichier avec un ou plusieurs utilisateurs ou groupes.",
      "message_other": "Partagez {{count}} fichiers avec un ou plusieurs utilisateurs ou groupes.",
      "currentPosition": "Poste actuel",
      "folderIsEmpty": "Le dossier est vide",
      "selectFolderToShareInto": "Sélectionnez une position pour afficher le chemin du dossier dans lequel vous souhaitez partager le fichier",
      "peopleWithAccess": "Personnes ayant accès",
      "sendMessage": "Notifier les destinataires par email",
      "sendMessagePlaceholder": "Ajouter un message personnalisé (facultatif)",
      "existingAccessesChanged": "Accès existants modifiés",
      "existingAccessesChangedDescription": "Enregistrer applique vos modifications aux accès existants, puis ajoute les nouveaux utilisateurs ou groupes. Annuler laisse le formulaire tel quel et ne les ajoute pas.",
      "existingAccessesExpirationRequired": "Pour mettre à jour ces accès existants, vous devez définir une date d'expiration autorisée par les politiques de l'entreprise.",
      "applyAllExpirationDates": "Appliquer tout"
    },
    "filePublicLinkForm": {
      "title": "Lien public",
      "createTitle": "Créer un lien public",
      "expirationLabel": "Expiration (facultatif)",
      "expirationLabelRequired": "Expiration",
      "expirationPlaceholder": "Jamais",
      "maxAccessCountLabel": "Nombre maximum d'accès (facultatif)",
      "maxAccessCountLabelRequired": "Nombre maximum d'accès",
      "maxAccessCountPlaceholder": "Illimité",
      "allowDownload": "Autoriser le téléchargement",
      "protectWithPassword": "Protéger avec un mot de passe",
      "passwordLabel": "Mot de passe",
      "passwordPlaceholder": "Entrez le mot de passe",
      "passwordRequired": "Le mot de passe est requis lorsque la protection est activée",
      "createLink": "Créer un lien",
      "linkCreatedTitle": "Lien créé !",
      "linkCreatedMessage": "Le lien public a été créé.",
      "copyLink": "Copier le lien",
      "warning": "La création d'un lien public contourne les protections standards sur ce fichier. Toute personne disposant du lien peut accéder au contenu du document – ​​à utiliser avec précaution.",
      "expiresAt": "Expire",
      "remainingAccesses": "Accès restants",
      "password": "Mot de passe",
      "revoke": "Révoquer le lien",
      "revoked": "Lien public révoqué avec succès.",
      "publicUrl": "URL publique",
      "status": "Statut",
      "statusActive": "Actif",
      "statusExpired": "Expiré",
      "statusExhausted": "Limite atteinte",
      "accessCount": "Accès",
      "hasPassword": "Protégé par mot de passe",
      "createdAt": "Créé",
      "errors": {
        "linkAlreadyExists": "Un lien public existe déjà pour ce fichier. Révoquez-le d'abord pour en créer un nouveau.",
        "linkNotFound": "Aucun lien actif trouvé pour ce fichier.",
        "featureDisabled": "Les liens publics sont désactivés pour votre organisation.",
        "notOwner": "Vous devez être le propriétaire pour créer ou révoquer des liens publics."
      }
    },
    "filePublicLinksForm": {
      "statusExpired": "Expiré",
      "statusExhausted": "Limite atteinte",
      "statusActive": "Actif",
      "expiresAt": "Expire",
      "accessCount": "Accès",
      "hasPassword": "Mot de passe",
      "empty": "Pas encore de liens publics."
    },
    "userTransferOwnershipForm": {
      "title": "Transférer la propriété – {{sourceName}}",
      "destinationLabel": "Utilisateur destinataire",
      "destinationPlaceholder": "Rechercher et sélectionner un utilisateur",
      "destinationRequired": "Sélectionnez un utilisateur de destination.",
      "infoMessage": "Les fichiers seront déplacés dans un dossier « Transféré depuis {{email}} » à la racine du destinataire. Les fichiers mis en vente sur la Marketplace ne seront pas transférés.",
      "submit": "Transférer la propriété",
      "cancel": "Annuler",
      "close": "Fermer",
      "successTitle": "Transfert terminé",
      "resultFilesTransferred": "Fichiers transférés",
      "resultFoldersTransferred": "Dossiers transférés",
      "resultSharesUpdated": "Partages mis à jour",
      "resultSelfSharesRemoved": "Auto-partages supprimés",
      "resultTagAssignmentsRemoved": "Attributions d'étiquettes supprimées",
      "resultTagAssignmentsTransferred": "Attributions d'étiquettes transférées",
      "resultFilesForSaleExcluded": "Fichiers à vendre exclus",
      "resultWrapperFolderName": "Nom du dossier wrapper"
    },
    "userTotpForm": {
      "title": "2FA – {{userName}}",
      "statusTitle": "Statut 2FA",
      "totpEnabled": "TOTP activé",
      "enabledAt": "Activé le",
      "backupCodesRemaining": "Codes de sauvegarde restants",
      "requiredByPolicy": "Exigé par la politique",
      "lockoutStatus": "Statut de verrouillage",
      "failedAttempts": "Tentatives infructueuses",
      "exemptionTitle": "Dispense TOTP",
      "grantExemption": "Dispense de subvention",
      "revokeExemption": "Révoquer l'exonération",
      "revoke": "Révoquer",
      "exemptionTypeTemporary": "Temporaire",
      "exemptionTypePermanent": "Permanent",
      "exemptionTypeLabel": "Tapez",
      "exemptionExpires": "Expire le",
      "exemptionReason": "Raison",
      "grantedBy": "Accordé par",
      "grantedAt": "Accordé le",
      "grantDialogTitle": "Dispense de subvention",
      "grantDialogTemporary": "Temporaire",
      "grantDialogPermanent": "Permanent",
      "grantDialogDays": "Jours",
      "grantDialogReason": "Raison (min 5 caractères)",
      "grantSubmit": "Subvention",
      "revokeConfirmTitle": "Révoquer l'exonération",
      "revokeConfirmDescription": "L’utilisateur devra à nouveau se conformer à la politique 2FA.",
      "disableConfirmTitle": "Désactiver 2FA pour cet utilisateur ?",
      "disableConfirmDescription": "Cela supprimera l'authentification à deux facteurs pour l'utilisateur. Ils devront le reconfigurer si la politique l’exige.",
      "statusLoading": "Chargement…",
      "statusError": "Échec du chargement du statut 2FA.",
      "grantSuccess": "Exonération accordée.",
      "revokeSuccess": "Exonération supprimée.",
      "disableSuccess": "2FA désactivé.",
      "cancel": "Annuler",
      "disableTotp": "Désactiver 2FA",
      "retry": "Réessayer",
      "errorGeneric": "Quelque chose s'est mal passé. Veuillez réessayer."
    },
    "userPasskeyForm": {
      "cancel": "Annuler",
      "retry": "Réessayer",
      "errorGeneric": "Quelque chose s'est mal passé. Veuillez réessayer.",
      "passkeyRemove": "Supprimer",
      "passkeyRemoveAll": "Supprimer tous les mots de passe",
      "passkeyRemoveAllConfirm": "Cela supprimera tous les mots de passe {{count}} pour cet utilisateur. Ils devront en enregistrer de nouveaux.",
      "passkeyRemoveAllSuccess": "Tous les mots de passe supprimés.",
      "passkeyRemoveAllTitle": "Supprimer tous les mots de passe ?",
      "passkeyRemoveConfirm": "Supprimer le mot de passe « {{name}} » ? L'utilisateur ne pourra plus l'utiliser pour se connecter.",
      "passkeyRemoveSuccess": "Clé d'accès supprimée.",
      "passkeyRemoveTitle": "Supprimer le mot de passe ?",
      "passkeysBlocked": "Verrouillage du mot de passe",
      "passkeysCount": "Mots-clés enregistrés",
      "passkeysEnabled": "Mots-clés activés",
      "passkeysFailedAttempts": "Les tentatives de clé d'accès ont échoué",
      "passkeysLoadError": "Impossible de charger le statut d'administrateur du mot de passe.",
      "passkeysTitle": "Mots-clés"
    },
    "loginTokensForm": {
      "title": "Jetons d'accès – {{userName}}",
      "manageTokens": "Gérer les jetons d'accès",
      "noTokens": "Aucun jeton d'accès configuré pour cet utilisateur.",
      "createToken": "Créer un nouveau jeton",
      "label": "Étiquette",
      "labelRequired": "L'étiquette est obligatoire",
      "labelPlaceholder": "par ex. Intégration CRM, pipeline CI/CD",
      "expirationDays": "Expiration (jours)",
      "create": "Créer",
      "cancel": "Annuler",
      "close": "Fermer",
      "delete": "Supprimer",
      "retry": "Réessayer",
      "enabled": "Activé",
      "disabled": "Désactivé",
      "expired": "Expiré",
      "enable": "Activer",
      "disable": "Désactiver",
      "createdAt": "Créé",
      "expiresAt": "Expire",
      "lastUsed": "Dernière utilisation",
      "lastUsedIp": "Dernière IP",
      "neverUsed": "Jamais utilisé",
      "maxTokensReached": "Nombre maximum de jetons atteint (2). Supprimez un jeton existant pour en créer un nouveau.",
      "tokenCreatedTitle": "Jeton créé avec succès",
      "tokenCreatedWarning": "Copiez ce jeton maintenant. Il ne sera plus affiché.",
      "copyToken": "Copier le jeton",
      "copied": "Copié!",
      "deleteConfirmTitle": "Supprimer le jeton d'accès ?",
      "deleteConfirmDescription": "Le token \"{{label}}\" sera définitivement supprimé et ne pourra plus être utilisé pour l'authentification.",
      "deleteSuccess": "Jeton supprimé avec succès.",
      "errorCannotCreateTokenForSuperAdmin": "Les jetons d'accès ne peuvent pas être créés pour les super-administrateurs.",
      "errorGeneric": "Quelque chose s'est mal passé. Veuillez réessayer.",
      "errorLoad": "Échec du chargement des jetons d'accès.",
      "errorMaxReached": "Cet utilisateur dispose déjà du nombre maximum de jetons.",
      "errorTokenAlreadyUsed": "Ce jeton a déjà été utilisé et ne peut pas être réactivé."
    },
    "alertDismiss": {
      "title": "Ignorer ou répéter l'alerte",
      "chooseAction": "Comment veux-tu continuer ?",
      "permanent": "Ne plus montrer",
      "snooze": "Rappelle-moi plus tard",
      "snoozeDuration": "Rappelle-moi après",
      "confirm": "Postuler",
      "success": "Préférence enregistrée."
    },
    "alertsList": {
      "title": "Toutes les alertes actives",
      "dismiss": "Répéter ou ignorer"
    },
    "totpForm": {
      "title": "Authentification à deux facteurs",
      "statusActive": "Actif",
      "statusInactive": "Inactif",
      "activatedOn": "Activé le {{date}}",
      "backupCodesRemaining": "{{count}} / {{total}} codes de sauvegarde restants",
      "requiredByPolicy": "Votre organisation nécessite une authentification à deux facteurs.",
      "gracePeriodEnds": "Vous avez jusqu'au {{date}} pour l'activer.",
      "activate": "Activer 2FA",
      "setupTitle": "Configurer l'authentification à deux facteurs",
      "scanQR": "Scannez ce QR code avec votre application d'authentification (Google Authenticator, Microsoft Authenticator, Authy, etc.).",
      "manualEntry": "Vous ne parvenez pas à numériser ? Entrez manuellement",
      "hideManual": "Masquer la saisie manuelle",
      "enterSecretManually": "Saisissez ce code manuellement dans votre application :",
      "copySecret": "Copier",
      "copied": "Copié dans le presse-papiers",
      "verifyCodeLabel": "Saisissez le code à 6 chiffres depuis votre application",
      "verifyAndActivate": "Vérifier et activer",
      "backupCodesTitle": "Authentification à deux facteurs activée !",
      "regenerateSuccess": "Codes de sauvegarde régénérés",
      "backupCodesWarning": "Enregistrez ces codes de sauvegarde dans un endroit sûr. Ils peuvent être utilisés pour accéder à votre compte si vous perdez l'accès à votre application d'authentification. Chaque code ne peut être utilisé qu'une seule fois.",
      "copyAll": "Copier tout",
      "download": "Télécharger",
      "print": "Imprimer",
      "savedConfirm": "J'ai sauvegardé ces codes dans un endroit sûr",
      "continue": "Continuer",
      "regenerateBackupCodes": "Régénérer les codes de sauvegarde",
      "disableTotp": "Désactiver 2FA",
      "disableConfirm": "Désactiver l'authentification à deux facteurs ?",
      "disableConfirmDescription": "La suppression de 2FA rendra votre compte moins sécurisé. Vous devrez reconfigurer votre application d'authentification si vous souhaitez réactiver 2FA.",
      "enterCodeToConfirm": "Entrez le code TOTP pour confirmer",
      "cancel": "Annuler",
      "disable": "Désactiver",
      "disabledSuccess": "L'authentification à deux facteurs a été désactivée.",
      "invalidCode": "Code invalide. Veuillez réessayer.",
      "errorGeneric": "Quelque chose s'est mal passé. Veuillez réessayer.",
      "retry": "Réessayer"
    },
    "passkeyCreateForm": {
      "addDescription": "Lorsque vous continuez, votre navigateur vous demandera de vérifier avec Touch ID, Face ID, Windows Hello ou votre clé de sécurité.",
      "continueAuthenticator": "Continuer",
      "deviceNameInvalid": "Saisissez un nom d'appareil compris entre 1 et 100 caractères.",
      "deviceNameLabel": "Nom de l'appareil",
      "deviceNamePlaceholder": "par ex. Identifiant tactile du MacBook",
      "passkeyCancelled": "La connexion par mot de passe a été annulée.",
      "registerErrorDeviceAlreadyRegistered": "Un mot de passe pour cet appareil est déjà enregistré. Utilisez un autre authentificateur ou supprimez d’abord le mot de passe existant.",
      "registerErrorGeneric": "L'enregistrement du mot de passe n'a pas pu être terminé. Veuillez réessayer.",
      "registerErrorNotSupported": "Votre navigateur ou appareil ne prend pas en charge ce type d'enregistrement de mot de passe.",
      "registerSuccess": "Mot de passe enregistré.",
      "title": "Ajouter un mot de passe"
    },
    "passkeyEditForm": {
      "deviceNameInvalid": "Saisissez un nom d'appareil compris entre 1 et 100 caractères.",
      "deviceNameLabel": "Nom de l'appareil",
      "renameError": "Impossible de renommer le mot de passe.",
      "renameSuccess": "Clé d'accès renommée.",
      "saveLabel": "Enregistrer",
      "title": "Renommer le mot de passe"
    },
    "passkeysForm": {
      "addPasskey": "Ajouter un mot de passe",
      "browserUnsupported": "Votre navigateur ne prend pas en charge les mots de passe. Utilisez une version actuelle de Chrome, Safari, Edge ou Firefox.",
      "empty": "Pas encore de mot de passe. Ajoutez-en un pour vous connecter plus rapidement et utilisez-le comme deuxième facteur.",
      "lastUsed": "Dernière utilisation",
      "loadError": "Impossible de charger l'état du mot de passe.",
      "maxReached": "Vous pouvez enregistrer jusqu'à {{max}} mots de passe.",
      "never": "Jamais",
      "passwordless": "Sans mot de passe",
      "passwordlessDisabled": "Sans mot de passe désactivé.",
      "passwordlessEnabled": "Sans mot de passe activé.",
      "passwordlessUnavailable": "Non disponible pour cet appareil",
      "policyDisabled": "Les clés d'accès sont désactivées par votre organisation.",
      "registered": "Inscrit",
      "remove": "Supprimer",
      "removeConfirm": "Supprimer le mot de passe « {{name}} » ? Vous ne pourrez plus l'utiliser pour vous connecter.",
      "removeError": "Impossible de supprimer le mot de passe.",
      "removeLastWarning": "C'est votre seul mot de passe. Le supprimer désactivera la connexion par mot de passe jusqu'à ce que vous en ajoutiez un nouveau.",
      "removeSuccess": "Clé d'accès supprimée.",
      "removeTitle": "Supprimer le mot de passe ?",
      "rename": "Renommer",
      "title": "Mots-clés",
      "toggleError": "Impossible de mettre à jour le paramètre sans mot de passe.",
      "transport": "Type d'appareil",
      "transportBle": "Clé de sécurité Bluetooth",
      "transportHybrid": "Téléphone",
      "transportHybridInternal": "Clé d'accès synchronisée (téléphone)",
      "transportInternal": "Cet appareil (Touch ID, Face ID, Windows Hello)",
      "transportNfc": "Clé de sécurité (NFC)",
      "transportUsb": "Clé de sécurité (USB)",
      "transportUsbNfc": "Clé de sécurité (USB + NFC)",
      "transportUnknown": "Non signalé"
    },
    "filesSelectForm": {
      "confirmDeselectParent": "Désélectionner le dossier parent ?",
      "confirmDeselectParentDescription": "La sélection de ce dossier désélectionnera le dossier parent et tous les dossiers du même niveau. Voulez-vous continuer ?",
      "ariaLabel": "Formulaire de partage de fichiers",
      "selectUsersOrGroups": "Sélectionnez des utilisateurs ou des groupes",
      "userMultiSelectAria": "Sélection des utilisateurs et des groupes",
      "actions": "Actions"
    },
    "fileTagsForm": {
      "title": "Modifier les étiquettes - {{resource}}",
      "availableTags": "Étiquettes disponibles",
      "assignedTags": "Étiquettes associées",
      "searchAvailableTags": "Rechercher des étiquettes disponibles",
      "searchAssignedTags": "Rechercher des étiquettes associées",
      "noAssignedTags": "Aucune étiquette associée",
      "clickHintAdd": "Cliquez sur une étiquette pour l'ajouter.",
      "clickHintRemove": "Cliquez sur une étiquette pour la retirer. Faites glisser la poignée pour réordonner.",
      "clickToAdd": "Ajouter l'étiquette {{title}}",
      "clickToRemove": "Retirer l'étiquette {{title}}",
      "dragToReorder": "Glisser pour réordonner {{title}}",
      "aiScrapingOnlyPdfOffice": "AI Scraping est actif uniquement sur les fichiers PDF et Office.",
      "watermarkOnlyPdfOffice": "La protection contre les filigranes est active uniquement sur les fichiers PDF et Office."
    },
    "openFileFromTrash": {
      "title": "Ce fichier est dans votre corbeille",
      "description": "Pour afficher <strong>{{resource}}</strong>, vous devez le restaurer à partir de la corbeille."
    },
    "fileUploadOptionsForm": {
      "title": "Options de téléchargement",
      "description": "<strong>{{resource}}</strong> existe déjà à cet emplacement. Souhaitez-vous remplacer le fichier existant par une nouvelle version ou conserver les deux fichiers ? Le remplacement de fichiers ne modifiera pas les options de partage",
      "description_other": "Un ou plusieurs éléments existent déjà à cet emplacement. Souhaitez-vous remplacer les fichiers existants par une nouvelle version ou conserver les deux fichiers ? Le remplacement de fichiers ne modifiera pas les options de partage",
      "replaceExistingFile": "Remplacer le fichier existant",
      "replaceExistingFile_other": "Remplacer les fichiers existants",
      "keepBothFiles": "Conservez les deux fichiers",
      "keepBothFiles_other": "Conservez les deux fichiers",
      "newOnly": "Nouveau seulement"
    },
    "filePermanentlyDeleteForm": {
      "title": "Supprimer définitivement {{resource}}",
      "title_other": "Supprimer définitivement les fichiers {{count}}",
      "description": "Êtes-vous sûr de vouloir supprimer définitivement <strong>{{resource}}</strong> ? Cette action ne peut pas être annulée.",
      "description_other": "Êtes-vous sûr de vouloir supprimer définitivement <strong>ces fichiers</strong> ? Cette action ne peut pas être annulée."
    },
    "fileSellForm": {
      "title": "Vendre un fichier",
      "message": "Vendre le fichier avec FileGrant",
      "uploadPreview": "Cliquez ou glissez pour téléverser l’aperçu",
      "uploadPreviewHint": "Image carrée - Max 5 Mo",
      "removeImage": "Supprimer l’image",
      "pleaseEnterPrice": "Veuillez saisir un prix",
      "invalidNumber": "Nombre invalide",
      "priceMin": "Le prix doit être d’au moins €{{amount}}",
      "allowDownload": "Autoriser le téléchargement du fichier",
      "removeFromStore": "Retirer de la boutique",
      "listedSuccess": "Fichier mis en vente avec succès !",
      "purchaseLink": "Lien d’achat",
      "previewUploadError": "Erreur lors du téléversement de l’aperçu",
      "imageTooLarge": "L’image doit faire moins de 5 Mo",
      "unableToReadImage": "Impossible de lire l’image",
      "previewAlt": "Aperçu",
      "mustBeImage": "Le fichier doit être une image",
      "previewImage": "Image d’aperçu"
    },
    "emptyFilesTrash": {
      "title": "Vider la poubelle",
      "description": "Êtes-vous sûr de vouloir vider la poubelle ? Tapez <strong>{{keyword}}</strong> pour confirmer, cette action ne peut pas être annulée."
    },
    "settingExceptionsForm": {
      "title": "Modifier les exceptions",
      "description": "Modifiez les exceptions pour le paramètre.",
      "unsavedExceptions": "Exceptions non enregistrées",
      "currentExceptions": "Exceptions actuelles"
    },
    "aiSummary": {
      "title": "Résumé de l'IA"
    },
    "aiDocumentChat": {
      "title": "Discutez avec un document"
    },
    "sendInvitationToGroupUsers": {
      "title": "Envoyer une invitation",
      "description": "Vous pouvez envoyer un message personnalisé aux nouveaux utilisateurs du groupe ou fermer cette boîte de dialogue sans autre action.",
      "success": "Invitation envoyée avec succès",
      "error": "Erreur lors de l'envoi de l'invitation",
      "customMessagePlaceholder": "Facultatif : message personnalisé"
    },
    "sendInvitationToUsers": {
      "title": "Envoyer une invitation",
      "description": "Vous pouvez envoyer un message personnalisé à {{resource}} ou fermer cette boîte de dialogue sans autre action.",
      "description_other": "Vous pouvez envoyer un message personnalisé aux utilisateurs {{count}} ou fermer cette boîte de dialogue sans autre action.",
      "success": "Invitation envoyée avec succès",
      "error": "Erreur lors de l'envoi de l'invitation",
      "customMessagePlaceholder": "Facultatif : message personnalisé"
    },
    "restoreFileVersion": {
      "title": "Restaurer la version du fichier",
      "description": "Êtes-vous sûr de vouloir restaurer <strong>{{resource}}</strong> vers la version <strong>{{version}}</strong> ?"
    },
    "fileShareFormUnauthorizedUsers": {
      "title": "Utilisateurs non autorisés",
      "descriptionForAllUsers": "Vous ne pouvez pas partager de fichiers avec ces utilisateurs en raison des paramètres actuels",
      "descriptionForSomeUsers": "Vous ne pouvez pas partager de fichiers avec ces utilisateurs : <strong> {{users}} </strong> en raison des paramètres actuels, souhaitez-vous partager avec d'autres utilisateurs qui ne sont pas bloqués par le paramètre ?"
    },
    "sessionExpired": {
      "title": "Session expirée",
      "description": "Votre session a expiré. Veuillez vous reconnecter pour continuer.",
      "redirectMessage": "Vous serez redirigé vers la connexion dans <strong>{{seconds}}</strong> secondes…",
      "goToLoginNow": "Allez vous connecter maintenant"
    },
    "appUpdated": {
      "title": "Nouvelle version disponible",
      "description": "Une nouvelle version de l'application est disponible. Veuillez recharger la page pour continuer.",
      "reloadButton": "Recharger"
    },
    "tooManyRequestsOverlay": {
      "title": "Trop de demandes",
      "description": "Vous avez fait trop de demandes en peu de temps. Veuillez patienter un moment avant de réessayer.",
      "redirectMessage": "Vous pourrez réessayer dans <strong>{{seconds}}</strong> secondes…"
    },
    "activateTotpOverlay": {
      "badge": "Protection du compte",
      "title": "Vos fichiers méritent une couche de défense supplémentaire",
      "description1": "Chez CyberGrant, nous savons que les données confidentielles n'ont pas de prix – ou plutôt, elles ont un prix, et il est très élevé pour quiconque souhaite vous les prendre.",
      "description2": "L'authentification à deux facteurs (2FA) ajoute une deuxième couche de vérification qui bloque les accès non autorisés même si les informations d'identification sont compromises.",
      "stat1Value": "99.9%",
      "stat1Label": "des attaques automatisées bloquées avec 2FA",
      "stat2Value": "< 30 ans",
      "stat2Label": "pour terminer la configuration initiale",
      "featuresTitle": "Avec 2FA activé",
      "feature1": "Pas d'accès sans votre téléphone",
      "feature2": "Notification immédiate à chaque tentative suspecte",
      "feature3": "Alignement plus fort avec NIS2 et RGPD",
      "actionActivate": "Activer 2FA maintenant",
      "actionRemind": "Rappelez-moi le jour {{count}}",
      "actionRemind_other": "Rappelez-moi dans {{count}} jours",
      "actionSkipForever": "J'accepte le risque et je ne souhaite pas activer 2FA",
      "skipForever": "Sauter pour toujours",
      "skipForeverConfirmTitle": "Confirmez votre choix",
      "skipForeverConfirmBody1": "Vous choisissez de ne pas activer l’authentification à deux facteurs (2FA). 2FA est la mesure de sécurité la plus simple et la plus efficace que vous puissiez adopter. Ne pas l’activer est un risque inutile et facilement évitable.",
      "skipForeverConfirmBody2": "Êtes-vous sûr de vouloir continuer sans activer l'authentification à deux facteurs (2FA) ?",
      "skipForeverConfirmEnableNow": "Activez-le maintenant",
      "skipForeverConfirmDecline": "Je ne veux pas l'activer",
      "footer": "Vous pouvez gérer 2FA à tout moment à partir des paramètres de sécurité de votre compte.",
      "badgeMandatory": "Action requise",
      "titleMandatory": "L'authentification à deux facteurs est désormais requise",
      "description1Mandatory": "Votre organisation exige une authentification à deux facteurs (2FA) pour votre compte et le délai de grâce pour la configurer est terminé. Vous devez l'activer maintenant pour continuer à utiliser Filegrant.",
      "footerMandatory": "Cette étape est requise par la politique de sécurité de votre organisation et ne peut être reportée."
    },
    "openFileLocallyError": {
      "title": "Client introuvable",
      "description": "Pour ouvrir des documents localement, vous devez avoir installé Remotegrant. Contactez l'administrateur pour l'installer."
    },
    "offline": {
      "title": "Hors ligne",
      "description": "Vous êtes hors ligne. Veuillez vérifier votre connexion Internet et réessayer.",
      "message": "En attente de connexion Internet..."
    },
    "webAppUpdateAvailable": {
      "title": "Mise à jour de l'application Web disponible",
      "description": "Une nouvelle version de l'application Web est disponible. Veuillez actualiser la page pour mettre à jour.",
      "okText": "Mise à jour",
      "cancelText": "Plus tard"
    },
    "keepFilesOfflineError": {
      "title": "Client introuvable",
      "description": "Pour conserver les fichiers sur votre PC, vous devez avoir installé l'agent RemoteGrant. Contactez votre administrateur pour l'installer."
    },
    "sharingApprovalRequirementReviewTeamForm": {
      "title": "Gérer l'équipe d'examen",
      "description": "Gérer l’équipe de révision pour l’exigence d’approbation de partage."
    },
    "tagsRequiredForShare": {
      "title": "Étiquettes requises pour le partage",
      "description": "Le fichier <strong>{{resource}}</strong> nécessite le partage d'étiquettes. Veuillez ajouter des étiquettes au fichier et réessayer.",
      "description_other": "Certains de ces fichiers nécessitent le partage d'étiquettes. Veuillez ajouter des étiquettes aux fichiers et réessayer."
    },
    "tagsRequiredForDownload": {
      "title": "Étiquettes requises pour le téléchargement",
      "description": "Le fichier <strong>{{resource}}</strong> nécessite le téléchargement d'étiquettes. Veuillez ajouter des étiquettes au fichier et réessayer.",
      "description_other": "Certains de ces fichiers nécessitent le téléchargement d'étiquettes. Veuillez ajouter des étiquettes aux fichiers et réessayer."
    },
    "filesWithShortcutsDeleteConfirmation": {
      "title": "Supprimer des fichiers ?",
      "description": "Êtes-vous sûr de vouloir supprimer <strong>{{resource}}</strong> ? Des raccourcis vers les fichiers sélectionnés ont été trouvés. Si vous supprimez ce fichier, ces raccourcis ne fonctionneront plus <br /><br />Voulez-vous continuer ?",
      "description_other": "Êtes-vous sûr de vouloir supprimer <strong>ces fichiers</strong> ? Des raccourcis vers les fichiers sélectionnés ont été trouvés. Si vous supprimez ces fichiers, ces raccourcis ne fonctionneront plus <br /><br />Voulez-vous continuer ?"
    },
    "officeTokenExpired": {
      "title": "Session expirée",
      "description": "Actualisez la page pour continuer"
    },
    "officeEditorBeta": {
      "title": "Essayez le nouveau FileGrant Office ?",
      "description": "FileGrant Office est disponible en version bêta. Vous pouvez continuer à utiliser l'éditeur classique ou essayer la nouvelle expérience pour cette session.",
      "tryNew": "Essayez le nouvel éditeur",
      "useClassic": "Utiliser l'éditeur classique"
    },
    "officeEditorDelete": {
      "title": "Mettre dans la corbeille et fermer l'éditeur ?",
      "description": "Le fichier sera déplacé vers la corbeille et l'éditeur se fermera. Les modifications non enregistrées sont gérées par la sauvegarde automatique."
    },
    "applyIsUsedForFileVisibilityTags": {
      "title": "Appliquer des étiquettes aux fichiers",
      "description": "L'application des étiquettes sélectionnées partagera automatiquement ces fichiers avec d'autres utilisateurs, selon les paramètres de visibilité des fichiers balisés.<br /><br />Étiquettes concernées :<br /><strong>{{resource}}</strong><br /><br />Voulez-vous continuer ?",
      "description_other": "L'application de certaines des étiquettes sélectionnées partagera automatiquement ces fichiers avec d'autres utilisateurs, selon les paramètres de visibilité des fichiers balisés.<br /><br />Étiquettes concernées :<br /><strong>{{resource}}</strong><br /><br />Voulez-vous continuer ?"
    },
    "convertToPdf": {
      "title": "Convertir en PDF",
      "selectDestination": "Sélectionner le dossier de destination"
    }
  },
  "specialFolders": {
    "FTA27E720F2F2BD4718893095FE4354A4F6": "Partage rapide"
  },
  "viewer": {
    "eml": {
      "attachments": "Pièces jointes",
      "cc": "Cc",
      "date": "Date",
      "downloadAttachment": "Télécharger {{name}}",
      "emptyBody": "Ce message n'a aucun contenu de corps.",
      "from": "De",
      "parseError": "Ce fichier de courrier électronique n'a pas pu être analysé.",
      "showRawSource": "Afficher la source brute",
      "subject": "Sujet",
      "to": "À"
    },
    "ics": {
      "description": "Description",
      "empty": "Aucun événement de calendrier trouvé dans ce fichier.",
      "end": "Fin",
      "location": "Emplacement",
      "organizer": "Organisateur",
      "parseError": "Ce fichier de calendrier n'a pas pu être analysé.",
      "showRaw": "Afficher la source brute",
      "start": "Commencer",
      "untitled": "Événement sans titre"
    },
    "msg": {
      "attachments": "Pièces jointes",
      "cc": "Cc",
      "date": "Date",
      "downloadAttachment": "Télécharger {{name}}",
      "emptyBody": "Ce message n'a aucun contenu de corps.",
      "from": "De",
      "parseError": "Ce message Outlook n'a pas pu être analysé.",
      "showRawSource": "Afficher la source brute",
      "subject": "Sujet",
      "to": "À"
    },
    "vcf": {
      "email": "Courriel",
      "empty": "Aucun contact trouvé dans ce fichier.",
      "note": "Remarque",
      "organization": "Organisation",
      "parseError": "Ce fichier de contacts n'a pas pu être analysé.",
      "phone": "Téléphone",
      "showRaw": "Afficher la source brute",
      "title": "Titre",
      "unnamed": "Contact anonyme"
    },
    "htmlPreview": {
      "title": "Ouvrir l'aperçu HTML",
      "description": "Ce fichier HTML peut contenir du code JavaScript potentiellement dangereux. L'aperçu sera affiché dans un environnement sandbox pour des raisons de sécurité. Voulez-vous continuer ?",
      "button": "Aperçu HTML",
      "hideButton": "Masquer l'aperçu"
    },
    "error": {
      "decryptFailed": {
        "title": "Échec du décryptage",
        "description": "Le fichier ne peut pas être déchiffré. Veuillez réessayer."
      },
      "officeNoPreview": {
        "title": "Aucun aperçu disponible",
        "description": "Attention : vérifiez à nouveau la fiabilité de la source avant de télécharger ce fichier original."
      },
      "blobFetchFailed": {
        "title": "Fichier introuvable",
        "description": "Le fichier n'a pas été trouvé. Veuillez réessayer."
      },
      "fetchFilePermissionsFailed": {
        "title": "Échec de la récupération des autorisations de fichier",
        "description": "Les autorisations du fichier n'ont pas pu être récupérées. Veuillez réessayer."
      },
      "isFolder": {
        "title": "Le fichier est un dossier",
        "description": "Le fichier est un dossier. Ne peut pas être ouvert dans la visionneuse."
      },
      "fetchFileFailed": {
        "title": "La récupération du fichier a échoué",
        "description": "Le fichier n'a pas pu être récupéré. Veuillez réessayer."
      },
      "noPreviewAvailable": {
        "title": "Aucun aperçu disponible",
        "description": "Attention : vérifiez à nouveau la fiabilité de la source avant de télécharger ce fichier original."
      },
      "noPermissions": {
        "title": "Aucune autorisation",
        "description": "Vous n'êtes pas autorisé à ouvrir ce fichier."
      }
    },
    "sign": {
      "title": "Ajouter une signature",
      "add": "Ajouter une signature",
      "delete": "Supprimer la signature",
      "pickFolder": "Choisir le dossier de destination",
      "saveSignature": "Enregistrer aussi cette signature dans Fichiers",
      "selectFolderHint": "Sélectionnez une position pour afficher le chemin du dossier où vous souhaitez enregistrer la signature",
      "unavailable": "La signature PDF n'est pas disponible avec la licence actuelle du visionneur.",
      "success": "PDF signé enregistré",
      "error": "Impossible d'enregistrer le PDF signé",
      "flattenWarning": "La signature ne pourra pas être retirée après l'enregistrement. Vérifiez avant d'enregistrer.",
      "modeEnabled": "Mode signature activé",
      "modeDisabled": "Mode signature désactivé",
      "tab": {
        "draw": "Dessiner",
        "upload": "Téléverser",
        "drive": "Depuis Fichiers"
      },
      "draw": {
        "hint": "Dessinez votre signature dans le cadre",
        "clear": "Effacer"
      },
      "upload": {
        "dropHint": "Déposez une image ici ou cliquez pour parcourir"
      },
      "replaceOrCopy": {
        "title": "Enregistrer le PDF signé",
        "replace": "Remplacer l'original",
        "replaceHint": "Écraser le PDF actuel avec la version signée",
        "copy": "Enregistrer une copie",
        "copyHint": "Conserver l'original et enregistrer le PDF signé dans un dossier de votre choix"
      }
    }
  },
  "store": {
    "fileSalesOverview": "Aperçu des ventes de fichiers",
    "totalSales": "Unités vendues",
    "fileRevenue": "Revenus des fichiers",
    "unitRevenue": "Prix unitaire",
    "stock": "Actions",
    "openStoreLink": "Ouvrir le lien du magasin",
    "salesDashboard": "Tableau de bord des ventes",
    "confirmEmail": "Confirmer l’e-mail",
    "confirmEmailPlaceholder": "Confirmez votre e-mail",
    "emailPlaceholder": "vous@exemple.com",
    "pleaseEnterEmail": "Veuillez saisir votre e-mail",
    "pleaseConfirmEmail": "Veuillez confirmer votre e-mail",
    "emailsDoNotMatch": "Les deux e-mails ne correspondent pas !",
    "invalidEmail": "L’e-mail n’est pas valide !",
    "payNow": "Payer maintenant",
    "paymentSuccessful": "Paiement réussi !",
    "fileAlreadySold": "Fichier déjà vendu à cet e-mail",
    "emailsMismatch": "L’e-mail et la confirmation ne correspondent pas.",
    "invalidEmailFormat": "Format d’e-mail invalide",
    "fileNotFound": "Fichier introuvable",
    "filePreview": "Aperçu du fichier",
    "filePreviewAlt": "Aperçu du fichier",
    "fileFullPreviewAlt": "Aperçu complet du fichier",
    "byOwner": "Par {{name}}",
    "purchase": "Acheter"
  },
  "dashboard": {
    "title": "Rapport exécutif",
    "tabs": {
      "overview": "Aperçu"
    },
    "riskIndicators": {
      "title": "Indicateurs de risque",
      "untaggedFiles": {
        "label": "Fichiers non balisés",
        "description": "Pourcentage de fichiers non classés avec des étiquettes. Une valeur élevée indique un risque de non-conformité aux politiques de classification des données."
      },
      "sharingWithoutExpiration": {
        "label": "Partage sans expiration",
        "description": "Pourcentage d'actions sans date d'expiration. Les partages perpétuels augmentent le risque d’accès non autorisé au fil du temps."
      },
      "editorSharing": {
        "label": "Partage des autorisations de l'éditeur",
        "description": "Pourcentage de partages avec autorisations de modification. Des valeurs élevées augmentent le risque de modification non autorisée des données."
      },
      "externalSharing": {
        "label": "Partage externe",
        "description": "Pourcentage de partages vers des domaines externes. Des valeurs élevées peuvent indiquer un risque de fuite de données sensibles."
      },
      "excessiveExpiration": {
        "label": "Expiration excessive",
        "description": "Pourcentage d'actions actives dont l'expiration dépasse 90 jours. Un accès prolongé augmente le risque de compromission."
      },
      "userConcentration": {
        "label": "Concentration des utilisateurs",
        "description": "Pourcentage maximum de partages effectués par un seul utilisateur. Une concentration élevée indique un risque de menace interne ou de compte compromis."
      },
      "thresholds": "Seuils"
    },
    "ssoCoverage": {
      "label": "Utilisateurs internes sans SSO",
      "asOfNow": "À l'instant",
      "excluded": "Exclus du SSO",
      "outsideDomains": "Domaine e-mail non couvert par le SSO",
      "description": "Instantané actuel des utilisateurs internes activés (tous les rôles sauf External, non expirés) qui se connectent par OTP e-mail au lieu du SSO. L'exclusion du SSO prime sur le domaine non couvert. Ne suit pas la plage de dates du rapport."
    },
    "riskDetail": {
      "viewDetails": "Détails",
      "user": "Utilisateur",
      "domain": "Domaine",
      "domains": "Domaines",
      "shares": "Actions",
      "noData": "Aucune donnée disponible pour cet indicateur",
      "totalUsers": "{{count}} utilisateurs concernés",
      "countLabel": {
        "editorSharing": "Partages de l'éditeur",
        "untaggedFiles": "Fichiers non balisés",
        "sharingWithoutExpiration": "Sans expiration",
        "externalSharing": "Partages externes",
        "excessiveExpiration": "Actions excessives",
        "userConcentration": "Total des actions"
      }
    },
    "volumeData": {
      "volume": "Volume",
      "files": "Fichiers",
      "folders": "Dossiers",
      "total": "Total des articles"
    },
    "classification": {
      "title": "Classement des étiquettes",
      "withTag": "Avec ÉTIQUETTE",
      "withoutTag": "Sans ÉTIQUETTE"
    },
    "sharing": {
      "internal": "Partager avec les internes",
      "external": "Partager avec des externes",
      "readOnly": "Partager en lecture seule",
      "editor": "Partager avec l'éditeur"
    },
    "expiration": {
      "title": "Expiration du partage",
      "withExpiration": "avec expiration",
      "withoutExpiration": "sans expiration"
    },
    "expirationAnalysis": {
      "title": "Analyse détaillée de l'expiration",
      "count": "Compter",
      "average": "Durée moyenne",
      "active": "Actif",
      "expired": "Expiré",
      "min": "Durée minimale",
      "max": "Durée maximale",
      "days": "jours",
      "distribution": {
        "expired": "Expiré",
        "expiringSoon": "0-7 jours",
        "shortTerm": "7-30 jours",
        "mediumTerm": "30-90 jours",
        "longTerm": "90-365 jours",
        "excessive": ">365 jours"
      }
    },
    "domains": {
      "title": "Domaines destinataires",
      "domain": "Domaine",
      "type": "Tapez",
      "count": "Compter",
      "distribution": "Distribution",
      "internal": "Interne",
      "external": "Externe",
      "openRecipients": "Ouvrir les destinataires des partages pour {{domain}}"
    },
    "users": {
      "title": "Statistiques des utilisateurs",
      "user": "Utilisateur",
      "files": "Fichiers",
      "folders": "Dossiers",
      "total": "Total",
      "sharing": "Partage",
      "withSharing": "Avec partage",
      "withoutSharing": "Sans partage"
    },
    "refresh": "Actualiser le rapport",
    "retry": "Réessayer",
    "period": "Période",
    "apply": "Postuler",
    "lastMonth": "Le mois dernier",
    "last3Months": "3 derniers mois",
    "year": "Année",
    "all": "Tout",
    "cachedData": "Données mises à jour à : {{date}}",
    "internalDomains": "Domaines internes",
    "critical": "critique",
    "warnings": "avertissements",
    "criticalAlert": "Indicateurs de risque critiques détectés. Action immédiate requise.",
    "warningAlert": "Indicateurs de risque d’avertissement détectés. Revue recommandée.",
    "securityIncidents": {
      "title": "Incidents de sécurité et alertes",
      "noData": "Aucun incident de sécurité ni alerte sur cette période",
      "dateTime": "Date et heure",
      "severityColumn": "Gravité",
      "category": "Tapez",
      "description": "Description",
      "user": "Utilisateur",
      "ipAddress": "Adresse IP",
      "country": "Pays",
      "viewInActivityLog": "Afficher dans le journal d'activité",
      "severityLevels": {
        "critical": "Critique",
        "error": "Erreur",
        "warning": "Avertissement",
        "info": "Informations"
      },
      "categories": {
        "loginFailed": "Échec de la connexion",
        "suspiciousAccess": "Accès suspect",
        "policyViolation": "Violation des règles",
        "permissionDenied": "Autorisation refusée",
        "rateLimitExceeded": "Limite de débit dépassée",
        "configurationAlert": "Changement de configuration",
        "sharingViolation": "Violation du partage",
        "dataExportAlert": "Exportation de données"
      }
    },
    "securityAnomalies": {
      "title": "Anomalies de sécurité",
      "noData": "Aucune anomalie de sécurité ouverte sur cette période",
      "criticalAlert": "{{count}} anomalie de sécurité critique nécessitant une attention particulière",
      "criticalAlert_other": "{{count}} anomalies de sécurité critiques nécessitent une attention particulière",
      "byDetectorTitle": "Anomalies par type",
      "summary": {
        "totalOpen": "Anomalies ouvertes",
        "critical": "Critique",
        "warning": "Avertissement",
        "info": "Informations"
      },
      "severityColumn": "Gravité",
      "type": "Tapez",
      "anomaly": "Anomalie",
      "events": "Événements",
      "lastSeen": "Vu pour la dernière fois",
      "actionsColumn": "Actions",
      "handledAt": "Traité",
      "tabs": {
        "open": "Ouvert",
        "managed": "Géré"
      },
      "actions": {
        "hide": "Marquer comme traité",
        "restore": "Restaurer"
      },
      "hideConfirmTitle": "Marquer cette anomalie comme traitée ?",
      "hideNotePlaceholder": "Note facultative (raison)…",
      "restoreConfirmTitle": "Restaurer cette anomalie ?",
      "hideSuccess": "Anomalie marquée comme traitée",
      "hideError": "Impossible de marquer l'anomalie comme traitée",
      "restoreSuccess": "Anomalie restaurée",
      "restoreError": "Impossible de restaurer l'anomalie",
      "managedLoadError": "Impossible de charger les anomalies gérées",
      "managedNoData": "Aucune anomalie gérée",
      "severityLevels": {
        "critical": "Critique",
        "warning": "Avertissement",
        "info": "Informations"
      },
      "detectors": {
        "admin_ip_blocked": "Accès administrateur depuis une adresse IP bloquée",
        "unauthorized_country": "Accès depuis un pays non autorisé",
        "brute_force_login": "Connectez-vous par force brute",
        "password_spray": "Spray de mot de passe",
        "folder_password_brute_force": "Mot de passe du dossier par force brute",
        "public_link_brute_force": "Lien public par force brute",
        "security_signal": "Signal de sécurité"
      }
    },
    "activityMap": {
      "title": "Activité par pays",
      "noData": "Aucune donnée de localisation d'activité au cours de cette période",
      "activities": "{{count}} activités",
      "failedLogins": "{{count}} connexions échouées",
      "legendLow": "Faible",
      "legendHigh": "Élevé",
      "selectedCountry": "{{country}}",
      "hint": "Cliquez sur un pays sur la carte pour voir les détails.",
      "viewDetails": "Afficher les détails d'accès",
      "periodNote": "Les données cartographiques couvrent les 90 derniers jours.",
      "periodRange": "Cartographiez les données de {{from}} à {{to}}."
    },
    "geoDetail": {
      "title": "Détails d'accès — {{country}}",
      "totalUsers": "{{count}} utilisateurs",
      "user": "Utilisateur",
      "activities": "Activités",
      "failedLogins": "Échec de connexion",
      "distinctIps": "IP",
      "lastAccess": "Dernier accès",
      "anonymous": "Anonyme",
      "noData": "Aucune donnée d'accès pour ce pays dans la période sélectionnée",
      "geoUnavailable": "Géolocalisation indisponible"
    },
    "recipients": {
      "title": "Destinataires des partages",
      "domainSubtitle": "Domaine : {{domain}}",
      "refreshHint": "Recalculer les données (au plus une fois toutes les 30 secondes)",
      "topTitle": "Top 10 des destinataires par éléments partagés",
      "noData": "Aucun destinataire sur la période sélectionnée",
      "countingRulesTitle": "Comment les destinataires sont comptés",
      "countingRules": {
        "active": "Seuls les partages actifs comptent : les partages expirés, en attente, refusés, révoqués ou épuisés et les fichiers dans la corbeille sont exclus.",
        "direct": "Seuls les partages directs comptent : un dossier partagé est un seul élément, son contenu n'est pas développé.",
        "group": "Un groupe est un seul destinataire (les membres sont indiqués à titre informatif) ; tous les liens publics forment une seule ligne.",
        "domainCount": "Ces totaux peuvent être inférieurs à ceux des Domaines destinataires, qui incluent tous les partages de la période."
      },
      "summary": {
        "internalUsers": "Utilisateurs internes",
        "externalUsers": "Utilisateurs externes",
        "groups": "Groupes",
        "publicLinks": "Liens publics",
        "totalShares": "Partages totaux"
      },
      "types": {
        "all": "Tous les types",
        "internal": "Interne",
        "external": "Externe",
        "group": "Groupe",
        "public": "Public"
      },
      "type": "Type",
      "domain": "Domaine",
      "domainPlaceholder": "Filtrer par domaine",
      "searchPlaceholder": "Rechercher un nom ou un e-mail",
      "editorOnly": "Partages éditeur uniquement",
      "withoutExpirationOnly": "Sans expiration uniquement",
      "sortBy": "Trier par",
      "sortByValue": "Trier par : {{field}}",
      "sort": {
        "items": "Éléments",
        "editor": "Partages éditeur",
        "withoutExpiration": "Sans expiration",
        "lastShared": "Dernier partage",
        "owners": "Propriétaires",
        "name": "Nom"
      },
      "totalRecipients": "{{count}} destinataires",
      "name": "Nom",
      "email": "E-mail",
      "members": "Membres",
      "items": "Éléments",
      "filesFolders": "{{files}} fichiers / {{folders}} dossiers",
      "editorShares": "Éditeur",
      "withoutExpiration": "Sans expiration",
      "withoutPassword": "Sans mot de passe",
      "owners": "Propriétaires",
      "lastShared": "Dernier partage",
      "highestRisk": "Risque maximal",
      "publicLinks": "Liens publics",
      "unknown": "Inconnu",
      "itemsTitle": "Partagé avec {{name}}",
      "totalItems": "{{count}} éléments partagés",
      "noItems": "Aucun partage actif sur la période sélectionnée",
      "itemName": "Nom",
      "file": "Fichier",
      "folder": "Dossier",
      "size": "Taille",
      "owner": "Propriétaire",
      "permission": "Autorisation",
      "editor": "Éditeur",
      "viewer": "Lecteur",
      "expiration": "Expiration",
      "never": "Jamais",
      "createdAt": "Partagé le",
      "canDownload": "Téléchargement",
      "passwordProtected": "Mot de passe",
      "accesses": "Accès",
      "accessCountValue": "{{count}} / {{max}}",
      "unlimited": "Illimité",
      "yes": "Oui",
      "no": "Non"
    },
    "errors": {
      "accessDenied": "Accès refusé",
      "accessDeniedDescription": "Vous n'êtes pas autorisé à consulter le rapport exécutif. Seuls les administrateurs peuvent accéder à cette section.",
      "serverError": "Erreur système",
      "serverErrorDescription": "Impossible de générer le rapport. Veuillez réessayer plus tard.",
      "noData": "Aucune donnée disponible",
      "pdfExportFailed": "Échec de l'exportation du tableau de bord au format PDF. Veuillez réessayer ou contacter l'assistance.",
      "folderPasswordForm": {
        "title": "Protection par mot de passe du dossier"
      },
      "invalidFilter": "Filtre non valide : il a été réinitialisé.",
      "recipientNotFound": "Destinataire introuvable. La liste a été actualisée."
    }
  },
  "aiClassificationStatus": {
    "none": "Aucun",
    "queued": "En file d'attente...",
    "classifying": "Classement...",
    "done": "Terminé",
    "error": "Erreur",
    "unknown": "Inconnu"
  },
  "webSocketStatus": {
    "idle": "Inactif",
    "connecting": "Connexion",
    "open": "Ouvert",
    "closing": "Clôture",
    "closed": "Fermé",
    "error": "Erreur"
  },
  "fileOfflineStatus": {
    "Pending": "En file d'attente pour la synchronisation des appareils",
    "Downloading": "Téléchargement sur l'appareil",
    "Downloaded": "Synchronisé sur l'appareil"
  },
  "file": {
    "antivirus": {
      "pending": "Analyse antivirus en cours",
      "rescanPending": "Nouvelle analyse en file d'attente — le fichier reste bloqué ({{threatName}})",
      "infected": "Menace détectée : {{threatName}}",
      "error": "L'antivirus n'a pas pu vérifier ce fichier",
      "errors": {
        "STREAM_TOO_LARGE": "Non vérifié par l'antivirus — fichier trop volumineux pour l'analyse",
        "ENGINE_UNREACHABLE": "Moteur antivirus injoignable",
        "SCAN_TIMEOUT": "Analyse antivirus expirée",
        "MAX_RETRIES": "Analyse antivirus échouée après plusieurs tentatives"
      },
      "rescanFailed": "Nouvelle analyse échouée — le fichier reste bloqué ({{threatName}})",
      "retry": "Relancer l'analyse",
      "contactAdmin": "Contactez votre administrateur si vous pensez qu'il s'agit d'un faux positif.",
      "stickyNote": "Un nouvel envoi, une restauration de version ou une modification dans Office ne supprimera pas cette menace.",
      "tooLarge": "Non vérifié par l'antivirus — fichier trop volumineux pour l'analyse"
    }
  },
  "batch": {
    "status": {
      "all": "Tout",
      "queued": "En file d'attente",
      "processing": "Traitement",
      "completed": "Terminé",
      "failed": "Échec",
      "partiallycompleted": "Partiellement terminé",
      "cancelled": "Annulé"
    },
    "operation": {
      "all": "Toutes les opérations",
      "classification": "Classement de l'IA",
      "folderexpansion": "Extension de dossier",
      "delete": "Supprimer"
    },
    "failedFiles": "Le fichier {{count}} a échoué",
    "failedFiles_other": "{{count}} fichiers ont échoué",
    "eta": "ETA",
    "failedFilesDetail": "Détails des fichiers ayant échoué",
    "noFailedFiles": "Aucun fichier échoué",
    "fileCancelled": "Annulation demandée pour ce fichier.",
    "fileCancelError": "Erreur lors de la demande d'annulation du fichier.",
    "fileRetried": "Fichier en file d'attente pour nouvelle tentative",
    "fileRetryError": "Erreur lors de la nouvelle tentative du fichier",
    "cancelAllFailed": "Annuler tous les lots en échec (pas en cours)",
    "cancelAllFailedConfirmTitle": "Annuler tous les lots en échec ?",
    "cancelAllFailedConfirmContent": "Seuls les lots au statut Échec seront effacés. Les lots en cours ou en file d’attente continuent et ne sont pas concernés. Cette opération ne peut pas être annulée."
  },
  "entraId": {
    "importFromEntraId": "Importer depuis Entra ID",
    "importGroupsTitle": "Importer des groupes depuis Microsoft Entra ID",
    "importUsersTitle": "Importer des utilisateurs depuis Microsoft Entra ID",
    "searchGroups": "Rechercher des groupes...",
    "selectNew": "Sélectionnez nouveau uniquement",
    "existing": "Existant",
    "new": "Nouveau",
    "importMembers": "Importer également les membres du groupe",
    "importSelected": "Importer ({{count}})",
    "importSuccess": "Importation terminée : {{created}} créé, {{updated}} mis à jour",
    "importError": "Erreur lors de l'importation",
    "errorLoadingGroups": "Erreur lors du chargement des groupes à partir d'Entra ID",
    "errorLoadingUsers": "Erreur lors du chargement des utilisateurs à partir d'Entra ID",
    "noGroupsFound": "Aucun groupe trouvé",
    "noUsersFound": "Aucun utilisateur trouvé",
    "resultSummary": "Créé : {{created}}, Mis à jour : {{updated}}, Ignoré : {{skipped}}, Échec : {{failed}}",
    "usersImported": "{{count}} membre(s) également importé(s)",
    "permissionErrorTitle": "Autorisations Azure AD insuffisantes",
    "permissionErrorDescription": "L'application Azure AD ne dispose pas des autorisations suffisantes pour accéder à l'API Microsoft Graph.",
    "permissionErrorSteps": "Pour résoudre ce problème :",
    "permissionErrorStep1": "Accédez au portail Azure > Inscriptions d’applications > Votre application",
    "permissionErrorStep2": "Accédez aux autorisations de l'API",
    "permissionErrorStep3": "Ajoutez les autorisations d'application requises (non déléguées)",
    "permissionErrorStep4": "Cliquez sur \"Accorder le consentement de l'administrateur\" pour autoriser les autorisations",
    "requiredPermissions": "Autorisations requises",
    "filterBySync": "Filtrer par synchronisation",
    "syncedWithEntraId": "Synchronisé avec Entra ID",
    "syncedTooltip": "Synchronisé avec Microsoft Entra ID",
    "searchUsers": "Rechercher des utilisateurs...",
    "importUsersSuccess": "Importation terminée : {{created}} créé, {{updated}} mis à jour",
    "usersResultSummary": "Créé : {{created}}, Mis à jour : {{updated}}, Ignoré : {{skipped}}, Échec : {{failed}}",
    "defaultRole": "Rôle par défaut"
  },
  "continents": {
    "europe": "Europe",
    "asia": "Asie",
    "africa": "Afrique",
    "northAmerica": "Amérique du Nord",
    "southAmerica": "Amérique du Sud",
    "oceania": "Océanie",
    "antarctica": "Antarctique"
  },
  "components": {
    "countrySelect": {
      "placeholder": "Sélectionnez des pays...",
      "euOption": "Union européenne (les 27 pays)",
      "searchPlaceholder": "Rechercher des pays..."
    },
    "regionSelect": {
      "placeholder": "Sélectionnez des régions ou saisissez des codes ISO...",
      "euOption": "Union européenne",
      "searchPlaceholder": "Rechercher des régions..."
    },
    "ipCidrInput": {
      "placeholder": "Saisissez des adresses IP ou des plages CIDR, séparées par des virgules.",
      "helperText": "Exemples : 192.168.1.100, 10.0.0.0/8, 2001:db8::/32",
      "invalidEntry": "Entrez une adresse IP ou une plage CIDR valide",
      "invalidEntries": "Entrées invalides : {{entries}}"
    },
    "ipRegionExceptionForm": {
      "title": "Gérer les exceptions IP/région",
      "description": "Accorder des critères d'accès supplémentaires à des utilisateurs ou des groupes spécifiques",
      "typeLabel": "Type d'exception",
      "additionalIpsTitle": "IP supplémentaires autorisées",
      "addAllowedIp": "Ajouter une adresse IP ou CIDR",
      "additionalCountriesTitle": "Pays supplémentaires autorisés",
      "additionalRegionsTitle": "Régions autorisées supplémentaires",
      "expirationTitle": "Date d'expiration",
      "expirationNone": "Aucune expiration",
      "expirationCustom": "Expire le :",
      "reasonTitle": "Raison (de l'audit)",
      "reasonPlaceholder": "Par exemple, voyage d'affaires à Londres - février 2026",
      "addException": "Ajouter une exception",
      "existingExceptions": "Exceptions existantes",
      "fetchError": "Une erreur s'est produite lors de la récupération des exceptions. Veuillez réessayer.",
      "selectAtLeastOne": "Sélectionnez au moins un utilisateur ou un groupe",
      "atLeastOneCriterion": "Ajoutez au moins une adresse IP, un pays ou une région : une exception sans critère n'accorde rien",
      "alreadyPresent": "Les utilisateurs ou groupes sélectionnés bénéficient déjà d'une exception à cette restriction"
    }
  },
  "email": {
    "inbox": "Boîte de réception",
    "sent": "Envoyé",
    "favorites": "Favoris",
    "trash": "Corbeille",
    "drafts": "Brouillons",
    "noEmails": "Aucun e-mail dans ce dossier",
    "noEmailsFound": "Aucun e-mail trouvé",
    "noSubject": "(Aucun sujet)",
    "searchPlaceholder": "Rechercher des e-mails",
    "newMessage": "Nouveau message",
    "newEmail": "Courriel",
    "folders": "Dossiers",
    "to": "À",
    "from": "De",
    "cc": "Cc",
    "bcc": "Cci",
    "subject": "Sujet",
    "date": "Date",
    "body": "Corps",
    "send": "Envoyer",
    "sending": "Envoi...",
    "cancel": "Annuler",
    "draftIdle": "En attente de changements",
    "draftSaveError": "Échec de l'enregistrement",
    "draftSaved": "Brouillon enregistré",
    "draftSaving": "Sauvegarde...",
    "editDraft": "Modifier le brouillon",
    "saveDraft": "Enregistrer le brouillon",
    "sendError": "Échec de l'envoi de l'e-mail",
    "errorExternalSharingNotAllowed": "Les destinataires suivants ne sont pas autorisés",
    "errorSharingDenied": "Vous n'êtes pas autorisé à partager ces fichiers",
    "errorPartialSharingDenied": "Certaines pièces jointes ne peuvent pas être partagées avec les destinataires sélectionnés",
    "errorCannotAccessFiles": "Vous n'avez pas accès aux fichiers joints",
    "attachmentReadOnly": "Visualisation uniquement",
    "attachmentEditor": "Peut modifier",
    "attachmentExpirationWarning": "Le partage expirera dans {{days}} jours",
    "attachmentPermission": "Autorisation",
    "writeMessage": "Écrivez votre message...",
    "attachFiles": "Joindre des fichiers",
    "attachments": "Pièces jointes",
    "hasAttachments": "A des pièces jointes",
    "addFavorite": "Ajouter aux favoris",
    "removeFavorite": "Supprimer des favoris",
    "moveToTrash": "Déplacer vers la corbeille",
    "archive": "Archiver",
    "archiveAction": "Archiver",
    "unarchiveAction": "Déplacer vers la boîte de réception",
    "restore": "Restaurer",
    "deleteDraft": "Supprimer le brouillon",
    "deleteDraftConfirm": "Mettre ce brouillon dans la corbeille ? Vous pourrez le restaurer depuis la corbeille plus tard.",
    "deletePermanently": "Supprimer définitivement",
    "bold": "Audacieux",
    "italic": "Italique",
    "underline": "Souligner",
    "bulletList": "Liste à puces",
    "fontSmall": "Petit",
    "fontNormal": "Normale",
    "fontLarge": "Grand",
    "fontHuge": "Énorme",
    "sendingInProgress": "Envoi en cours",
    "stepPreparing": "Préparation du message pour la livraison",
    "stepValidating": "Validation des destinataires",
    "stepArchiving": "Archivage pour sécuriser le stockage",
    "stepDelivering": "Remise aux destinataires...",
    "secureDelivery": "Livraison sécurisée - Entreprise protégée",
    "protect": "Protéger avec un mot de passe",
    "protectionTitle": "Protection par mot de passe",
    "protectionPassword": "Mot de passe",
    "protectionConfirm": "Confirmer le mot de passe",
    "protectionHint": "Indice (facultatif)",
    "protectionMismatch": "Les mots de passe ne correspondent pas",
    "protectionWarning": "Le contenu de l'e-mail sera crypté localement. Si vous perdez ce mot de passe, le message ne pourra pas être récupéré.",
    "protectedMessage": "Ce message est protégé par un mot de passe.",
    "protectedSnippet": "Message protégé",
    "protectedHintLabel": "Indice",
    "enterPassword": "Entrez le mot de passe pour lire le message",
    "unlock": "Déverrouiller",
    "wrongPassword": "Mot de passe incorrect. Veuillez réessayer.",
    "reply": "Répondre",
    "forward": "En avant",
    "forwardedMessage": "Message transféré",
    "forwardExpired": "Le message d'origine a expiré, le transfert a été annulé.",
    "forwardAttachmentsTitle": "Transférer les pièces jointes",
    "forwardAttachmentsMessage": "Ce message contient des pièces jointes. Souhaitez-vous les inclure dans le message transféré ?",
    "forwardWithAttachments": "Avec pièces jointes",
    "forwardWithoutAttachments": "Sans pièces jointes",
    "selectFromFileGrant": "Sélectionnez parmi FileGrant",
    "uploadFromDevice": "Télécharger depuis l'appareil",
    "selectFiles": "Sélectionner des fichiers",
    "selectFolderForUpload": "Sélectionnez le dossier de téléchargement",
    "filesSelected": "{{count}} fichier(s) sélectionné(s)",
    "confirm": "Confirmer",
    "expiration": "Expiration",
    "expirationTitle": "Date d'expiration",
    "expirationDescription": "L'e-mail ne sera plus accessible après la date sélectionnée.",
    "expirationPlaceholder": "Sélectionnez la date et l'heure d'expiration",
    "expiresOn": "Expire le {{date}}",
    "expired": "Expiré le {{date}}",
    "selected": "{{count}} sélectionné",
    "markAsRead": "Marquer comme lu",
    "markAsUnread": "Marquer comme non lu",
    "deletePermanentlyConfirm": "Êtes-vous sûr de vouloir supprimer définitivement les {{count}} e-mails ? Cette action ne peut pas être annulée.",
    "selectAll": "Tout sélectionner",
    "deselectAll": "Tout désélectionner",
    "removeAttachment": "Supprimer la pièce jointe",
    "removeAttachmentConfirm": "Voulez-vous supprimer cette pièce jointe ? L'accès sera révoqué pour tous les destinataires.",
    "attachmentNotFound": "Pièce jointe introuvable",
    "featureNotAvailable": "Fonctionnalité non disponible",
    "removeRecipient": "Supprimer le destinataire",
    "removeRecipientsConfirm": "Voulez-vous supprimer {{count}} destinataire(s) ? Ils ne pourront plus voir cet e-mail et l'accès aux pièces jointes sera révoqué.",
    "emailNotFound": "E-mail introuvable",
    "recipientNotFound": "Destinataire introuvable",
    "mustKeepOneRecipient": "Au moins un destinataire doit rester",
    "replyAll": "Répondre à tous",
    "activity": "Activité",
    "cannotCreateEmail": "Vous n'êtes pas autorisé à créer de nouveaux e-mails",
    "blockForward": "Bloquer en avant",
    "blockForwardDescription": "Les destinataires ne pourront pas transférer cet e-mail",
    "advancedProtection": "Protection avancée",
    "protectDescription": "Les destinataires auront besoin d'un mot de passe pour lire cet e-mail"
  },
  "note": {
    "createNote": "Remarque",
    "createTitle": "Créer une note",
    "newNote": "Nouvelle remarque",
    "fileName": "Nom du fichier",
    "fileNameRequired": "Le nom du fichier est obligatoire",
    "placeholder": "Écrivez votre note...",
    "loadError": "Impossible de charger la note",
    "sidebarTitle": "Remarques",
    "editing": "Édition",
    "reading": "Lecture",
    "codeBlock": "Bloc de code",
    "rename": "Renommer",
    "renamed": "Fichier renommé",
    "renameError": "Impossible de renommer le fichier",
    "saved": "Remarque enregistrée",
    "saveError": "Impossible d'enregistrer la note",
    "checklist": "Liste de contrôle",
    "linkUrl": "URL du lien",
    "linkText": "Texte du lien",
    "insertLink": "Insérer un lien",
    "saving": "Sauvegarde…",
    "savedShort": "Enregistré",
    "delete": "Supprimer la note",
    "deleteTitle": "Supprimer la note",
    "deleteConfirm": "Supprimer la note « {{name}} » ? Il sera déplacé vers la poubelle.",
    "deleted": "Remarque supprimée",
    "deleteError": "Impossible de supprimer la note",
    "expandSidebar": "Agrandir la barre latérale",
    "collapseSidebar": "Réduire la barre latérale"
  },
  "aiSummary": {
    "generationInProgress": "La génération du résumé peut prendre un certain temps : vous pouvez fermer cette fenêtre, nous vous avertirons lorsqu'elle sera prête.",
    "closeAndNotify": "Fermez, nous vous informerons"
  },
  "imagePreview": {
    "loadFullQuality": "Charger la qualité complète",
    "loadFullQualityTooltip": "Charger l'image originale en pleine résolution (fichier volumineux)",
    "loadingFullQuality": "Chargement en qualité complète…",
    "openInViewer": "Ouvrir dans la visionneuse"
  },
  "shortcuts": {
    "title": "Raccourcis clavier",
    "then": "alors",
    "searchLabel": "Rechercher des raccourcis clavier",
    "searchPlaceholder": "Rechercher des raccourcis…",
    "listLabel": "Liste des raccourcis clavier",
    "noResults": "Aucun raccourci ne correspond à votre recherche.",
    "categories": {
      "app": "Demande",
      "create": "Créer",
      "file": "Fichiers",
      "navigation": "Navigation",
      "selection": "Sélection",
      "view": "Voir"
    },
    "app": {
      "focusSearch": "Recherche ciblée",
      "openShortcutsHelp": "Ouvrir les raccourcis clavier"
    },
    "create": {
      "openMenu": "Ouvrir le menu Créer",
      "folder": "Nouveau dossier",
      "uploadFile": "Télécharger le fichier",
      "uploadFolder": "Télécharger le dossier",
      "word": "Nouveau document Word",
      "excel": "Nouvelle feuille de calcul Excel",
      "powerpoint": "Nouvelle présentation PowerPoint",
      "note": "Nouvelle remarque",
      "secret": "Nouvelles informations d'identification",
      "secretCard": "Nouvelle carte de paiement",
      "secretIdentity": "Nouvelle identité",
      "secretSshKey": "Nouvelle clé SSH",
      "secretCustom": "Nouveau secret personnalisé"
    },
    "file": {
      "open": "Ouvert",
      "openNewTab": "Ouvrir dans un nouvel onglet",
      "rename": "Renommer",
      "share": "Partager",
      "move": "Déplacer",
      "favorite": "Ajouter aux favoris",
      "delete": "Supprimer",
      "copyLink": "Copier le lien",
      "createShortcut": "Créer un raccourci",
      "details": "Détails",
      "download": "Télécharger",
      "publicLink": "Lien public",
      "setPassword": "Définir le mot de passe",
      "aiSummary": "Résumé de l'IA",
      "tags": "Modifier les étiquettes"
    },
    "view": {
      "toggleGridList": "Basculer entre l'affichage en grille ou en liste"
    },
    "nav": {
      "focusSidebar": "Navigation ciblée",
      "focusMain": "Liste des fichiers de focus",
      "focusDetails": "Panneau de détails du focus",
      "focusUploadDrawer": "Focus sur la progression du téléchargement"
    },
    "selection": {
      "selectAll": "Tout sélectionner",
      "clear": "Effacer la sélection",
      "toggle": "Basculer la sélection",
      "moveFocusUp": "Déplacer la mise au point vers le haut",
      "moveFocusDown": "Déplacer le focus vers le bas",
      "moveFocusLeft": "Déplacer le focus vers la gauche",
      "moveFocusRight": "Déplacer le focus vers la droite",
      "extendUp": "Étendre la sélection vers le haut",
      "extendDown": "Étendre la sélection vers le bas",
      "extendLeft": "Étendre la sélection vers la gauche",
      "extendRight": "Étendre la sélection à droite"
    }
  },
  "chat": {
    "thinking": {
      "working": "Travailler sur votre demande. Cela peut prendre quelques secondes."
    },
    "stream": {
      "tools": {
        "routing": "Demande de classement",
        "rag_search": "Recherche de documents",
        "filename_search": "Recherche par nom de fichier",
        "metadata_search": "Recherche de métadonnées",
        "open_file": "Ouverture du fichier",
        "relevance_assessment": "Évaluation de la pertinence",
        "search_refinement": "Affiner la recherche",
        "activity_log_search": "Recherche du journal d'activité",
        "calculator": "Calcul",
        "chart_generation": "Génération d'un graphique",
        "aggregation": "Agrégation des résultats",
        "answer_generation": "Rédiger la réponse",
        "paused": "En attente dans la file d'attente",
        "unknown": "Travailler"
      },
      "descriptions": {
        "routing": {
          "start": "Déterminer ce dont vous avez besoin…",
          "done": "Demande classée{{intentDetail}}."
        },
        "rag_search": {
          "start": "Parcourir vos documents{{queryDetail}}…",
          "done": "Trouvé des passages correspondants dans votre bibliothèque{{countDetail}}."
        },
        "filename_search": {
          "start": "Parcourir vos fichiers par nom{{patternDetail}}…",
          "done": "Fichiers correspondants par leurs noms{{countDetail}}."
        },
        "metadata_search": {
          "start": "Analyse des étiquettes, des dates et d'autres propriétés…",
          "done": "Fin de la vérification des propriétés du document{{countDetail}}."
        },
        "open_file": {
          "start": "Lecture du document choisi{{filenameDetail}}…",
          "done": "Le contenu du document est prêt à être utilisé{{filenameDetail}}."
        },
        "relevance_assessment": {
          "start": "Peser les résultats qui correspondent le mieux à votre question{{candidateCountDetail}}…",
          "done": "A conservé les matchs les plus forts{{countDetail}}."
        },
        "search_refinement": {
          "start": "Resserrer la requête pour de meilleurs hits{{queryDetail}}…",
          "done": "Mise à jour des critères de recherche."
        },
        "activity_log_search": {
          "start": "Vérifier qui a fait quoi et quand{{queryDetail}}…",
          "done": "Extrait les entrées d'activité correspondantes{{countDetail}}."
        },
        "calculator": {
          "start": "Calculer les chiffres{{expressionDetail}}…",
          "done": "Les chiffres sont prêts{{expressionDetail}}."
        },
        "chart_generation": {
          "start": "Transformer les données en visuel…",
          "done": "Le graphique est prêt à être affiché."
        },
        "aggregation": {
          "start": "Combiner des matchs en un seul set…",
          "done": "Les résultats combinés sont prêts{{countDetail}}."
        },
        "answer_generation": {
          "start": "Préparez votre réponse…",
          "done": "La réponse est prête."
        },
        "paused": {
          "start": "GPU occupé — votre tour est en file d'attente{{reasonDetail}}…",
          "done": "Reprise : poursuite de votre demande."
        },
        "unknown": {
          "start": "Je travaille sur cette étape…",
          "done": "Cette étape est terminée."
        }
      },
      "param": {
        "query": " pour «{{query}}»",
        "pattern": " pour «{{pattern}}»",
        "filename": " «{{filename}}»",
        "expression": " ({{expression}})",
        "count": " ({{count}})",
        "candidateCount": " ({{count}} candidats)",
        "reason": " — {{reason}}",
        "intent": "comme «{{intent}}»"
      },
      "reasons": {
        "gpu_overload": "Surcharge du GPU"
      },
      "toolsUsed": "Outils utilisés ({{count}})"
    },
    "disclaimer": "AIGrant peut faire des erreurs. Vérifiez les informations importantes.",
    "offlineHint": "Temps réel déconnecté. Parcourez les discussions à tout moment ; envoyer une fois de retour en ligne.",
    "offlineDisclaimer": "Hors ligne : vous pouvez envoyer des messages une fois la connexion rétablie.",
    "connectingHint": "Établir une connexion en temps réel. Vous pouvez envoyer une fois prêt.",
    "connectingDisclaimer": "Connexion : vous pouvez envoyer des messages une fois la connexion prête.",
    "placeholder": "Tapez votre message... (Entrée pour envoyer, Maj+Entrée pour une nouvelle ligne)",
    "dictate": "Dicter",
    "stopDictation": "Arrêter la dictée",
    "speechUnsupported": "La reconnaissance vocale n'est pas prise en charge dans ce navigateur",
    "dictationFailed": "Impossible de démarrer la dictée",
    "regenerate": "Régénérer",
    "readAloud": "Lire à haute voix",
    "stopReading": "Arrêter de lire",
    "speechUnavailable": "Synthèse vocale indisponible",
    "requestCancelled": "Demande annulée",
    "genericError": "Une erreur s'est produite lors du traitement de votre demande."
  }
}
